// ============================================================
// airport_countries.js — index compact IATA → ISO pays
// GÉNÉRÉ AUTOMATIQUEMENT À PARTIR DE airports.json. NE PAS MODIFIER À LA MAIN.
// ============================================================
const AIRPORT_COUNTRIES = {
  "AAA": "PF",
  "AAB": "AU",
  "AAC": "EG",
  "AAE": "DZ",
  "AAF": "US",
  "AAG": "BR",
  "AAH": "DE",
  "AAI": "BR",
  "AAJ": "SR",
  "AAK": "KI",
  "AAL": "DK",
  "AAM": "ZA",
  "AAN": "AE",
  "AAO": "VE",
  "AAP": "US",
  "AAQ": "RU",
  "AAR": "DK",
  "AAS": "ID",
  "AAT": "CN",
  "AAU": "WS",
  "AAV": "PH",
  "AAX": "BR",
  "AAY": "YE",
  "AAZ": "GT",
  "ABA": "RU",
  "ABB": "NG",
  "ABC": "ES",
  "ABD": "IR",
  "ABE": "US",
  "ABF": "KI",
  "ABG": "AU",
  "ABH": "AU",
  "ABI": "US",
  "ABJ": "CI",
  "ABK": "ET",
  "ABL": "US",
  "ABM": "AU",
  "ABN": "SR",
  "ABP": "PG",
  "ABQ": "US",
  "ABR": "US",
  "ABS": "EG",
  "ABT": "SA",
  "ABU": "ID",
  "ABV": "NG",
  "ABW": "PG",
  "ABX": "AU",
  "ABY": "US",
  "ABZ": "GB",
  "ACA": "MX",
  "ACB": "US",
  "ACC": "GH",
  "ACD": "CO",
  "ACE": "ES",
  "ACF": "AU",
  "ACH": "CH",
  "ACI": "GG",
  "ACJ": "LK",
  "ACK": "US",
  "ACL": "CO",
  "ACM": "CO",
  "ACN": "MX",
  "ACO": "CH",
  "ACP": "IR",
  "ACR": "CO",
  "ACS": "RU",
  "ACT": "US",
  "ACU": "PA",
  "ACV": "US",
  "ACX": "CN",
  "ACY": "US",
  "ACZ": "IR",
  "ADA": "TR",
  "ADB": "TR",
  "ADC": "PG",
  "ADD": "ET",
  "ADE": "YE",
  "ADF": "TR",
  "ADG": "US",
  "ADH": "RU",
  "ADI": "NA",
  "ADJ": "JO",
  "ADK": "US",
  "ADL": "AU",
  "ADM": "US",
  "ADN": "CO",
  "ADO": "AU",
  "ADP": "LK",
  "ADQ": "US",
  "ADR": "US",
  "ADS": "US",
  "ADT": "US",
  "ADU": "IR",
  "ADV": "GB",
  "ADW": "US",
  "ADX": "GB",
  "ADY": "ZA",
  "ADZ": "CO",
  "AEA": "KI",
  "AEB": "CN",
  "AEE": "SS",
  "AEG": "ID",
  "AEH": "TD",
  "AEI": "ES",
  "AEK": "PG",
  "AEL": "US",
  "AEO": "MR",
  "AEP": "AR",
  "AER": "RU",
  "AES": "NO",
  "AET": "US",
  "AEU": "IR",
  "AEX": "US",
  "AEY": "IS",
  "AFA": "AR",
  "AFD": "ZA",
  "AFF": "US",
  "AFI": "CO",
  "AFK": "LK",
  "AFL": "BR",
  "AFN": "US",
  "AFO": "US",
  "AFR": "PG",
  "AFS": "UZ",
  "AFT": "SB",
  "AFW": "US",
  "AFZ": "IR",
  "AGA": "MA",
  "AGB": "DE",
  "AGC": "US",
  "AGD": "ID",
  "AGE": "DE",
  "AGF": "FR",
  "AGG": "PG",
  "AGH": "SE",
  "AGJ": "JP",
  "AGK": "PG",
  "AGL": "PG",
  "AGM": "GL",
  "AGN": "US",
  "AGO": "US",
  "AGP": "ES",
  "AGR": "IN",
  "AGS": "US",
  "AGT": "PY",
  "AGU": "MX",
  "AGV": "VE",
  "AGW": "AU",
  "AGX": "IN",
  "AGY": "AU",
  "AGZ": "ZA",
  "AHB": "SA",
  "AHC": "US",
  "AHD": "US",
  "AHE": "PF",
  "AHF": "US",
  "AHH": "US",
  "AHI": "ID",
  "AHJ": "CN",
  "AHL": "GY",
  "AHM": "US",
  "AHN": "US",
  "AHO": "IT",
  "AHS": "HN",
  "AHU": "MA",
  "AHY": "MG",
  "AIA": "US",
  "AIC": "MH",
  "AID": "US",
  "AIE": "PG",
  "AIF": "BR",
  "AIG": "CF",
  "AIH": "PG",
  "AII": "DJ",
  "AIK": "US",
  "AIL": "PA",
  "AIM": "MH",
  "AIN": "US",
  "AIO": "US",
  "AIP": "MH",
  "AIR": "BR",
  "AIS": "KI",
  "AIT": "CK",
  "AIU": "CK",
  "AIV": "US",
  "AIW": "NA",
  "AIY": "US",
  "AIZ": "US",
  "AJA": "FR",
  "AJF": "SA",
  "AJI": "TR",
  "AJJ": "MR",
  "AJK": "IR",
  "AJL": "IN",
  "AJN": "KM",
  "AJR": "SE",
  "AJS": "MX",
  "AJU": "BR",
  "AJY": "NE",
  "AKB": "US",
  "AKC": "US",
  "AKD": "IN",
  "AKE": "GA",
  "AKF": "LY",
  "AKG": "PG",
  "AKI": "US",
  "AKJ": "JP",
  "AKK": "US",
  "AKL": "NZ",
  "AKM": "TD",
  "AKN": "US",
  "AKO": "US",
  "AKP": "US",
  "AKQ": "ID",
  "AKR": "NG",
  "AKS": "SB",
  "AKU": "CN",
  "AKV": "CA",
  "AKX": "KZ",
  "AKY": "MM",
  "ALA": "KZ",
  "ALB": "US",
  "ALC": "ES",
  "ALD": "PE",
  "ALE": "US",
  "ALF": "NO",
  "ALG": "DZ",
  "ALH": "AU",
  "ALI": "US",
  "ALJ": "ZA",
  "ALL": "IT",
  "ALM": "US",
  "ALN": "US",
  "ALO": "US",
  "ALP": "SY",
  "ALQ": "BR",
  "ALR": "NZ",
  "ALS": "US",
  "ALT": "BR",
  "ALV": "AD",
  "ALW": "US",
  "ALX": "US",
  "ALY": "EG",
  "ALZ": "US",
  "AMA": "US",
  "AMB": "MG",
  "AMC": "TD",
  "AMD": "IN",
  "AME": "MZ",
  "AMF": "PG",
  "AMH": "ET",
  "AMI": "ID",
  "AMJ": "BR",
  "AMK": "US",
  "AML": "PA",
  "AMM": "JO",
  "AMO": "TD",
  "AMP": "MG",
  "AMQ": "ID",
  "AMS": "NL",
  "AMT": "AU",
  "AMU": "PG",
  "AMV": "RU",
  "AMX": "AU",
  "AMY": "MG",
  "AMZ": "NZ",
  "ANB": "US",
  "ANC": "US",
  "AND": "US",
  "ANE": "FR",
  "ANF": "CL",
  "ANG": "FR",
  "ANH": "SB",
  "ANI": "US",
  "ANJ": "CG",
  "ANL": "AO",
  "ANM": "MG",
  "ANN": "US",
  "ANO": "MZ",
  "ANP": "US",
  "ANQ": "US",
  "ANR": "BE",
  "ANS": "PE",
  "ANU": "AG",
  "ANV": "US",
  "ANW": "US",
  "ANX": "NO",
  "ANY": "US",
  "ANZ": "AU",
  "AOA": "PG",
  "AOB": "PG",
  "AOC": "DE",
  "AOD": "TD",
  "AOG": "CN",
  "AOH": "US",
  "AOI": "IT",
  "AOJ": "JP",
  "AOK": "GR",
  "AOL": "AR",
  "AOM": "OM",
  "AOO": "US",
  "AOP": "PE",
  "AOR": "MY",
  "AOS": "US",
  "AOT": "IT",
  "AOU": "LA",
  "AOY": "IR",
  "APA": "US",
  "APB": "BO",
  "APC": "US",
  "APE": "PE",
  "APF": "US",
  "APG": "US",
  "APH": "US",
  "APK": "PF",
  "APL": "MZ",
  "APN": "US",
  "APO": "CO",
  "APP": "PG",
  "APR": "PG",
  "APS": "BR",
  "APT": "US",
  "APU": "BR",
  "APV": "US",
  "APW": "WS",
  "APX": "BR",
  "APZ": "AR",
  "AQA": "BR",
  "AQB": "GT",
  "AQG": "CN",
  "AQI": "SA",
  "AQJ": "JO",
  "AQM": "BR",
  "AQP": "PE",
  "AQS": "FJ",
  "AQY": "US",
  "ARA": "US",
  "ARB": "US",
  "ARC": "US",
  "ARD": "ID",
  "ARE": "PR",
  "ARF": "CO",
  "ARG": "US",
  "ARH": "RU",
  "ARI": "CL",
  "ARJ": "ID",
  "ARK": "TZ",
  "ARL": "BF",
  "ARM": "AU",
  "ARN": "SE",
  "ARO": "CO",
  "ARP": "PG",
  "ARQ": "CO",
  "ARR": "AR",
  "ARS": "BR",
  "ART": "US",
  "ARU": "BR",
  "ARV": "US",
  "ARW": "RO",
  "ARX": "US",
  "ARY": "AU",
  "ARZ": "AO",
  "ASA": "ER",
  "ASB": "TM",
  "ASC": "BO",
  "ASD": "BS",
  "ASE": "US",
  "ASF": "RU",
  "ASG": "NZ",
  "ASH": "US",
  "ASI": "SH",
  "ASJ": "JP",
  "ASK": "CI",
  "ASL": "US",
  "ASM": "ER",
  "ASN": "US",
  "ASO": "ET",
  "ASP": "AU",
  "ASQ": "US",
  "ASR": "TR",
  "AST": "US",
  "ASU": "PY",
  "ASV": "KE",
  "ASW": "EG",
  "ASX": "US",
  "ASY": "US",
  "ASZ": "PG",
  "ATA": "PE",
  "ATB": "SD",
  "ATC": "BS",
  "ATD": "SB",
  "ATE": "US",
  "ATF": "EC",
  "ATG": "PE",
  "ATH": "GR",
  "ATJ": "MG",
  "ATK": "US",
  "ATL": "US",
  "ATM": "BR",
  "ATN": "PG",
  "ATO": "US",
  "ATP": "PG",
  "ATQ": "IN",
  "ATR": "MR",
  "ATS": "US",
  "ATT": "US",
  "ATU": "US",
  "ATV": "TD",
  "ATW": "US",
  "ATX": "KZ",
  "ATZ": "EG",
  "AUA": "AW",
  "AUC": "CO",
  "AUD": "AU",
  "AUF": "FR",
  "AUG": "US",
  "AUH": "AE",
  "AUI": "PG",
  "AUJ": "PG",
  "AUK": "US",
  "AUL": "MH",
  "AUM": "US",
  "AUN": "US",
  "AUO": "US",
  "AUP": "PG",
  "AUQ": "PF",
  "AUR": "FR",
  "AUS": "US",
  "AUT": "TL",
  "AUU": "AU",
  "AUW": "US",
  "AUX": "BR",
  "AUY": "VU",
  "AUZ": "US",
  "AVA": "CN",
  "AVG": "AU",
  "AVI": "CU",
  "AVK": "MN",
  "AVL": "US",
  "AVN": "FR",
  "AVO": "US",
  "AVP": "US",
  "AVU": "SB",
  "AVV": "AU",
  "AVW": "US",
  "AVX": "US",
  "AWA": "ET",
  "AWD": "VU",
  "AWE": "GA",
  "AWK": "UM",
  "AWM": "US",
  "AWN": "AU",
  "AWP": "AU",
  "AWR": "PG",
  "AWZ": "IR",
  "AXA": "AI",
  "AXB": "US",
  "AXC": "AU",
  "AXD": "GR",
  "AXE": "BR",
  "AXG": "US",
  "AXK": "YE",
  "AXL": "AU",
  "AXM": "CO",
  "AXN": "US",
  "AXP": "BS",
  "AXR": "PF",
  "AXS": "US",
  "AXT": "JP",
  "AXU": "ET",
  "AXV": "US",
  "AXX": "US",
  "AYA": "CO",
  "AYC": "CO",
  "AYD": "AU",
  "AYG": "CO",
  "AYH": "GB",
  "AYI": "CO",
  "AYK": "KZ",
  "AYL": "AU",
  "AYN": "CN",
  "AYO": "PY",
  "AYP": "PE",
  "AYQ": "AU",
  "AYR": "AU",
  "AYS": "US",
  "AYT": "TR",
  "AYU": "PG",
  "AYW": "ID",
  "AYY": "LK",
  "AYZ": "US",
  "AZA": "US",
  "AZB": "PG",
  "AZD": "IR",
  "AZG": "MX",
  "AZI": "AE",
  "AZL": "BR",
  "AZN": "UZ",
  "AZO": "US",
  "AZP": "MX",
  "AZR": "DZ",
  "AZS": "DO",
  "AZT": "CO",
  "AZZ": "AO",
  "BAA": "PG",
  "BAB": "US",
  "BAC": "CO",
  "BAD": "US",
  "BAE": "FR",
  "BAG": "PH",
  "BAH": "BH",
  "BAI": "CR",
  "BAJ": "PG",
  "BAL": "TR",
  "BAM": "US",
  "BAN": "CD",
  "BAO": "TH",
  "BAP": "PG",
  "BAQ": "CO",
  "BAR": "UM",
  "BAS": "SB",
  "BAT": "BR",
  "BAU": "BR",
  "BAV": "CN",
  "BAX": "RU",
  "BAY": "RO",
  "BAZ": "BR",
  "BBA": "CL",
  "BBB": "US",
  "BBC": "US",
  "BBD": "US",
  "BBE": "AU",
  "BBG": "KI",
  "BBH": "DE",
  "BBI": "IN",
  "BBJ": "DE",
  "BBK": "BW",
  "BBM": "KH",
  "BBN": "MY",
  "BBO": "SO",
  "BBP": "GB",
  "BBQ": "AG",
  "BBR": "GP",
  "BBS": "GB",
  "BBT": "CF",
  "BBV": "CI",
  "BBW": "US",
  "BBX": "US",
  "BBY": "CF",
  "BBZ": "ZM",
  "BCA": "CU",
  "BCB": "US",
  "BCC": "US",
  "BCD": "PH",
  "BCE": "US",
  "BCF": "CF",
  "BCG": "GY",
  "BCH": "TL",
  "BCI": "AU",
  "BCJ": "US",
  "BCK": "AU",
  "BCL": "CR",
  "BCM": "RO",
  "BCN": "ES",
  "BCO": "ET",
  "BCP": "PG",
  "BCR": "BR",
  "BCS": "US",
  "BCT": "US",
  "BCU": "NG",
  "BCV": "BZ",
  "BCW": "MZ",
  "BCX": "RU",
  "BCZ": "AU",
  "BDA": "BM",
  "BDB": "AU",
  "BDC": "BR",
  "BDD": "AU",
  "BDE": "US",
  "BDF": "US",
  "BDG": "US",
  "BDH": "IR",
  "BDJ": "ID",
  "BDK": "CI",
  "BDL": "US",
  "BDN": "PK",
  "BDO": "ID",
  "BDP": "NP",
  "BDQ": "IN",
  "BDR": "US",
  "BDS": "IT",
  "BDT": "CD",
  "BDU": "NO",
  "BDV": "CD",
  "BDW": "AU",
  "BDX": "US",
  "BDY": "US",
  "BDZ": "PG",
  "BEA": "PG",
  "BEB": "GB",
  "BEC": "US",
  "BED": "US",
  "BEE": "AU",
  "BEG": "RS",
  "BEH": "US",
  "BEI": "ET",
  "BEJ": "ID",
  "BEK": "IN",
  "BEL": "BR",
  "BEM": "CF",
  "BEN": "LY",
  "BEP": "IN",
  "BEQ": "GB",
  "BER": "DE",
  "BES": "FR",
  "BET": "US",
  "BEU": "AU",
  "BEW": "MZ",
  "BEX": "GB",
  "BEY": "LB",
  "BEZ": "KI",
  "BFA": "PY",
  "BFC": "AU",
  "BFD": "US",
  "BFE": "DE",
  "BFF": "US",
  "BFG": "US",
  "BFH": "BR",
  "BFI": "US",
  "BFJ": "CN",
  "BFK": "US",
  "BFL": "US",
  "BFM": "US",
  "BFN": "ZA",
  "BFO": "ZW",
  "BFP": "US",
  "BFQ": "PA",
  "BFR": "US",
  "BFS": "GB",
  "BFT": "US",
  "BFU": "CN",
  "BFV": "TH",
  "BFW": "DZ",
  "BFX": "CM",
  "BGA": "CO",
  "BGD": "US",
  "BGE": "US",
  "BGF": "CF",
  "BGG": "CI",
  "BGH": "MR",
  "BGI": "BB",
  "BGJ": "IS",
  "BGK": "BZ",
  "BGL": "NP",
  "BGM": "US",
  "BGN": "RU",
  "BGO": "NO",
  "BGP": "GA",
  "BGQ": "US",
  "BGR": "US",
  "BGT": "US",
  "BGU": "CF",
  "BGV": "BR",
  "BGW": "IQ",
  "BGY": "IT",
  "BGZ": "PT",
  "BHA": "EC",
  "BHB": "US",
  "BHC": "PK",
  "BHD": "GB",
  "BHE": "NZ",
  "BHF": "CO",
  "BHG": "HN",
  "BHH": "SA",
  "BHI": "AR",
  "BHJ": "IN",
  "BHK": "UZ",
  "BHL": "MX",
  "BHM": "US",
  "BHN": "YE",
  "BHO": "IN",
  "BHP": "NP",
  "BHQ": "AU",
  "BHR": "NP",
  "BHS": "AU",
  "BHT": "AU",
  "BHU": "IN",
  "BHV": "PK",
  "BHW": "PK",
  "BHX": "GB",
  "BHY": "CN",
  "BIA": "FR",
  "BIB": "SO",
  "BID": "US",
  "BIE": "US",
  "BIF": "US",
  "BIG": "US",
  "BIH": "US",
  "BII": "MH",
  "BIJ": "PG",
  "BIK": "ID",
  "BIL": "US",
  "BIM": "BS",
  "BIN": "AF",
  "BIO": "ES",
  "BIP": "AU",
  "BIQ": "FR",
  "BIR": "NP",
  "BIS": "US",
  "BIT": "NP",
  "BIU": "IS",
  "BIV": "CF",
  "BIW": "AU",
  "BIX": "US",
  "BIY": "ZA",
  "BIZ": "PG",
  "BJA": "DZ",
  "BJB": "IR",
  "BJC": "US",
  "BJD": "IS",
  "BJE": "SD",
  "BJF": "NO",
  "BJG": "ID",
  "BJH": "NP",
  "BJI": "US",
  "BJJ": "US",
  "BJL": "GM",
  "BJM": "BI",
  "BJO": "BO",
  "BJP": "BR",
  "BJQ": "OM",
  "BJR": "ET",
  "BJT": "LK",
  "BJU": "NP",
  "BJV": "TR",
  "BJW": "ID",
  "BJX": "MX",
  "BJY": "RS",
  "BJZ": "ES",
  "BKA": "RU",
  "BKB": "IN",
  "BKC": "US",
  "BKD": "US",
  "BKE": "US",
  "BKF": "US",
  "BKG": "US",
  "BKH": "US",
  "BKI": "MY",
  "BKK": "TH",
  "BKL": "US",
  "BKM": "MY",
  "BKN": "NE",
  "BKO": "ML",
  "BKP": "AU",
  "BKQ": "AU",
  "BKR": "TD",
  "BKS": "ID",
  "BKT": "US",
  "BKU": "MG",
  "BKW": "US",
  "BKX": "US",
  "BKY": "CD",
  "BKZ": "TZ",
  "BLA": "VE",
  "BLB": "PA",
  "BLC": "CM",
  "BLD": "US",
  "BLE": "SE",
  "BLF": "US",
  "BLG": "MY",
  "BLH": "US",
  "BLI": "US",
  "BLJ": "DZ",
  "BLK": "GB",
  "BLL": "DK",
  "BLN": "AU",
  "BLO": "IS",
  "BLP": "PE",
  "BLQ": "IT",
  "BLR": "IN",
  "BLS": "AU",
  "BLT": "AU",
  "BLU": "US",
  "BLV": "US",
  "BLW": "US",
  "BLX": "IT",
  "BLY": "IE",
  "BLZ": "MW",
  "BMA": "SE",
  "BMB": "CD",
  "BMC": "US",
  "BMD": "MG",
  "BME": "AU",
  "BMF": "CF",
  "BMG": "US",
  "BMH": "PG",
  "BMI": "US",
  "BMJ": "GY",
  "BMK": "DE",
  "BML": "US",
  "BMM": "GA",
  "BMN": "IQ",
  "BMO": "MM",
  "BMP": "AU",
  "BMQ": "KE",
  "BMR": "DE",
  "BMS": "BR",
  "BMT": "US",
  "BMU": "ID",
  "BMV": "VN",
  "BMW": "DZ",
  "BMX": "US",
  "BMY": "NC",
  "BMZ": "PG",
  "BNA": "US",
  "BNB": "CD",
  "BNC": "CD",
  "BND": "IR",
  "BNE": "AU",
  "BNF": "US",
  "BNG": "US",
  "BNI": "NG",
  "BNJ": "DE",
  "BNK": "AU",
  "BNL": "US",
  "BNM": "PG",
  "BNN": "NO",
  "BNO": "US",
  "BNP": "PK",
  "BNQ": "PH",
  "BNR": "BF",
  "BNS": "VE",
  "BNT": "PG",
  "BNU": "BR",
  "BNV": "PG",
  "BNW": "US",
  "BNX": "BA",
  "BNY": "SB",
  "BNZ": "PG",
  "BOA": "CD",
  "BOB": "PF",
  "BOC": "PA",
  "BOD": "FR",
  "BOE": "CG",
  "BOF": "US",
  "BOG": "CO",
  "BOH": "GB",
  "BOI": "US",
  "BOJ": "BG",
  "BOK": "US",
  "BOL": "GB",
  "BOM": "IN",
  "BON": "BQ",
  "BOO": "NO",
  "BOP": "CF",
  "BOQ": "PG",
  "BOR": "FR",
  "BOS": "US",
  "BOT": "PG",
  "BOU": "FR",
  "BOV": "PG",
  "BOW": "US",
  "BOX": "AU",
  "BOY": "BF",
  "BOZ": "CF",
  "BPA": "US",
  "BPC": "CM",
  "BPD": "PG",
  "BPE": "MM",
  "BPF": "SB",
  "BPG": "BR",
  "BPH": "PH",
  "BPI": "US",
  "BPK": "PG",
  "BPL": "CN",
  "BPM": "IN",
  "BPN": "ID",
  "BPS": "BR",
  "BPT": "US",
  "BPX": "CN",
  "BPY": "MG",
  "BQA": "PH",
  "BQB": "AU",
  "BQD": "IS",
  "BQE": "GW",
  "BQG": "RU",
  "BQH": "GB",
  "BQI": "NA",
  "BQK": "US",
  "BQL": "AU",
  "BQN": "PR",
  "BQO": "CI",
  "BQQ": "BR",
  "BQS": "RU",
  "BQT": "BY",
  "BQV": "US",
  "BQW": "AU",
  "BR-": "BR",
  "BRA": "BR",
  "BRB": "BR",
  "BRC": "AR",
  "BRD": "US",
  "BRE": "DE",
  "BRG": "US",
  "BRI": "IT",
  "BRK": "AU",
  "BRL": "US",
  "BRM": "VE",
  "BRN": "CH",
  "BRO": "US",
  "BRP": "PG",
  "BRQ": "CZ",
  "BRR": "GB",
  "BRS": "GB",
  "BRT": "AU",
  "BRU": "BE",
  "BRV": "DE",
  "BRW": "US",
  "BRX": "DO",
  "BRY": "US",
  "BSA": "SO",
  "BSB": "BR",
  "BSC": "CO",
  "BSD": "CN",
  "BSE": "MY",
  "BSF": "US",
  "BSG": "GQ",
  "BSI": "US",
  "BSJ": "AU",
  "BSK": "DZ",
  "BSL": "FR",
  "BSM": "IR",
  "BSN": "CF",
  "BSO": "PH",
  "BSP": "PG",
  "BSQ": "US",
  "BSR": "IQ",
  "BSS": "BR",
  "BST": "AF",
  "BSU": "CD",
  "BSV": "MG",
  "BSW": "US",
  "BSX": "MM",
  "BSY": "SO",
  "BSZ": "US",
  "BTA": "CM",
  "BTB": "CG",
  "BTC": "LK",
  "BTD": "AU",
  "BTE": "SL",
  "BTF": "US",
  "BTG": "CF",
  "BTH": "ID",
  "BTI": "US",
  "BTJ": "ID",
  "BTK": "RU",
  "BTL": "US",
  "BTM": "US",
  "BTN": "US",
  "BTO": "SR",
  "BTP": "US",
  "BTQ": "RW",
  "BTR": "US",
  "BTS": "SK",
  "BTT": "US",
  "BTU": "MY",
  "BTV": "US",
  "BTW": "ID",
  "BTX": "AU",
  "BTY": "US",
  "BTZ": "TR",
  "BUA": "PG",
  "BUB": "US",
  "BUC": "AU",
  "BUD": "HU",
  "BUF": "US",
  "BUG": "AO",
  "BUI": "ID",
  "BUJ": "DZ",
  "BUK": "YE",
  "BUL": "PG",
  "BUM": "US",
  "BUN": "CO",
  "BUO": "SO",
  "BUP": "IN",
  "BUQ": "ZW",
  "BUR": "US",
  "BUS": "GE",
  "BUT": "GB",
  "BUV": "UY",
  "BUW": "ID",
  "BUX": "CD",
  "BUY": "AU",
  "BUZ": "IR",
  "BVA": "FR",
  "BVB": "BR",
  "BVC": "CV",
  "BVE": "FR",
  "BVF": "FJ",
  "BVG": "NO",
  "BVH": "BR",
  "BVI": "AU",
  "BVK": "BO",
  "BVL": "BO",
  "BVM": "BR",
  "BVO": "US",
  "BVP": "PG",
  "BVR": "CV",
  "BVS": "BR",
  "BVU": "US",
  "BVV": "RU",
  "BVW": "AU",
  "BVX": "US",
  "BVY": "US",
  "BVZ": "AU",
  "BWA": "NP",
  "BWB": "AU",
  "BWC": "US",
  "BWD": "US",
  "BWE": "DE",
  "BWF": "GB",
  "BWG": "US",
  "BWH": "MY",
  "BWI": "US",
  "BWJ": "PG",
  "BWK": "HR",
  "BWL": "US",
  "BWM": "US",
  "BWN": "BN",
  "BWO": "RU",
  "BWP": "PG",
  "BWQ": "AU",
  "BWT": "AU",
  "BWU": "AU",
  "BWW": "CU",
  "BWY": "GB",
  "BXA": "US",
  "BXB": "ID",
  "BXD": "ID",
  "BXE": "SN",
  "BXG": "AU",
  "BXH": "KZ",
  "BXI": "CI",
  "BXJ": "KZ",
  "BXK": "US",
  "BXL": "FJ",
  "BXM": "ID",
  "BXO": "CH",
  "BXP": "PL",
  "BXR": "IR",
  "BXS": "US",
  "BXT": "ID",
  "BXU": "PH",
  "BXV": "IS",
  "BXZ": "PG",
  "BYA": "US",
  "BYB": "OM",
  "BYC": "BO",
  "BYD": "YE",
  "BYF": "FR",
  "BYH": "US",
  "BYK": "CI",
  "BYL": "LR",
  "BYM": "CU",
  "BYN": "MN",
  "BYO": "BR",
  "BYP": "AU",
  "BYQ": "ID",
  "BYR": "DK",
  "BYS": "US",
  "BYT": "IE",
  "BYU": "DE",
  "BYV": "LK",
  "BYW": "US",
  "BZA": "NI",
  "BZB": "MZ",
  "BZC": "BR",
  "BZD": "AU",
  "BZE": "BZ",
  "BZF": "US",
  "BZG": "PL",
  "BZH": "ZW",
  "BZK": "RU",
  "BZL": "BD",
  "BZM": "MG",
  "BZN": "US",
  "BZO": "IT",
  "BZP": "AU",
  "BZR": "FR",
  "BZS": "US",
  "BZT": "US",
  "BZU": "CD",
  "BZV": "CG",
  "BZY": "MD",
  "BZZ": "GB",
  "CAA": "HN",
  "CAB": "AO",
  "CAC": "BR",
  "CAD": "US",
  "CAE": "US",
  "CAF": "BR",
  "CAG": "IT",
  "CAH": "VN",
  "CAI": "EG",
  "CAJ": "VE",
  "CAK": "US",
  "CAL": "GB",
  "CAM": "BO",
  "CAN": "CN",
  "CAO": "US",
  "CAP": "HT",
  "CAQ": "CO",
  "CAS": "MA",
  "CAU": "BR",
  "CAV": "AO",
  "CAW": "BR",
  "CAX": "GB",
  "CAY": "GF",
  "CAZ": "AU",
  "CBB": "BO",
  "CBC": "AU",
  "CBD": "IN",
  "CBE": "US",
  "CBF": "US",
  "CBG": "GB",
  "CBH": "DZ",
  "CBI": "AU",
  "CBJ": "DO",
  "CBK": "US",
  "CBL": "VE",
  "CBM": "US",
  "CBN": "ID",
  "CBO": "PH",
  "CBQ": "NG",
  "CBR": "AU",
  "CBS": "VE",
  "CBT": "AO",
  "CBU": "DE",
  "CBV": "GT",
  "CBW": "BR",
  "CBX": "AU",
  "CBY": "AU",
  "CCB": "US",
  "CCC": "CU",
  "CCD": "US",
  "CCF": "FR",
  "CCG": "US",
  "CCH": "CL",
  "CCI": "BR",
  "CCJ": "IN",
  "CCK": "CC",
  "CCL": "AU",
  "CCM": "BR",
  "CCN": "AF",
  "CCO": "CO",
  "CCP": "CL",
  "CCR": "US",
  "CCS": "VE",
  "CCT": "AR",
  "CCU": "IN",
  "CCV": "VU",
  "CCW": "AU",
  "CCY": "US",
  "CCZ": "BS",
  "CDA": "AU",
  "CDB": "US",
  "CDC": "US",
  "CDD": "HN",
  "CDF": "IT",
  "CDG": "FR",
  "CDH": "US",
  "CDI": "BR",
  "CDJ": "BR",
  "CDK": "US",
  "CDL": "US",
  "CDN": "US",
  "CDP": "IN",
  "CDQ": "AU",
  "CDR": "US",
  "CDS": "US",
  "CDT": "ES",
  "CDU": "AU",
  "CDV": "US",
  "CDW": "US",
  "CDY": "PH",
  "CEA": "US",
  "CEB": "PH",
  "CEC": "US",
  "CED": "AU",
  "CEE": "RU",
  "CEF": "US",
  "CEG": "GB",
  "CEH": "MW",
  "CEI": "TH",
  "CEJ": "UA",
  "CEK": "RU",
  "CEL": "BS",
  "CEM": "US",
  "CEN": "MX",
  "CEP": "BO",
  "CEQ": "FR",
  "CER": "FR",
  "CES": "AU",
  "CET": "FR",
  "CEU": "US",
  "CEV": "US",
  "CEW": "US",
  "CEX": "US",
  "CEY": "US",
  "CEZ": "US",
  "CFB": "BR",
  "CFC": "BR",
  "CFD": "US",
  "CFE": "FR",
  "CFF": "AO",
  "CFG": "CU",
  "CFH": "AU",
  "CFI": "AU",
  "CFN": "IE",
  "CFO": "BR",
  "CFP": "AU",
  "CFQ": "CA",
  "CFR": "FR",
  "CFS": "AU",
  "CFT": "US",
  "CFU": "GR",
  "CGA": "US",
  "CGB": "BR",
  "CGC": "PG",
  "CGD": "CN",
  "CGE": "US",
  "CGF": "US",
  "CGG": "PH",
  "CGH": "BR",
  "CGI": "US",
  "CGK": "ID",
  "CGM": "PH",
  "CGN": "DE",
  "CGO": "CN",
  "CGP": "BD",
  "CGQ": "CN",
  "CGR": "BR",
  "CGS": "US",
  "CGT": "MR",
  "CGV": "AU",
  "CGX": "US",
  "CGY": "PH",
  "CHA": "US",
  "CHB": "PK",
  "CHC": "NZ",
  "CHE": "IE",
  "CHF": "KR",
  "CHG": "CN",
  "CHJ": "ZW",
  "CHL": "US",
  "CHO": "US",
  "CHP": "US",
  "CHQ": "GR",
  "CHR": "FR",
  "CHS": "US",
  "CHT": "NZ",
  "CHU": "US",
  "CHV": "PT",
  "CHX": "PA",
  "CHY": "SB",
  "CHZ": "US",
  "CIA": "IT",
  "CIC": "US",
  "CID": "US",
  "CIE": "AU",
  "CIF": "CN",
  "CIG": "US",
  "CIH": "CN",
  "CII": "TR",
  "CIJ": "BO",
  "CIK": "US",
  "CIL": "US",
  "CIM": "CO",
  "CIN": "US",
  "CIO": "PY",
  "CIP": "ZM",
  "CIQ": "GT",
  "CIR": "US",
  "CIT": "KZ",
  "CIU": "US",
  "CIV": "US",
  "CIW": "VC",
  "CIX": "PE",
  "CIY": "IT",
  "CJA": "PE",
  "CJB": "IN",
  "CJC": "CL",
  "CJF": "AU",
  "CJH": "CA",
  "CJJ": "KR",
  "CJL": "PK",
  "CJM": "TH",
  "CJS": "MX",
  "CJT": "MX",
  "CJU": "KR",
  "CKA": "US",
  "CKB": "US",
  "CKC": "UA",
  "CKD": "US",
  "CKE": "US",
  "CKG": "CN",
  "CKH": "RU",
  "CKI": "AU",
  "CKK": "US",
  "CKL": "RU",
  "CKM": "US",
  "CKO": "BR",
  "CKR": "US",
  "CKS": "BR",
  "CKT": "IR",
  "CKU": "US",
  "CKV": "US",
  "CKX": "US",
  "CKY": "GN",
  "CKZ": "TR",
  "CLA": "BD",
  "CLB": "IE",
  "CLC": "US",
  "CLD": "US",
  "CLE": "US",
  "CLG": "US",
  "CLH": "AU",
  "CLI": "US",
  "CLJ": "RO",
  "CLL": "US",
  "CLM": "US",
  "CLN": "BR",
  "CLO": "CO",
  "CLP": "US",
  "CLQ": "MX",
  "CLR": "US",
  "CLS": "US",
  "CLT": "US",
  "CLU": "US",
  "CLV": "BR",
  "CLW": "US",
  "CLX": "AR",
  "CLY": "FR",
  "CLZ": "VE",
  "CMA": "AU",
  "CMB": "LK",
  "CMC": "BR",
  "CMD": "AU",
  "CME": "MX",
  "CMF": "FR",
  "CMG": "BR",
  "CMH": "US",
  "CMI": "US",
  "CMJ": "TW",
  "CMK": "MW",
  "CML": "AU",
  "CMM": "GT",
  "CMN": "MA",
  "CMO": "SO",
  "CMP": "BR",
  "CMQ": "AU",
  "CMR": "FR",
  "CMS": "SO",
  "CMT": "BR",
  "CMU": "PG",
  "CMV": "NZ",
  "CMW": "CU",
  "CMX": "US",
  "CMY": "US",
  "CMZ": "MZ",
  "CNA": "MX",
  "CNB": "AU",
  "CNC": "AU",
  "CND": "RO",
  "CNE": "US",
  "CNF": "BR",
  "CNG": "FR",
  "CNI": "CN",
  "CNJ": "AU",
  "CNK": "US",
  "CNL": "DK",
  "CNM": "US",
  "CNN": "RU",
  "CNO": "US",
  "CNP": "GL",
  "CNQ": "AR",
  "CNR": "CL",
  "CNS": "AU",
  "CNT": "AR",
  "CNU": "US",
  "CNW": "US",
  "CNX": "TH",
  "CNY": "US",
  "CNZ": "AO",
  "COA": "US",
  "COB": "AU",
  "COC": "AR",
  "COD": "US",
  "COF": "US",
  "COG": "CO",
  "COH": "IN",
  "COI": "US",
  "COJ": "AU",
  "COK": "IN",
  "COL": "GB",
  "COM": "US",
  "CON": "US",
  "COO": "BJ",
  "COP": "US",
  "COQ": "MN",
  "COR": "AR",
  "COS": "US",
  "COT": "US",
  "COU": "US",
  "COW": "CL",
  "COX": "BS",
  "COY": "AU",
  "CPB": "CO",
  "CPC": "AR",
  "CPD": "AU",
  "CPE": "MX",
  "CPG": "AR",
  "CPH": "DK",
  "CPI": "PG",
  "CPL": "CO",
  "CPM": "US",
  "CPN": "PG",
  "CPO": "CL",
  "CPQ": "BR",
  "CPR": "US",
  "CPS": "US",
  "CPT": "ZA",
  "CPU": "BR",
  "CPV": "BR",
  "CPX": "PR",
  "CQA": "BR",
  "CQD": "IR",
  "CQF": "FR",
  "CQM": "ES",
  "CQP": "AU",
  "CQS": "BR",
  "CQT": "CO",
  "CRA": "RO",
  "CRB": "AU",
  "CRC": "CO",
  "CRD": "AR",
  "CRE": "US",
  "CRF": "CF",
  "CRG": "US",
  "CRH": "AU",
  "CRI": "BS",
  "CRK": "PH",
  "CRL": "BE",
  "CRM": "PH",
  "CRO": "US",
  "CRP": "US",
  "CRQ": "BR",
  "CRR": "AR",
  "CRS": "US",
  "CRU": "GD",
  "CRV": "IT",
  "CRW": "US",
  "CRX": "US",
  "CRY": "AU",
  "CSA": "GB",
  "CSD": "AU",
  "CSE": "US",
  "CSF": "FR",
  "CSG": "US",
  "CSH": "RU",
  "CSI": "AU",
  "CSK": "SN",
  "CSM": "US",
  "CSN": "US",
  "CSO": "DE",
  "CSR": "CO",
  "CSS": "BR",
  "CST": "FJ",
  "CSU": "BR",
  "CSV": "US",
  "CSX": "CN",
  "CSY": "RU",
  "CSZ": "AR",
  "CTA": "IT",
  "CTB": "US",
  "CTC": "AR",
  "CTD": "PA",
  "CTE": "PA",
  "CTG": "CO",
  "CTH": "US",
  "CTI": "AO",
  "CTL": "AU",
  "CTM": "MX",
  "CTN": "AU",
  "CTO": "US",
  "CTP": "BR",
  "CTQ": "BR",
  "CTR": "AU",
  "CTS": "JP",
  "CTT": "FR",
  "CTU": "CN",
  "CTX": "US",
  "CTY": "US",
  "CTZ": "US",
  "CUA": "MX",
  "CUB": "US",
  "CUC": "CO",
  "CUD": "AU",
  "CUE": "EC",
  "CUF": "IT",
  "CUG": "AU",
  "CUI": "CO",
  "CUJ": "PH",
  "CUK": "BZ",
  "CUL": "MX",
  "CUM": "VE",
  "CUN": "MX",
  "CUO": "CO",
  "CUP": "VE",
  "CUR": "CW",
  "CUT": "AR",
  "CUU": "MX",
  "CUV": "VE",
  "CUY": "AU",
  "CUZ": "PE",
  "CVB": "PG",
  "CVC": "AU",
  "CVE": "CO",
  "CVF": "FR",
  "CVG": "US",
  "CVH": "AR",
  "CVJ": "MX",
  "CVL": "PG",
  "CVM": "MX",
  "CVN": "US",
  "CVO": "US",
  "CVQ": "AU",
  "CVR": "US",
  "CVS": "US",
  "CVT": "GB",
  "CVU": "PT",
  "CWA": "US",
  "CWB": "BR",
  "CWC": "UA",
  "CWE": "EG",
  "CWF": "US",
  "CWI": "US",
  "CWL": "GB",
  "CWP": "PK",
  "CWR": "AU",
  "CWS": "US",
  "CWT": "AU",
  "CWW": "AU",
  "CWX": "US",
  "CXA": "VE",
  "CXB": "BD",
  "CXC": "US",
  "CXF": "US",
  "CXH": "CA",
  "CXI": "KI",
  "CXJ": "BR",
  "CXL": "US",
  "CXM": "AO",
  "CXN": "SO",
  "CXO": "US",
  "CXP": "ID",
  "CXQ": "AU",
  "CXR": "VN",
  "CXT": "AU",
  "CXY": "BS",
  "CYA": "HT",
  "CYB": "KY",
  "CYC": "BZ",
  "CYF": "US",
  "CYG": "AU",
  "CYI": "TW",
  "CYL": "HN",
  "CYM": "US",
  "CYO": "CU",
  "CYP": "PH",
  "CYR": "UY",
  "CYS": "US",
  "CYT": "US",
  "CYU": "PH",
  "CYW": "MX",
  "CYX": "RU",
  "CYZ": "PH",
  "CZA": "MX",
  "CZB": "BR",
  "CZC": "US",
  "CZE": "VE",
  "CZH": "BZ",
  "CZJ": "PA",
  "CZK": "US",
  "CZL": "DZ",
  "CZM": "MX",
  "CZN": "US",
  "CZO": "US",
  "CZP": "US",
  "CZS": "BR",
  "CZT": "US",
  "CZU": "CO",
  "CZX": "CN",
  "CZY": "AU",
  "DAA": "US",
  "DAB": "US",
  "DAC": "BD",
  "DAD": "VN",
  "DAE": "IN",
  "DAF": "PG",
  "DAG": "US",
  "DAK": "EG",
  "DAL": "US",
  "DAM": "SY",
  "DAN": "US",
  "DAO": "PG",
  "DAP": "NP",
  "DAR": "TZ",
  "DAS": "CA",
  "DAT": "CN",
  "DAU": "PG",
  "DAV": "PA",
  "DAX": "CN",
  "DAY": "US",
  "DAZ": "AF",
  "DBA": "PK",
  "DBB": "EG",
  "DBD": "IN",
  "DBM": "ET",
  "DBN": "US",
  "DBO": "AU",
  "DBP": "PG",
  "DBQ": "US",
  "DBS": "US",
  "DBT": "ET",
  "DBU": "LK",
  "DBV": "HR",
  "DBY": "AU",
  "DCA": "US",
  "DCF": "DM",
  "DCG": "AE",
  "DCK": "US",
  "DCM": "FR",
  "DCN": "AU",
  "DCR": "US",
  "DCT": "BS",
  "DCU": "US",
  "DDC": "US",
  "DDG": "CN",
  "DDM": "PG",
  "DDN": "AU",
  "DDP": "PR",
  "DDU": "PK",
  "DEA": "PK",
  "DEB": "HU",
  "DEC": "US",
  "DED": "IN",
  "DEE": "RU",
  "DEF": "IR",
  "DEH": "US",
  "DEI": "SC",
  "DEL": "IN",
  "DEM": "ET",
  "DEN": "US",
  "DEP": "IN",
  "DER": "PG",
  "DES": "SC",
  "DET": "US",
  "DEZ": "SY",
  "DFI": "US",
  "DFP": "AU",
  "DFW": "US",
  "DGA": "BZ",
  "DGC": "ET",
  "DGD": "AU",
  "DGE": "AU",
  "DGF": "CA",
  "DGG": "PG",
  "DGL": "US",
  "DGM": "CN",
  "DGN": "US",
  "DGO": "MX",
  "DGP": "LV",
  "DGR": "NZ",
  "DGT": "PH",
  "DGU": "BF",
  "DGW": "US",
  "DHA": "SA",
  "DHB": "US",
  "DHD": "AU",
  "DHF": "AE",
  "DHI": "NP",
  "DHM": "IN",
  "DHN": "US",
  "DHR": "NL",
  "DHT": "US",
  "DIB": "IN",
  "DIE": "MG",
  "DIG": "CN",
  "DIJ": "FR",
  "DIK": "US",
  "DIL": "TL",
  "DIM": "CI",
  "DIN": "VN",
  "DIP": "BF",
  "DIQ": "BR",
  "DIR": "ET",
  "DIS": "CG",
  "DIU": "IN",
  "DIY": "TR",
  "DJA": "BJ",
  "DJB": "ID",
  "DJE": "TN",
  "DJG": "DZ",
  "DJJ": "ID",
  "DJM": "CG",
  "DJN": "US",
  "DJO": "CI",
  "DJU": "IS",
  "DKA": "NG",
  "DKI": "AU",
  "DKK": "US",
  "DKR": "SN",
  "DKS": "RU",
  "DKV": "AU",
  "DLA": "CM",
  "DLC": "CN",
  "DLD": "NO",
  "DLE": "FR",
  "DLF": "US",
  "DLG": "US",
  "DLH": "US",
  "DLI": "VN",
  "DLK": "AU",
  "DLL": "US",
  "DLM": "TR",
  "DLS": "US",
  "DLU": "CN",
  "DLV": "AU",
  "DLY": "VU",
  "DLZ": "MN",
  "DMA": "US",
  "DMB": "KZ",
  "DMD": "AU",
  "DME": "RU",
  "DMK": "TH",
  "DMM": "SA",
  "DMN": "US",
  "DMO": "US",
  "DMT": "BR",
  "DMU": "IN",
  "DNA": "JP",
  "DNB": "AU",
  "DND": "GB",
  "DNG": "AU",
  "DNH": "CN",
  "DNI": "SD",
  "DNK": "UA",
  "DNL": "US",
  "DNO": "BR",
  "DNP": "NP",
  "DNQ": "AU",
  "DNR": "FR",
  "DNU": "PG",
  "DNV": "US",
  "DNX": "SD",
  "DNZ": "TR",
  "DOA": "MG",
  "DOE": "SR",
  "DOG": "SD",
  "DOH": "QA",
  "DOI": "PG",
  "DOK": "UA",
  "DOL": "FR",
  "DOM": "DM",
  "DON": "GT",
  "DOO": "PG",
  "DOP": "NP",
  "DOR": "BF",
  "DOS": "PG",
  "DOU": "BR",
  "DOV": "US",
  "DOX": "AU",
  "DOY": "CN",
  "DPA": "US",
  "DPE": "FR",
  "DPG": "US",
  "DPK": "US",
  "DPL": "PH",
  "DPO": "AU",
  "DPS": "ID",
  "DPU": "PG",
  "DQA": "CN",
  "DQH": "US",
  "DRA": "US",
  "DRB": "AU",
  "DRC": "AO",
  "DRD": "AU",
  "DRE": "US",
  "DRF": "US",
  "DRG": "US",
  "DRH": "ID",
  "DRI": "US",
  "DRJ": "SR",
  "DRK": "CR",
  "DRN": "AU",
  "DRO": "US",
  "DRR": "AU",
  "DRS": "DE",
  "DRT": "US",
  "DRU": "US",
  "DRW": "AU",
  "DRY": "AU",
  "DSA": "GB",
  "DSC": "CM",
  "DSD": "GP",
  "DSE": "ET",
  "DSG": "PH",
  "DSI": "US",
  "DSK": "PK",
  "DSM": "US",
  "DSN": "CN",
  "DSV": "US",
  "DTA": "US",
  "DTD": "ID",
  "DTE": "PH",
  "DTH": "US",
  "DTI": "BR",
  "DTL": "US",
  "DTM": "DE",
  "DTN": "US",
  "DTR": "US",
  "DTW": "US",
  "DUA": "US",
  "DUB": "IE",
  "DUC": "US",
  "DUD": "NZ",
  "DUE": "AO",
  "DUF": "US",
  "DUG": "US",
  "DUJ": "US",
  "DUK": "ZA",
  "DUM": "ID",
  "DUN": "GL",
  "DUQ": "CA",
  "DUR": "ZA",
  "DUS": "DE",
  "DUT": "US",
  "DVK": "CA",
  "DVL": "US",
  "DVN": "US",
  "DVO": "PH",
  "DVP": "AU",
  "DVR": "AU",
  "DVT": "US",
  "DWA": "MW",
  "DWB": "MG",
  "DWC": "AE",
  "DWD": "SA",
  "DWF": "US",
  "DWH": "US",
  "DWN": "US",
  "DWR": "AF",
  "DWS": "US",
  "DXB": "AE",
  "DXD": "AU",
  "DXR": "US",
  "DYA": "AU",
  "DYG": "CN",
  "DYL": "US",
  "DYR": "RU",
  "DYS": "US",
  "DYU": "TJ",
  "DYW": "AU",
  "DZA": "YT",
  "DZN": "KZ",
  "DZO": "UY",
  "DZU": "CN",
  "EAA": "US",
  "EAB": "YE",
  "EAE": "VU",
  "EAL": "MH",
  "EAM": "SA",
  "EAN": "US",
  "EAR": "US",
  "EAS": "ES",
  "EAT": "US",
  "EAU": "US",
  "EBB": "UG",
  "EBD": "SD",
  "EBG": "CO",
  "EBH": "DZ",
  "EBJ": "DK",
  "EBL": "IQ",
  "EBM": "TN",
  "EBN": "MH",
  "EBO": "MH",
  "EBS": "US",
  "EBU": "FR",
  "EBW": "CM",
  "ECA": "US",
  "ECG": "US",
  "ECH": "AU",
  "ECN": "CY",
  "ECO": "CO",
  "ECP": "US",
  "ECR": "CO",
  "ECS": "US",
  "ECV": "ES",
  "EDA": "US",
  "EDB": "SD",
  "EDD": "AU",
  "EDE": "US",
  "EDF": "US",
  "EDI": "GB",
  "EDK": "US",
  "EDL": "KE",
  "EDM": "FR",
  "EDO": "TR",
  "EDQ": "HN",
  "EDR": "AU",
  "EDW": "US",
  "EED": "US",
  "EEK": "US",
  "EEN": "US",
  "EFD": "US",
  "EFG": "PG",
  "EFK": "US",
  "EFL": "GR",
  "EGA": "PG",
  "EGC": "FR",
  "EGE": "US",
  "EGI": "US",
  "EGL": "ET",
  "EGM": "SB",
  "EGN": "SD",
  "EGO": "RU",
  "EGP": "US",
  "EGS": "IS",
  "EGV": "US",
  "EGX": "US",
  "EHL": "AR",
  "EHT": "US",
  "EIB": "DE",
  "EIE": "RU",
  "EIH": "AU",
  "EIN": "NL",
  "EIS": "VG",
  "EIY": "IL",
  "EJA": "CO",
  "EJH": "SA",
  "EKA": "US",
  "EKB": "KZ",
  "EKD": "AU",
  "EKI": "US",
  "EKN": "US",
  "EKO": "US",
  "EKS": "RU",
  "EKT": "SE",
  "EKX": "US",
  "ELA": "US",
  "ELB": "CO",
  "ELC": "AU",
  "ELD": "US",
  "ELE": "PA",
  "ELF": "SD",
  "ELG": "DZ",
  "ELH": "BS",
  "ELI": "US",
  "ELJ": "CO",
  "ELL": "ZA",
  "ELM": "US",
  "ELN": "US",
  "ELO": "AR",
  "ELP": "US",
  "ELQ": "SA",
  "ELS": "ZA",
  "ELT": "EG",
  "ELU": "DZ",
  "ELV": "US",
  "ELW": "US",
  "ELX": "VE",
  "ELY": "US",
  "ELZ": "US",
  "EMA": "GB",
  "EMD": "AU",
  "EME": "DE",
  "EMG": "ZA",
  "EMI": "PG",
  "EMK": "US",
  "EML": "CH",
  "EMM": "US",
  "EMN": "MR",
  "EMO": "PG",
  "EMP": "US",
  "EMS": "PG",
  "EMT": "US",
  "EMX": "AR",
  "EMY": "EG",
  "ENA": "US",
  "ENB": "AU",
  "ENC": "FR",
  "END": "US",
  "ENE": "ID",
  "ENF": "FI",
  "ENH": "CN",
  "ENJ": "GT",
  "ENN": "US",
  "ENO": "PY",
  "ENU": "NG",
  "ENV": "US",
  "ENW": "US",
  "ENY": "CN",
  "EOH": "CO",
  "EOI": "GB",
  "EOK": "US",
  "EOR": "VE",
  "EOZ": "VE",
  "EPA": "AR",
  "EPG": "US",
  "EPH": "US",
  "EPL": "FR",
  "EPR": "AU",
  "EPT": "PG",
  "EPU": "EE",
  "EQS": "AR",
  "ERA": "SO",
  "ERB": "AU",
  "ERC": "TR",
  "ERD": "UA",
  "ERE": "PG",
  "ERF": "DE",
  "ERG": "RU",
  "ERH": "MA",
  "ERI": "US",
  "ERL": "CN",
  "ERM": "BR",
  "ERN": "BR",
  "ERR": "US",
  "ERS": "NA",
  "ERT": "MN",
  "ERU": "PG",
  "ERV": "US",
  "ERZ": "TR",
  "ESA": "PG",
  "ESB": "TR",
  "ESC": "US",
  "ESD": "US",
  "ESE": "MX",
  "ESF": "US",
  "ESG": "PY",
  "ESI": "BR",
  "ESL": "RU",
  "ESM": "EC",
  "ESN": "US",
  "ESO": "US",
  "ESR": "CL",
  "ESS": "DE",
  "ESU": "MA",
  "ESW": "US",
  "ETB": "US",
  "ETD": "AU",
  "ETE": "ET",
  "ETH": "IL",
  "ETR": "EC",
  "ETZ": "FR",
  "EUA": "TO",
  "EUC": "AU",
  "EUE": "US",
  "EUF": "US",
  "EUG": "US",
  "EUM": "DE",
  "EUN": "EH",
  "EUO": "CO",
  "EUQ": "PH",
  "EUX": "BQ",
  "EVA": "US",
  "EVD": "AU",
  "EVE": "NO",
  "EVG": "SE",
  "EVH": "AU",
  "EVM": "US",
  "EVN": "AM",
  "EVV": "US",
  "EVW": "US",
  "EVX": "FR",
  "EWB": "US",
  "EWI": "ID",
  "EWK": "US",
  "EWN": "US",
  "EWO": "CG",
  "EWR": "US",
  "EWY": "GB",
  "EXI": "US",
  "EXM": "AU",
  "EXT": "GB",
  "EYK": "RU",
  "EYL": "ML",
  "EYP": "CO",
  "EYR": "US",
  "EYS": "KE",
  "EYW": "US",
  "EZE": "AR",
  "EZS": "TR",
  "EZV": "RU",
  "FAA": "GN",
  "FAB": "GB",
  "FAC": "PF",
  "FAE": "FO",
  "FAF": "US",
  "FAG": "IS",
  "FAH": "AF",
  "FAI": "US",
  "FAJ": "PR",
  "FAK": "US",
  "FAL": "US",
  "FAM": "US",
  "FAN": "NO",
  "FAO": "PT",
  "FAR": "US",
  "FAS": "IS",
  "FAT": "US",
  "FAU": "OM",
  "FAV": "PF",
  "FAY": "US",
  "FAZ": "IR",
  "FBA": "BR",
  "FBD": "AF",
  "FBE": "BR",
  "FBG": "US",
  "FBK": "US",
  "FBM": "CD",
  "FBR": "US",
  "FBS": "US",
  "FBU": "NO",
  "FCA": "US",
  "FCB": "ZA",
  "FCH": "US",
  "FCM": "US",
  "FCO": "IT",
  "FCS": "US",
  "FCT": "US",
  "FDA": "CO",
  "FDE": "NO",
  "FDF": "MQ",
  "FDH": "DE",
  "FDK": "US",
  "FDO": "AR",
  "FDU": "CD",
  "FDY": "US",
  "FEA": "GB",
  "FEB": "NP",
  "FEC": "BR",
  "FEG": "UZ",
  "FEJ": "BR",
  "FEK": "CI",
  "FEL": "DE",
  "FEN": "BR",
  "FEP": "US",
  "FEW": "US",
  "FEZ": "MA",
  "FFA": "US",
  "FFD": "GB",
  "FFM": "US",
  "FFO": "US",
  "FFU": "CL",
  "FGD": "MR",
  "FGI": "WS",
  "FGL": "NZ",
  "FGU": "PF",
  "FHB": "US",
  "FHU": "US",
  "FHZ": "PF",
  "FID": "US",
  "FIE": "GB",
  "FIG": "GN",
  "FIH": "CD",
  "FIK": "AU",
  "FIL": "US",
  "FIN": "PG",
  "FIV": "US",
  "FIZ": "AU",
  "FJR": "AE",
  "FKB": "DE",
  "FKI": "CD",
  "FKJ": "JP",
  "FKL": "US",
  "FKQ": "ID",
  "FKS": "JP",
  "FLA": "CO",
  "FLB": "BR",
  "FLD": "US",
  "FLE": "US",
  "FLF": "DE",
  "FLG": "US",
  "FLL": "US",
  "FLM": "PY",
  "FLN": "BR",
  "FLO": "US",
  "FLP": "US",
  "FLR": "IT",
  "FLS": "AU",
  "FLT": "US",
  "FLU": "US",
  "FLV": "US",
  "FLW": "PT",
  "FLY": "AU",
  "FMA": "AR",
  "FME": "US",
  "FMG": "CR",
  "FMH": "US",
  "FMI": "CD",
  "FMM": "DE",
  "FMN": "US",
  "FMO": "DE",
  "FMS": "US",
  "FMU": "US",
  "FMY": "US",
  "FNA": "SL",
  "FNC": "PT",
  "FNE": "PG",
  "FNG": "BF",
  "FNH": "ET",
  "FNI": "FR",
  "FNJ": "KP",
  "FNL": "US",
  "FNR": "US",
  "FNT": "US",
  "FNU": "IT",
  "FOA": "GB",
  "FOB": "US",
  "FOC": "CN",
  "FOD": "US",
  "FOK": "US",
  "FOM": "CM",
  "FON": "CR",
  "FOO": "ID",
  "FOR": "BR",
  "FOS": "AU",
  "FOT": "AU",
  "FOU": "GA",
  "FOY": "LR",
  "FPO": "BS",
  "FPR": "US",
  "FRA": "DE",
  "FRB": "AU",
  "FRC": "BR",
  "FRD": "US",
  "FRE": "SB",
  "FRF": "DE",
  "FRG": "US",
  "FRH": "US",
  "FRI": "US",
  "FRJ": "FR",
  "FRM": "US",
  "FRO": "NO",
  "FRQ": "PG",
  "FRR": "US",
  "FRS": "GT",
  "FRT": "CL",
  "FRU": "KG",
  "FRW": "BW",
  "FRY": "US",
  "FRZ": "DE",
  "FSC": "FR",
  "FSD": "US",
  "FSI": "US",
  "FSL": "AU",
  "FSM": "US",
  "FSN": "US",
  "FSP": "PM",
  "FSS": "GB",
  "FST": "US",
  "FSU": "US",
  "FSZ": "JP",
  "FTA": "VU",
  "FTE": "AR",
  "FTI": "AS",
  "FTK": "US",
  "FTU": "MG",
  "FTW": "US",
  "FTX": "CG",
  "FTY": "US",
  "FUB": "PG",
  "FUE": "ES",
  "FUG": "CN",
  "FUJ": "JP",
  "FUK": "JP",
  "FUL": "US",
  "FUM": "PG",
  "FUN": "TV",
  "FUO": "CN",
  "FUT": "WF",
  "FVL": "AU",
  "FVM": "MV",
  "FVR": "AU",
  "FWA": "US",
  "FWH": "US",
  "FWL": "US",
  "FXM": "US",
  "FXO": "MZ",
  "FYT": "TD",
  "FYU": "US",
  "FYV": "US",
  "FZB": "UY",
  "FZO": "GB",
  "GAB": "US",
  "GAC": "HN",
  "GAD": "US",
  "GAE": "TN",
  "GAF": "TN",
  "GAG": "US",
  "GAH": "AU",
  "GAI": "US",
  "GAJ": "JP",
  "GAL": "US",
  "GAM": "US",
  "GAN": "MV",
  "GAO": "CU",
  "GAP": "PG",
  "GAQ": "ML",
  "GAR": "PG",
  "GAS": "KE",
  "GAT": "FR",
  "GAU": "IN",
  "GAV": "ID",
  "GAW": "MM",
  "GAX": "GA",
  "GAY": "IN",
  "GAZ": "PG",
  "GBA": "VU",
  "GBB": "AZ",
  "GBC": "PG",
  "GBD": "US",
  "GBE": "BW",
  "GBF": "PG",
  "GBG": "US",
  "GBH": "US",
  "GBI": "BS",
  "GBJ": "GP",
  "GBK": "SL",
  "GBL": "AU",
  "GBM": "SO",
  "GBP": "AU",
  "GBR": "US",
  "GBT": "IR",
  "GBU": "SD",
  "GBV": "AU",
  "GBZ": "NZ",
  "GCA": "CO",
  "GCC": "US",
  "GCD": "US",
  "GCH": "IR",
  "GCI": "GG",
  "GCJ": "ZA",
  "GCK": "US",
  "GCM": "KY",
  "GCN": "US",
  "GCV": "BR",
  "GCW": "US",
  "GDC": "US",
  "GDD": "AU",
  "GDE": "ET",
  "GDG": "RU",
  "GDH": "US",
  "GDI": "CF",
  "GDJ": "CD",
  "GDL": "MX",
  "GDN": "PL",
  "GDO": "VE",
  "GDP": "BR",
  "GDQ": "ET",
  "GDT": "TC",
  "GDV": "US",
  "GDW": "US",
  "GDX": "RU",
  "GDZ": "RU",
  "GEA": "NC",
  "GEC": "CY",
  "GED": "US",
  "GEE": "AU",
  "GEF": "SB",
  "GEG": "US",
  "GEL": "BR",
  "GEO": "GY",
  "GER": "CU",
  "GES": "PH",
  "GET": "AU",
  "GEV": "SE",
  "GEW": "PG",
  "GEX": "AU",
  "GEY": "US",
  "GFA": "US",
  "GFD": "US",
  "GFE": "AU",
  "GFF": "AU",
  "GFK": "US",
  "GFL": "US",
  "GFN": "AU",
  "GFO": "GY",
  "GFR": "FR",
  "GFY": "NA",
  "GGD": "AU",
  "GGE": "US",
  "GGG": "US",
  "GGL": "CO",
  "GGM": "KE",
  "GGN": "CI",
  "GGO": "CI",
  "GGR": "SO",
  "GGS": "AR",
  "GGT": "BS",
  "GGW": "US",
  "GHA": "DZ",
  "GHB": "BS",
  "GHC": "BS",
  "GHE": "PA",
  "GHF": "DE",
  "GHK": "PS",
  "GHN": "CN",
  "GHT": "LY",
  "GHU": "AR",
  "GIB": "GI",
  "GIC": "AU",
  "GID": "BI",
  "GIF": "US",
  "GIG": "BR",
  "GII": "GN",
  "GIL": "PK",
  "GIR": "CO",
  "GIS": "NZ",
  "GIU": "LK",
  "GIY": "ZA",
  "GIZ": "SA",
  "GJL": "DZ",
  "GJR": "IS",
  "GJT": "US",
  "GKA": "PG",
  "GKD": "TR",
  "GKK": "MV",
  "GKL": "AU",
  "GKN": "US",
  "GKT": "US",
  "GLA": "GB",
  "GLB": "US",
  "GLC": "ET",
  "GLD": "US",
  "GLF": "CR",
  "GLG": "AU",
  "GLH": "US",
  "GLI": "AU",
  "GLJ": "CO",
  "GLK": "SO",
  "GLM": "AU",
  "GLN": "MA",
  "GLO": "GB",
  "GLP": "PG",
  "GLR": "US",
  "GLS": "US",
  "GLT": "AU",
  "GLU": "BT",
  "GLV": "US",
  "GLX": "ID",
  "GLZ": "NL",
  "GMA": "CD",
  "GMB": "ET",
  "GMD": "MA",
  "GME": "BY",
  "GMI": "PG",
  "GML": "UA",
  "GMM": "CG",
  "GMN": "NZ",
  "GMO": "NG",
  "GMP": "KR",
  "GMR": "PF",
  "GMS": "BR",
  "GMT": "US",
  "GMU": "US",
  "GMV": "US",
  "GMZ": "ES",
  "GNA": "BY",
  "GNB": "FR",
  "GND": "GD",
  "GNF": "US",
  "GNG": "US",
  "GNI": "TW",
  "GNM": "BR",
  "GNN": "ET",
  "GNR": "AR",
  "GNS": "ID",
  "GNT": "US",
  "GNU": "US",
  "GNV": "US",
  "GNY": "TR",
  "GNZ": "BW",
  "GOA": "IT",
  "GOB": "ET",
  "GOC": "PG",
  "GOE": "PG",
  "GOG": "NA",
  "GOH": "GL",
  "GOI": "IN",
  "GOJ": "RU",
  "GOK": "US",
  "GOM": "CD",
  "GON": "US",
  "GOO": "AU",
  "GOP": "IN",
  "GOQ": "CN",
  "GOR": "ET",
  "GOT": "SE",
  "GOU": "CM",
  "GOV": "AU",
  "GOY": "LK",
  "GOZ": "BG",
  "GPA": "GR",
  "GPD": "AU",
  "GPI": "CO",
  "GPL": "CR",
  "GPN": "AU",
  "GPO": "AR",
  "GPS": "EC",
  "GPT": "US",
  "GPZ": "US",
  "GQQ": "US",
  "GRB": "US",
  "GRC": "LR",
  "GRD": "US",
  "GRF": "US",
  "GRG": "AF",
  "GRH": "PG",
  "GRI": "US",
  "GRJ": "ZA",
  "GRK": "US",
  "GRL": "PG",
  "GRM": "US",
  "GRN": "US",
  "GRO": "ES",
  "GRP": "BR",
  "GRQ": "NL",
  "GRR": "US",
  "GRT": "PK",
  "GRU": "BR",
  "GRV": "RU",
  "GRW": "PT",
  "GRX": "ES",
  "GRY": "IS",
  "GRZ": "AT",
  "GSA": "MY",
  "GSC": "AU",
  "GSE": "SE",
  "GSH": "US",
  "GSI": "SB",
  "GSJ": "GT",
  "GSL": "CA",
  "GSM": "IR",
  "GSN": "AU",
  "GSO": "US",
  "GSP": "US",
  "GSQ": "EG",
  "GSR": "SO",
  "GSS": "ZA",
  "GST": "US",
  "GSU": "SD",
  "GSW": "US",
  "GSY": "GB",
  "GTB": "MY",
  "GTE": "AU",
  "GTF": "US",
  "GTI": "DE",
  "GTK": "MY",
  "GTN": "NZ",
  "GTO": "ID",
  "GTP": "US",
  "GTR": "US",
  "GTS": "AU",
  "GTT": "AU",
  "GTW": "CZ",
  "GTY": "US",
  "GTZ": "TZ",
  "GUA": "GT",
  "GUB": "MX",
  "GUC": "US",
  "GUD": "ML",
  "GUE": "PG",
  "GUF": "US",
  "GUG": "PG",
  "GUH": "AU",
  "GUL": "AU",
  "GUM": "GU",
  "GUO": "HN",
  "GUP": "US",
  "GUR": "PG",
  "GUS": "US",
  "GUT": "DE",
  "GUU": "IS",
  "GUV": "PG",
  "GUW": "KZ",
  "GUX": "IN",
  "GUY": "US",
  "GUZ": "BR",
  "GVA": "CH",
  "GVI": "PG",
  "GVL": "US",
  "GVN": "RU",
  "GVP": "AU",
  "GVR": "BR",
  "GVT": "US",
  "GVW": "US",
  "GVX": "SE",
  "GWA": "MM",
  "GWD": "PK",
  "GWE": "ZW",
  "GWL": "IN",
  "GWN": "PG",
  "GWO": "US",
  "GWS": "US",
  "GWT": "DE",
  "GWV": "US",
  "GWW": "DE",
  "GWY": "IE",
  "GXF": "YE",
  "GXG": "AO",
  "GXH": "GB",
  "GXQ": "CL",
  "GXX": "CM",
  "GXY": "US",
  "GYA": "BO",
  "GYD": "AZ",
  "GYE": "EC",
  "GYI": "RW",
  "GYL": "AU",
  "GYM": "MX",
  "GYN": "BR",
  "GYP": "AU",
  "GYR": "US",
  "GYS": "CN",
  "GYU": "CN",
  "GYY": "US",
  "GZA": "PS",
  "GZI": "AF",
  "GZM": "MT",
  "GZO": "SB",
  "GZP": "TR",
  "GZT": "TR",
  "HAA": "NO",
  "HAB": "US",
  "HAC": "JP",
  "HAD": "SE",
  "HAE": "US",
  "HAF": "US",
  "HAH": "KM",
  "HAI": "US",
  "HAJ": "DE",
  "HAK": "CN",
  "HAL": "NA",
  "HAM": "DE",
  "HAN": "VN",
  "HAO": "US",
  "HAQ": "MV",
  "HAS": "SA",
  "HAT": "AU",
  "HAU": "NO",
  "HAV": "CU",
  "HAW": "GB",
  "HAX": "US",
  "HAY": "US",
  "HAZ": "PG",
  "HBA": "AU",
  "HBB": "US",
  "HBD": "PG",
  "HBE": "EG",
  "HBG": "US",
  "HBH": "US",
  "HBK": "US",
  "HBR": "US",
  "HBU": "MN",
  "HBX": "IN",
  "HCA": "US",
  "HCC": "US",
  "HCM": "SO",
  "HCN": "TW",
  "HCQ": "AU",
  "HCR": "US",
  "HCW": "US",
  "HDB": "DE",
  "HDD": "PK",
  "HDE": "US",
  "HDF": "DE",
  "HDG": "CN",
  "HDH": "US",
  "HDM": "IR",
  "HDN": "US",
  "HDR": "IR",
  "HDS": "ZA",
  "HDY": "TH",
  "HEA": "AF",
  "HED": "US",
  "HEE": "US",
  "HEG": "SD",
  "HEH": "MM",
  "HEI": "DE",
  "HEK": "CN",
  "HEL": "FI",
  "HEM": "FI",
  "HEO": "PG",
  "HER": "GR",
  "HET": "CN",
  "HEV": "ES",
  "HEW": "GR",
  "HEX": "DO",
  "HEY": "US",
  "HEZ": "US",
  "HFA": "IL",
  "HFD": "US",
  "HFE": "CN",
  "HFF": "US",
  "HFS": "SE",
  "HFT": "NO",
  "HGA": "SO",
  "HGD": "AU",
  "HGH": "CN",
  "HGL": "DE",
  "HGN": "TH",
  "HGO": "CI",
  "HGR": "US",
  "HGS": "SL",
  "HGT": "US",
  "HGU": "PG",
  "HGZ": "US",
  "HHE": "JP",
  "HHH": "US",
  "HHI": "US",
  "HHN": "DE",
  "HHP": "HK",
  "HHQ": "TH",
  "HHR": "US",
  "HHZ": "PF",
  "HIA": "CN",
  "HIB": "US",
  "HID": "AU",
  "HIE": "US",
  "HIF": "US",
  "HIJ": "JP",
  "HIL": "ET",
  "HIN": "KR",
  "HIO": "US",
  "HIP": "AU",
  "HIR": "SB",
  "HIS": "AU",
  "HIT": "PG",
  "HIW": "JP",
  "HJJ": "CN",
  "HJR": "IN",
  "HJT": "MN",
  "HKB": "US",
  "HKD": "JP",
  "HKG": "HK",
  "HKK": "NZ",
  "HKN": "PG",
  "HKS": "US",
  "HKT": "TH",
  "HKY": "US",
  "HLA": "ZA",
  "HLB": "US",
  "HLC": "US",
  "HLD": "CN",
  "HLF": "SE",
  "HLG": "US",
  "HLH": "CN",
  "HLI": "US",
  "HLJ": "LT",
  "HLL": "AU",
  "HLM": "US",
  "HLN": "US",
  "HLO": "IS",
  "HLP": "ID",
  "HLR": "US",
  "HLS": "AU",
  "HLT": "AU",
  "HLU": "NC",
  "HLV": "AU",
  "HLW": "ZA",
  "HLY": "GB",
  "HLZ": "NZ",
  "HMA": "RU",
  "HMB": "EG",
  "HME": "DZ",
  "HMG": "AU",
  "HMI": "CN",
  "HMJ": "UA",
  "HMN": "US",
  "HMO": "MX",
  "HMR": "NO",
  "HMT": "US",
  "HMV": "SE",
  "HNA": "JP",
  "HNC": "US",
  "HND": "JP",
  "HNE": "US",
  "HNH": "US",
  "HNI": "PG",
  "HNL": "US",
  "HNM": "US",
  "HNN": "PG",
  "HNS": "US",
  "HNY": "CN",
  "HOA": "KE",
  "HOB": "US",
  "HOC": "PG",
  "HOD": "YE",
  "HOE": "LA",
  "HOF": "SA",
  "HOG": "CU",
  "HOH": "AT",
  "HOI": "PF",
  "HOK": "AU",
  "HOM": "US",
  "HON": "US",
  "HOO": "VN",
  "HOQ": "DE",
  "HOR": "PT",
  "HOS": "AR",
  "HOT": "US",
  "HOU": "US",
  "HOV": "NO",
  "HOX": "MM",
  "HOY": "GB",
  "HPA": "TO",
  "HPB": "US",
  "HPE": "AU",
  "HPH": "VN",
  "HPN": "US",
  "HPR": "ZA",
  "HPV": "US",
  "HPY": "US",
  "HQM": "US",
  "HRA": "PK",
  "HRB": "CN",
  "HRC": "KZ",
  "HRE": "ZW",
  "HRG": "EG",
  "HRI": "LK",
  "HRK": "UA",
  "HRL": "US",
  "HRM": "DZ",
  "HRO": "US",
  "HRR": "CO",
  "HRS": "ZA",
  "HRT": "GB",
  "HRY": "AU",
  "HRZ": "BR",
  "HSB": "US",
  "HSC": "CN",
  "HSG": "JP",
  "HSH": "US",
  "HSI": "US",
  "HSL": "US",
  "HSM": "AU",
  "HSN": "CN",
  "HSP": "US",
  "HSS": "IN",
  "HST": "US",
  "HSV": "US",
  "HSZ": "TW",
  "HTA": "RU",
  "HTG": "RU",
  "HTI": "AU",
  "HTL": "US",
  "HTM": "MN",
  "HTN": "CN",
  "HTO": "US",
  "HTR": "JP",
  "HTS": "US",
  "HTU": "AU",
  "HTW": "US",
  "HTY": "TR",
  "HTZ": "CO",
  "HUB": "AU",
  "HUC": "PR",
  "HUD": "US",
  "HUE": "ET",
  "HUF": "US",
  "HUG": "GT",
  "HUH": "PF",
  "HUI": "VN",
  "HUJ": "US",
  "HUK": "BW",
  "HUM": "US",
  "HUN": "TW",
  "HUQ": "LY",
  "HUT": "US",
  "HUU": "PE",
  "HUV": "SE",
  "HUX": "MX",
  "HUY": "GB",
  "HUZ": "CN",
  "HVA": "MG",
  "HVB": "AU",
  "HVD": "MN",
  "HVE": "US",
  "HVG": "NO",
  "HVK": "IS",
  "HVN": "US",
  "HVR": "US",
  "HWA": "PG",
  "HWD": "US",
  "HWK": "AU",
  "HWN": "ZW",
  "HWO": "US",
  "HXX": "AU",
  "HYA": "US",
  "HYC": "GB",
  "HYD": "IN",
  "HYF": "PG",
  "HYG": "US",
  "HYN": "CN",
  "HYS": "US",
  "HZB": "FR",
  "HZG": "CN",
  "HZH": "CN",
  "HZL": "US",
  "HZP": "CA",
  "HZV": "ZA",
  "IAA": "RU",
  "IAD": "US",
  "IAG": "US",
  "IAH": "US",
  "IAL": "PG",
  "IAM": "DZ",
  "IAN": "US",
  "IAO": "PH",
  "IAR": "RU",
  "IAS": "RO",
  "IBA": "NG",
  "IBE": "CO",
  "IBI": "PG",
  "IBL": "MZ",
  "IBO": "MZ",
  "IBP": "PE",
  "IBR": "JP",
  "IBZ": "ES",
  "ICA": "VE",
  "ICI": "FJ",
  "ICK": "SR",
  "ICN": "KR",
  "ICO": "PH",
  "ICR": "CU",
  "ICS": "US",
  "ICT": "US",
  "ICY": "US",
  "IDA": "US",
  "IDB": "SE",
  "IDF": "CD",
  "IDH": "US",
  "IDI": "US",
  "IDK": "AU",
  "IDN": "PG",
  "IDO": "BR",
  "IDP": "US",
  "IDR": "IN",
  "IDY": "FR",
  "IEJ": "JP",
  "IES": "DE",
  "IEV": "UA",
  "IFA": "US",
  "IFF": "AU",
  "IFH": "IR",
  "IFJ": "IS",
  "IFL": "AU",
  "IFN": "IR",
  "IFO": "UA",
  "IFP": "US",
  "IGA": "BS",
  "IGB": "AR",
  "IGD": "TR",
  "IGE": "GA",
  "IGG": "US",
  "IGH": "AU",
  "IGL": "TR",
  "IGM": "US",
  "IGN": "PH",
  "IGO": "CO",
  "IGR": "AR",
  "IGS": "DE",
  "IGT": "RU",
  "IGU": "BR",
  "IHC": "MZ",
  "IHN": "YE",
  "IHO": "MG",
  "IHR": "IR",
  "IHU": "PG",
  "IIA": "IE",
  "IIL": "IR",
  "IIS": "PG",
  "IJK": "RU",
  "IJU": "BR",
  "IKA": "IR",
  "IKB": "US",
  "IKI": "JP",
  "IKK": "US",
  "IKL": "CD",
  "IKO": "US",
  "IKP": "AU",
  "IKS": "RU",
  "IKT": "RU",
  "ILA": "ID",
  "ILD": "ES",
  "ILF": "CA",
  "ILG": "US",
  "ILH": "DE",
  "ILI": "US",
  "ILK": "MG",
  "ILL": "US",
  "ILM": "US",
  "ILN": "US",
  "ILO": "PH",
  "ILP": "NC",
  "ILQ": "PE",
  "ILR": "NG",
  "ILU": "KE",
  "ILX": "PG",
  "ILY": "GB",
  "ILZ": "SK",
  "IMA": "PG",
  "IMB": "GY",
  "IMD": "PG",
  "IMF": "IN",
  "IMG": "MZ",
  "IMI": "MH",
  "IMK": "NP",
  "IML": "US",
  "IMM": "US",
  "IMN": "PG",
  "IMO": "CF",
  "IMP": "BR",
  "IMT": "US",
  "INA": "RU",
  "INB": "BZ",
  "IND": "US",
  "INE": "MZ",
  "INF": "DZ",
  "ING": "AR",
  "INH": "MZ",
  "INI": "RS",
  "INJ": "AU",
  "INK": "US",
  "INL": "US",
  "INM": "AU",
  "INN": "AT",
  "INS": "US",
  "INT": "US",
  "INU": "NR",
  "INV": "GB",
  "INW": "US",
  "INX": "ID",
  "INY": "ZA",
  "INZ": "DZ",
  "IOA": "GR",
  "IOK": "PG",
  "IOM": "IM",
  "ION": "CG",
  "IOP": "PG",
  "IOS": "BR",
  "IOU": "NC",
  "IOW": "US",
  "IPA": "VU",
  "IPC": "CL",
  "IPE": "PH",
  "IPG": "BR",
  "IPH": "MY",
  "IPI": "CO",
  "IPL": "US",
  "IPN": "BR",
  "IPT": "US",
  "IPU": "BR",
  "IQA": "IQ",
  "IQM": "CN",
  "IQN": "CN",
  "IQQ": "CL",
  "IQT": "PE",
  "IRA": "SB",
  "IRB": "US",
  "IRC": "US",
  "IRD": "BD",
  "IRE": "BR",
  "IRG": "AU",
  "IRI": "TZ",
  "IRJ": "AR",
  "IRK": "US",
  "IRM": "RU",
  "IRN": "HN",
  "IRO": "CF",
  "IRP": "CD",
  "IRS": "US",
  "IRZ": "BR",
  "ISA": "AU",
  "ISB": "PK",
  "ISC": "GB",
  "ISD": "CO",
  "ISE": "TR",
  "ISG": "JP",
  "ISI": "AU",
  "ISL": "VE",
  "ISM": "US",
  "ISN": "US",
  "ISO": "US",
  "ISP": "US",
  "ISS": "US",
  "IST": "TR",
  "ISU": "IQ",
  "ISW": "US",
  "ITA": "BR",
  "ITE": "BR",
  "ITH": "US",
  "ITI": "BR",
  "ITK": "PG",
  "ITM": "JP",
  "ITN": "BR",
  "ITO": "US",
  "ITP": "BR",
  "ITQ": "BR",
  "ITR": "BR",
  "IUE": "NU",
  "IUL": "ID",
  "IUS": "PG",
  "IVC": "NZ",
  "IVG": "ME",
  "IVH": "US",
  "IVL": "FI",
  "IVR": "AU",
  "IVW": "AU",
  "IWA": "RU",
  "IWD": "US",
  "IWJ": "JP",
  "IWO": "JP",
  "IWS": "US",
  "IXA": "IN",
  "IXB": "IN",
  "IXC": "IN",
  "IXD": "IN",
  "IXE": "IN",
  "IXG": "IN",
  "IXH": "IN",
  "IXI": "IN",
  "IXJ": "IN",
  "IXK": "IN",
  "IXL": "IN",
  "IXM": "IN",
  "IXN": "IN",
  "IXP": "IN",
  "IXQ": "IN",
  "IXR": "IN",
  "IXS": "IN",
  "IXT": "IN",
  "IXU": "IN",
  "IXV": "IN",
  "IXW": "IN",
  "IXY": "IN",
  "IXZ": "IN",
  "IYK": "US",
  "IZA": "BR",
  "IZO": "JP",
  "IZT": "MX",
  "JAA": "AF",
  "JAB": "AU",
  "JAC": "US",
  "JAD": "AU",
  "JAF": "LK",
  "JAG": "PK",
  "JAI": "IN",
  "JAK": "HT",
  "JAL": "MX",
  "JAN": "US",
  "JAP": "CR",
  "JAQ": "PG",
  "JAS": "US",
  "JAT": "MH",
  "JAU": "PE",
  "JAV": "GL",
  "JAX": "US",
  "JBK": "US",
  "JBQ": "DO",
  "JBR": "US",
  "JBT": "US",
  "JCA": "FR",
  "JCB": "BR",
  "JCH": "GL",
  "JCI": "US",
  "JCK": "AU",
  "JCM": "BR",
  "JCR": "BR",
  "JCT": "US",
  "JCU": "ES",
  "JCY": "US",
  "JDA": "US",
  "JDF": "BR",
  "JDH": "IN",
  "JDN": "US",
  "JDO": "BR",
  "JDP": "FR",
  "JDR": "BR",
  "JDZ": "CN",
  "JED": "SA",
  "JEE": "HT",
  "JEG": "GL",
  "JEJ": "MH",
  "JEQ": "BR",
  "JER": "JE",
  "JFK": "US",
  "JFN": "US",
  "JFR": "GL",
  "JGA": "IN",
  "JGB": "IN",
  "JGD": "CN",
  "JGN": "CN",
  "JGO": "GL",
  "JGR": "GL",
  "JGS": "CN",
  "JHB": "MY",
  "JHG": "CN",
  "JHL": "CA",
  "JHM": "US",
  "JHS": "GL",
  "JHW": "US",
  "JIA": "BR",
  "JIB": "DJ",
  "JIC": "CN",
  "JIJ": "ET",
  "JIK": "GR",
  "JIL": "CN",
  "JIM": "ET",
  "JIN": "UG",
  "JIO": "US",
  "JIP": "EC",
  "JIQ": "CN",
  "JIU": "CN",
  "JIW": "PK",
  "JJI": "PE",
  "JJN": "CN",
  "JJU": "GL",
  "JKG": "SE",
  "JKH": "GR",
  "JKR": "NP",
  "JKV": "US",
  "JLA": "US",
  "JLN": "US",
  "JLR": "IN",
  "JLS": "BR",
  "JMB": "AO",
  "JMK": "GR",
  "JMO": "NP",
  "JMS": "US",
  "JMU": "CN",
  "JNA": "BR",
  "JNB": "ZA",
  "JNG": "CN",
  "JNI": "AR",
  "JNN": "GL",
  "JNS": "GL",
  "JNU": "US",
  "JNX": "GR",
  "JNZ": "CN",
  "JOE": "FI",
  "JOG": "ID",
  "JOH": "ZA",
  "JOI": "BR",
  "JOK": "RU",
  "JOL": "PH",
  "JOM": "TZ",
  "JON": "UM",
  "JOP": "PG",
  "JOS": "NG",
  "JOT": "US",
  "JPA": "BR",
  "JPN": "US",
  "JPR": "BR",
  "JQA": "GL",
  "JQE": "PA",
  "JRA": "US",
  "JRB": "US",
  "JRH": "IN",
  "JRN": "BR",
  "JRO": "TZ",
  "JRS": "PS",
  "JSA": "IN",
  "JSH": "GR",
  "JSI": "GR",
  "JSM": "AR",
  "JSR": "BD",
  "JSS": "GR",
  "JST": "US",
  "JSU": "GL",
  "JSY": "GR",
  "JTI": "BR",
  "JTR": "GR",
  "JTY": "GR",
  "JUA": "BR",
  "JUB": "SS",
  "JUH": "CN",
  "JUI": "DE",
  "JUJ": "AR",
  "JUL": "PE",
  "JUM": "NP",
  "JUN": "AU",
  "JUO": "CO",
  "JUR": "AU",
  "JUT": "HN",
  "JUV": "GL",
  "JUZ": "CN",
  "JVA": "MG",
  "JVI": "US",
  "JVL": "US",
  "JWA": "BW",
  "JWN": "IR",
  "JXN": "US",
  "JYV": "FI",
  "JZH": "CN",
  "KAA": "ZM",
  "KAB": "ZW",
  "KAC": "SY",
  "KAD": "NG",
  "KAE": "US",
  "KAF": "PG",
  "KAG": "KR",
  "KAI": "GY",
  "KAJ": "FI",
  "KAL": "US",
  "KAM": "YE",
  "KAN": "NG",
  "KAO": "FI",
  "KAP": "CD",
  "KAQ": "PG",
  "KAR": "GY",
  "KAS": "NA",
  "KAT": "NZ",
  "KAU": "FI",
  "KAV": "VE",
  "KAW": "MM",
  "KAX": "AU",
  "KAY": "FJ",
  "KAZ": "ID",
  "KBA": "SL",
  "KBB": "AU",
  "KBC": "US",
  "KBD": "AU",
  "KBE": "US",
  "KBF": "ID",
  "KBG": "UG",
  "KBH": "PK",
  "KBI": "CM",
  "KBJ": "AU",
  "KBL": "AF",
  "KBM": "PG",
  "KBN": "CD",
  "KBO": "CD",
  "KBP": "UA",
  "KBQ": "MW",
  "KBR": "MY",
  "KBS": "SL",
  "KBT": "MH",
  "KBU": "ID",
  "KBV": "TH",
  "KBW": "US",
  "KBX": "ID",
  "KBY": "AU",
  "KBZ": "NZ",
  "KCA": "CN",
  "KCB": "SR",
  "KCC": "US",
  "KCD": "ID",
  "KCE": "AU",
  "KCF": "PK",
  "KCG": "US",
  "KCH": "MY",
  "KCI": "TL",
  "KCJ": "PG",
  "KCK": "RU",
  "KCL": "US",
  "KCM": "TR",
  "KCQ": "US",
  "KCR": "US",
  "KCS": "AU",
  "KCT": "LK",
  "KCU": "UG",
  "KCZ": "JP",
  "KDA": "SN",
  "KDB": "AU",
  "KDC": "BJ",
  "KDD": "PK",
  "KDE": "PG",
  "KDH": "AF",
  "KDI": "ID",
  "KDJ": "GA",
  "KDK": "US",
  "KDL": "EE",
  "KDM": "MV",
  "KDN": "GA",
  "KDO": "MV",
  "KDP": "PG",
  "KDQ": "PG",
  "KDR": "PG",
  "KDS": "AU",
  "KDT": "TH",
  "KDU": "PK",
  "KDV": "FJ",
  "KDX": "SD",
  "KEA": "ID",
  "KEB": "US",
  "KEC": "CD",
  "KED": "MR",
  "KEE": "CG",
  "KEF": "IS",
  "KEG": "PG",
  "KEH": "US",
  "KEI": "ID",
  "KEJ": "RU",
  "KEK": "US",
  "KEL": "DE",
  "KEM": "FI",
  "KEN": "SL",
  "KEO": "CI",
  "KEP": "NP",
  "KEQ": "ID",
  "KER": "IR",
  "KES": "CA",
  "KET": "MM",
  "KEV": "FI",
  "KEW": "CA",
  "KEX": "PG",
  "KEY": "KE",
  "KFA": "MR",
  "KFE": "AU",
  "KFG": "AU",
  "KFP": "US",
  "KFS": "TR",
  "KGA": "CD",
  "KGB": "PG",
  "KGC": "AU",
  "KGD": "RU",
  "KGE": "SB",
  "KGF": "KZ",
  "KGG": "SN",
  "KGH": "PG",
  "KGI": "AU",
  "KGJ": "MW",
  "KGK": "US",
  "KGL": "RW",
  "KGM": "PG",
  "KGO": "UA",
  "KGP": "RU",
  "KGR": "AU",
  "KGS": "GR",
  "KGU": "MY",
  "KGW": "PG",
  "KGX": "US",
  "KGY": "AU",
  "KGZ": "US",
  "KHA": "IR",
  "KHC": "UA",
  "KHD": "IR",
  "KHE": "UA",
  "KHG": "CN",
  "KHH": "TW",
  "KHI": "PK",
  "KHJ": "FI",
  "KHK": "IR",
  "KHL": "BD",
  "KHM": "MM",
  "KHN": "CN",
  "KHO": "ZA",
  "KHR": "MN",
  "KHS": "OM",
  "KHT": "AF",
  "KHU": "UA",
  "KHV": "RU",
  "KHW": "BW",
  "KHY": "IR",
  "KHZ": "PF",
  "KIC": "US",
  "KIE": "PG",
  "KIF": "CA",
  "KIG": "ZA",
  "KIH": "IR",
  "KII": "PG",
  "KIJ": "JP",
  "KIK": "IQ",
  "KIL": "CD",
  "KIM": "ZA",
  "KIN": "JM",
  "KIO": "MH",
  "KIP": "US",
  "KIQ": "PG",
  "KIR": "IE",
  "KIS": "KE",
  "KIT": "GR",
  "KIU": "KE",
  "KIV": "MD",
  "KIW": "ZM",
  "KIX": "JP",
  "KIY": "TZ",
  "KIZ": "PG",
  "KJA": "RU",
  "KJK": "BE",
  "KJP": "JP",
  "KJU": "PG",
  "KKA": "US",
  "KKC": "TH",
  "KKD": "PG",
  "KKE": "NZ",
  "KKG": "GY",
  "KKH": "US",
  "KKI": "US",
  "KKJ": "JP",
  "KKK": "US",
  "KKL": "US",
  "KKN": "NO",
  "KKO": "NZ",
  "KKP": "AU",
  "KKR": "PF",
  "KKT": "US",
  "KKU": "US",
  "KKW": "CD",
  "KKX": "JP",
  "KKY": "IE",
  "KKZ": "KH",
  "KLC": "SN",
  "KLD": "RU",
  "KLE": "CM",
  "KLF": "RU",
  "KLG": "US",
  "KLH": "IN",
  "KLI": "CD",
  "KLK": "KE",
  "KLL": "US",
  "KLN": "US",
  "KLO": "PH",
  "KLQ": "ID",
  "KLR": "SE",
  "KLS": "US",
  "KLU": "AT",
  "KLV": "CZ",
  "KLW": "US",
  "KLX": "GR",
  "KLY": "CD",
  "KLZ": "ZA",
  "KMA": "PG",
  "KMB": "PG",
  "KMC": "SA",
  "KME": "RW",
  "KMF": "PG",
  "KMG": "CN",
  "KMH": "ZA",
  "KMI": "JP",
  "KMJ": "JP",
  "KMK": "CG",
  "KML": "AU",
  "KMM": "ID",
  "KMN": "CD",
  "KMO": "US",
  "KMP": "NA",
  "KMQ": "JP",
  "KMR": "PG",
  "KMS": "GH",
  "KMT": "KH",
  "KMU": "SO",
  "KMV": "MM",
  "KMW": "RU",
  "KMX": "SA",
  "KMZ": "ZM",
  "KNA": "CL",
  "KND": "CD",
  "KNE": "PG",
  "KNF": "GB",
  "KNG": "ID",
  "KNH": "TW",
  "KNI": "AU",
  "KNJ": "CG",
  "KNK": "US",
  "KNL": "PG",
  "KNM": "CD",
  "KNN": "GN",
  "KNO": "ID",
  "KNP": "AO",
  "KNQ": "NC",
  "KNS": "AU",
  "KNT": "US",
  "KNU": "IN",
  "KNW": "US",
  "KNX": "AU",
  "KNZ": "ML",
  "KOA": "US",
  "KOC": "NC",
  "KOE": "ID",
  "KOF": "ZA",
  "KOH": "AU",
  "KOI": "GB",
  "KOJ": "JP",
  "KOK": "FI",
  "KOL": "CF",
  "KOM": "PG",
  "KON": "VN",
  "KOO": "CD",
  "KOP": "TH",
  "KOQ": "DE",
  "KOR": "PG",
  "KOS": "KH",
  "KOT": "US",
  "KOV": "KZ",
  "KOW": "CN",
  "KOX": "ID",
  "KOY": "US",
  "KOZ": "US",
  "KPA": "PG",
  "KPB": "US",
  "KPC": "US",
  "KPE": "PG",
  "KPF": "PG",
  "KPI": "MY",
  "KPL": "PG",
  "KPM": "PG",
  "KPN": "US",
  "KPO": "KR",
  "KPP": "AU",
  "KPR": "US",
  "KPS": "AU",
  "KPT": "US",
  "KPV": "US",
  "KPY": "US",
  "KQA": "US",
  "KQL": "PG",
  "KQT": "TJ",
  "KRA": "AU",
  "KRB": "AU",
  "KRD": "AU",
  "KRE": "BI",
  "KRF": "SE",
  "KRG": "GY",
  "KRH": "GB",
  "KRI": "PG",
  "KRJ": "PG",
  "KRK": "PL",
  "KRL": "CN",
  "KRM": "GY",
  "KRN": "SE",
  "KRO": "RU",
  "KRP": "DK",
  "KRQ": "UA",
  "KRR": "RU",
  "KRS": "NO",
  "KRT": "SD",
  "KRU": "PG",
  "KRV": "KE",
  "KRW": "TM",
  "KRX": "PG",
  "KRY": "CN",
  "KRZ": "CD",
  "KSA": "FM",
  "KSB": "PG",
  "KSC": "SK",
  "KSD": "SE",
  "KSF": "DE",
  "KSG": "PG",
  "KSH": "IR",
  "KSI": "GN",
  "KSJ": "GR",
  "KSK": "SE",
  "KSL": "SD",
  "KSM": "US",
  "KSN": "KZ",
  "KSO": "GR",
  "KSP": "PG",
  "KSQ": "UZ",
  "KSS": "ML",
  "KST": "SD",
  "KSU": "NO",
  "KSV": "AU",
  "KSW": "IL",
  "KSX": "PG",
  "KSY": "TR",
  "KSZ": "RU",
  "KTA": "AU",
  "KTB": "US",
  "KTC": "CI",
  "KTD": "JP",
  "KTE": "MY",
  "KTF": "NZ",
  "KTG": "ID",
  "KTI": "KH",
  "KTK": "PG",
  "KTL": "KE",
  "KTM": "NP",
  "KTN": "US",
  "KTO": "GY",
  "KTP": "JM",
  "KTR": "AU",
  "KTS": "US",
  "KTT": "FI",
  "KTU": "IN",
  "KTV": "VE",
  "KTW": "PL",
  "KTX": "ML",
  "KUA": "MY",
  "KUC": "KI",
  "KUD": "MY",
  "KUE": "SB",
  "KUF": "RU",
  "KUG": "AU",
  "KUH": "JP",
  "KUK": "US",
  "KUL": "MY",
  "KUM": "JP",
  "KUN": "LT",
  "KUO": "FI",
  "KUP": "PG",
  "KUQ": "PG",
  "KUS": "GL",
  "KUT": "GE",
  "KUU": "IN",
  "KUV": "KR",
  "KUX": "PG",
  "KUY": "PG",
  "KVA": "GR",
  "KVB": "SE",
  "KVC": "US",
  "KVD": "AZ",
  "KVE": "PG",
  "KVG": "PG",
  "KVK": "RU",
  "KVL": "US",
  "KVX": "RU",
  "KWA": "MH",
  "KWB": "ID",
  "KWE": "CN",
  "KWF": "US",
  "KWG": "UA",
  "KWH": "AF",
  "KWI": "KW",
  "KWJ": "KR",
  "KWK": "US",
  "KWL": "CN",
  "KWM": "AU",
  "KWN": "US",
  "KWO": "PG",
  "KWP": "US",
  "KWS": "SB",
  "KWT": "US",
  "KWV": "PG",
  "KWX": "PG",
  "KWY": "KE",
  "KWZ": "CD",
  "KXA": "US",
  "KXE": "ZA",
  "KXF": "FJ",
  "KXK": "RU",
  "KXR": "PG",
  "KYA": "TR",
  "KYD": "TW",
  "KYE": "LB",
  "KYI": "AU",
  "KYK": "US",
  "KYL": "US",
  "KYO": "US",
  "KYP": "MM",
  "KYS": "ML",
  "KYT": "MM",
  "KYU": "US",
  "KYX": "PG",
  "KYZ": "RU",
  "KZB": "US",
  "KZC": "KH",
  "KZD": "KH",
  "KZF": "PG",
  "KZI": "GR",
  "KZN": "RU",
  "KZO": "KZ",
  "KZS": "GR",
  "LAA": "US",
  "LAB": "PG",
  "LAD": "AO",
  "LAE": "PG",
  "LAF": "US",
  "LAG": "VE",
  "LAH": "ID",
  "LAI": "FR",
  "LAK": "CA",
  "LAL": "US",
  "LAM": "US",
  "LAN": "US",
  "LAO": "PH",
  "LAP": "MX",
  "LAQ": "LY",
  "LAR": "US",
  "LAS": "US",
  "LAU": "KE",
  "LAW": "US",
  "LAX": "US",
  "LAZ": "BR",
  "LBA": "GB",
  "LBB": "US",
  "LBC": "DE",
  "LBD": "TJ",
  "LBE": "US",
  "LBF": "US",
  "LBG": "FR",
  "LBH": "AU",
  "LBI": "FR",
  "LBJ": "ID",
  "LBK": "KE",
  "LBL": "US",
  "LBM": "MZ",
  "LBN": "KE",
  "LBO": "CD",
  "LBP": "MY",
  "LBQ": "GA",
  "LBR": "BR",
  "LBS": "FJ",
  "LBT": "US",
  "LBU": "MY",
  "LBV": "GA",
  "LBW": "ID",
  "LBX": "PH",
  "LBY": "FR",
  "LBZ": "AO",
  "LCA": "CY",
  "LCB": "BR",
  "LCD": "ZA",
  "LCE": "HN",
  "LCF": "GT",
  "LCG": "ES",
  "LCH": "US",
  "LCI": "US",
  "LCJ": "PL",
  "LCK": "US",
  "LCL": "CU",
  "LCM": "AR",
  "LCN": "AU",
  "LCO": "CG",
  "LCP": "AR",
  "LCQ": "US",
  "LCR": "CO",
  "LCX": "CN",
  "LCY": "GB",
  "LDA": "IN",
  "LDB": "BR",
  "LDC": "AU",
  "LDE": "FR",
  "LDG": "RU",
  "LDH": "AU",
  "LDI": "TZ",
  "LDJ": "US",
  "LDK": "SE",
  "LDM": "US",
  "LDN": "NP",
  "LDO": "SR",
  "LDS": "CN",
  "LDU": "MY",
  "LDV": "FR",
  "LDW": "AU",
  "LDX": "GF",
  "LDY": "GB",
  "LDZ": "ZA",
  "LEA": "AU",
  "LEB": "US",
  "LEC": "BR",
  "LED": "RU",
  "LEE": "US",
  "LEF": "LS",
  "LEH": "FR",
  "LEI": "ES",
  "LEJ": "DE",
  "LEL": "AU",
  "LEM": "US",
  "LEN": "ES",
  "LEO": "GA",
  "LEP": "BR",
  "LEQ": "GB",
  "LER": "AU",
  "LES": "LS",
  "LET": "CO",
  "LEU": "ES",
  "LEV": "FJ",
  "LEW": "US",
  "LEX": "US",
  "LEY": "NL",
  "LEZ": "HN",
  "LFB": "MZ",
  "LFI": "US",
  "LFK": "US",
  "LFN": "US",
  "LFO": "ET",
  "LFP": "AU",
  "LFR": "VE",
  "LFT": "US",
  "LFW": "TG",
  "LGA": "US",
  "LGB": "US",
  "LGC": "US",
  "LGD": "US",
  "LGF": "US",
  "LGG": "BE",
  "LGH": "AU",
  "LGI": "BS",
  "LGK": "MY",
  "LGL": "MY",
  "LGM": "PG",
  "LGN": "PG",
  "LGO": "DE",
  "LGP": "PH",
  "LGQ": "EC",
  "LGR": "CL",
  "LGS": "AR",
  "LGT": "CO",
  "LGU": "US",
  "LGW": "GB",
  "LGX": "SO",
  "LGY": "VE",
  "LHA": "DE",
  "LHE": "PK",
  "LHG": "AU",
  "LHI": "ID",
  "LHK": "CN",
  "LHR": "GB",
  "LHS": "AR",
  "LHV": "US",
  "LHW": "CN",
  "LIA": "CN",
  "LIB": "AU",
  "LIC": "US",
  "LID": "NL",
  "LIE": "CD",
  "LIF": "NC",
  "LIG": "FR",
  "LIH": "US",
  "LII": "ID",
  "LIK": "MH",
  "LIL": "FR",
  "LIM": "PE",
  "LIN": "IT",
  "LIO": "CR",
  "LIP": "BR",
  "LIQ": "CD",
  "LIR": "CR",
  "LIS": "PT",
  "LIT": "US",
  "LIV": "US",
  "LIW": "MM",
  "LIX": "MW",
  "LIY": "US",
  "LIZ": "US",
  "LJA": "CD",
  "LJG": "CN",
  "LJN": "US",
  "LJU": "SI",
  "LKA": "ID",
  "LKB": "FJ",
  "LKC": "CG",
  "LKD": "AU",
  "LKE": "US",
  "LKG": "KE",
  "LKH": "MY",
  "LKK": "US",
  "LKL": "NO",
  "LKN": "NO",
  "LKO": "IN",
  "LKP": "US",
  "LKU": "KE",
  "LKV": "US",
  "LKW": "OM",
  "LKY": "TZ",
  "LKZ": "GB",
  "LLA": "SE",
  "LLE": "ZA",
  "LLF": "CN",
  "LLH": "HN",
  "LLI": "ET",
  "LLJ": "BD",
  "LLK": "AZ",
  "LLL": "AU",
  "LLM": "MY",
  "LLN": "ID",
  "LLS": "AR",
  "LLU": "GL",
  "LLW": "MW",
  "LLX": "US",
  "LLY": "US",
  "LMB": "MW",
  "LMC": "CO",
  "LMD": "AR",
  "LME": "FR",
  "LMI": "PG",
  "LML": "MH",
  "LMM": "MX",
  "LMN": "MY",
  "LMO": "GB",
  "LMP": "IT",
  "LMQ": "LY",
  "LMR": "ZA",
  "LMS": "US",
  "LMT": "US",
  "LMY": "PG",
  "LMZ": "MZ",
  "LNA": "US",
  "LNB": "VU",
  "LNC": "PG",
  "LND": "US",
  "LNE": "VU",
  "LNF": "PG",
  "LNG": "PG",
  "LNH": "AU",
  "LNI": "US",
  "LNJ": "CN",
  "LNK": "US",
  "LNM": "PG",
  "LNN": "US",
  "LNO": "AU",
  "LNP": "US",
  "LNQ": "PG",
  "LNR": "US",
  "LNS": "US",
  "LNV": "PG",
  "LNX": "RU",
  "LNY": "US",
  "LNZ": "AT",
  "LOA": "AU",
  "LOB": "CL",
  "LOC": "AU",
  "LOD": "VU",
  "LOE": "TH",
  "LOF": "MH",
  "LOH": "EC",
  "LOI": "BR",
  "LOK": "KE",
  "LOL": "US",
  "LOM": "MX",
  "LOO": "DZ",
  "LOP": "ID",
  "LOQ": "BW",
  "LOR": "US",
  "LOS": "NG",
  "LOT": "US",
  "LOU": "US",
  "LOV": "MX",
  "LOY": "KE",
  "LOZ": "US",
  "LPA": "ES",
  "LPB": "BO",
  "LPC": "US",
  "LPG": "AR",
  "LPI": "SE",
  "LPJ": "VE",
  "LPK": "RU",
  "LPL": "GB",
  "LPM": "VU",
  "LPN": "PG",
  "LPO": "US",
  "LPP": "FI",
  "LPQ": "LA",
  "LPS": "US",
  "LPT": "TH",
  "LPU": "ID",
  "LPY": "FR",
  "LQK": "US",
  "LQM": "CO",
  "LQN": "AF",
  "LRA": "GR",
  "LRB": "LS",
  "LRD": "US",
  "LRE": "AU",
  "LRF": "US",
  "LRG": "PK",
  "LRH": "FR",
  "LRJ": "US",
  "LRL": "TG",
  "LRM": "DO",
  "LRO": "US",
  "LRQ": "CA",
  "LRR": "IR",
  "LRS": "GR",
  "LRT": "FR",
  "LRU": "US",
  "LSA": "PG",
  "LSB": "US",
  "LSC": "CL",
  "LSE": "US",
  "LSF": "US",
  "LSH": "MM",
  "LSI": "GB",
  "LSJ": "PG",
  "LSL": "CR",
  "LSM": "MY",
  "LSN": "US",
  "LSO": "FR",
  "LSP": "VE",
  "LSQ": "CL",
  "LSS": "GP",
  "LST": "AU",
  "LSU": "MY",
  "LSV": "US",
  "LSW": "ID",
  "LSX": "ID",
  "LSY": "AU",
  "LSZ": "HR",
  "LTA": "ZA",
  "LTB": "AU",
  "LTC": "TD",
  "LTD": "LY",
  "LTF": "PG",
  "LTG": "NP",
  "LTH": "US",
  "LTI": "MN",
  "LTK": "SY",
  "LTL": "GA",
  "LTM": "GY",
  "LTN": "GB",
  "LTO": "MX",
  "LTP": "AU",
  "LTQ": "FR",
  "LTR": "IE",
  "LTS": "US",
  "LTT": "FR",
  "LTU": "IN",
  "LTV": "AU",
  "LTW": "US",
  "LTX": "EC",
  "LUA": "NP",
  "LUB": "GY",
  "LUC": "FJ",
  "LUD": "NA",
  "LUF": "US",
  "LUG": "CH",
  "LUH": "IN",
  "LUI": "HN",
  "LUJ": "ZA",
  "LUK": "US",
  "LUL": "US",
  "LUM": "CN",
  "LUN": "ZM",
  "LUO": "AO",
  "LUP": "US",
  "LUQ": "AR",
  "LUR": "US",
  "LUS": "CD",
  "LUT": "AU",
  "LUU": "AU",
  "LUV": "ID",
  "LUW": "ID",
  "LUX": "LU",
  "LUZ": "PL",
  "LVA": "FR",
  "LVD": "US",
  "LVI": "ZM",
  "LVK": "US",
  "LVL": "US",
  "LVM": "US",
  "LVO": "AU",
  "LVP": "IR",
  "LVR": "BR",
  "LVS": "US",
  "LWB": "US",
  "LWC": "US",
  "LWE": "ID",
  "LWH": "AU",
  "LWI": "PG",
  "LWK": "GB",
  "LWL": "US",
  "LWM": "US",
  "LWN": "AM",
  "LWO": "UA",
  "LWR": "NL",
  "LWS": "US",
  "LWT": "US",
  "LWV": "US",
  "LWY": "MY",
  "LXA": "CN",
  "LXG": "LA",
  "LXN": "US",
  "LXR": "EG",
  "LXS": "GR",
  "LXU": "ZM",
  "LXV": "US",
  "LYA": "CN",
  "LYB": "KY",
  "LYC": "SE",
  "LYE": "GB",
  "LYG": "CN",
  "LYH": "US",
  "LYI": "CN",
  "LYK": "ID",
  "LYN": "FR",
  "LYO": "US",
  "LYP": "PK",
  "LYR": "NO",
  "LYS": "FR",
  "LYT": "AU",
  "LYU": "US",
  "LYX": "GB",
  "LZA": "CD",
  "LZC": "MX",
  "LZH": "CN",
  "LZI": "CD",
  "LZM": "AO",
  "LZN": "TW",
  "LZO": "CN",
  "LZU": "US",
  "LZY": "CN",
  "MAA": "IN",
  "MAB": "BR",
  "MAC": "US",
  "MAD": "ES",
  "MAE": "US",
  "MAF": "US",
  "MAG": "PG",
  "MAH": "ES",
  "MAI": "MW",
  "MAJ": "MH",
  "MAM": "MX",
  "MAN": "GB",
  "MAO": "BR",
  "MAP": "PG",
  "MAQ": "TH",
  "MAR": "VE",
  "MAS": "PG",
  "MAT": "CD",
  "MAU": "PF",
  "MAV": "MH",
  "MAW": "US",
  "MAX": "SN",
  "MAY": "BS",
  "MAZ": "PR",
  "MBA": "KE",
  "MBB": "AU",
  "MBC": "GA",
  "MBD": "ZA",
  "MBE": "JP",
  "MBG": "US",
  "MBH": "AU",
  "MBI": "TZ",
  "MBJ": "JM",
  "MBK": "BR",
  "MBL": "US",
  "MBM": "ZA",
  "MBO": "PH",
  "MBP": "PE",
  "MBQ": "UG",
  "MBS": "US",
  "MBT": "PH",
  "MBU": "SB",
  "MBV": "PG",
  "MBW": "AU",
  "MBX": "SI",
  "MBY": "US",
  "MBZ": "BR",
  "MCB": "US",
  "MCC": "US",
  "MCD": "US",
  "MCE": "US",
  "MCF": "US",
  "MCG": "US",
  "MCH": "EC",
  "MCI": "US",
  "MCK": "US",
  "MCL": "US",
  "MCM": "MC",
  "MCN": "US",
  "MCO": "US",
  "MCP": "BR",
  "MCQ": "HU",
  "MCR": "GT",
  "MCS": "AR",
  "MCT": "OM",
  "MCU": "FR",
  "MCV": "AU",
  "MCW": "US",
  "MCX": "RU",
  "MCY": "AU",
  "MCZ": "BR",
  "MDA": "US",
  "MDB": "BZ",
  "MDC": "ID",
  "MDD": "US",
  "MDE": "CO",
  "MDF": "US",
  "MDG": "CN",
  "MDH": "US",
  "MDI": "NG",
  "MDJ": "US",
  "MDK": "CD",
  "MDL": "MM",
  "MDM": "PG",
  "MDN": "US",
  "MDP": "ID",
  "MDQ": "AR",
  "MDR": "US",
  "MDS": "TC",
  "MDT": "US",
  "MDU": "PG",
  "MDV": "GA",
  "MDW": "US",
  "MDX": "AR",
  "MDY": "UM",
  "MDZ": "AR",
  "MEB": "AU",
  "MEC": "EC",
  "MED": "SA",
  "MEE": "NC",
  "MEF": "TD",
  "MEG": "AO",
  "MEH": "NO",
  "MEI": "US",
  "MEJ": "US",
  "MEK": "MA",
  "MEL": "AU",
  "MEM": "US",
  "MEN": "FR",
  "MEO": "US",
  "MEP": "MY",
  "MEQ": "ID",
  "MET": "AU",
  "MEU": "BR",
  "MEV": "US",
  "MEW": "CD",
  "MEX": "MX",
  "MEY": "NP",
  "MFA": "TZ",
  "MFB": "CO",
  "MFC": "LS",
  "MFD": "US",
  "MFE": "US",
  "MFF": "GA",
  "MFG": "PK",
  "MFH": "US",
  "MFI": "US",
  "MFJ": "FJ",
  "MFK": "TW",
  "MFL": "AU",
  "MFM": "MO",
  "MFN": "NZ",
  "MFO": "PG",
  "MFP": "AU",
  "MFQ": "NE",
  "MFR": "US",
  "MFS": "CO",
  "MFT": "PE",
  "MFU": "ZM",
  "MFV": "US",
  "MFW": "MZ",
  "MFX": "FR",
  "MGA": "NI",
  "MGB": "AU",
  "MGC": "US",
  "MGD": "BO",
  "MGE": "US",
  "MGF": "BR",
  "MGG": "PG",
  "MGH": "ZA",
  "MGI": "US",
  "MGJ": "US",
  "MGK": "MM",
  "MGL": "DE",
  "MGM": "US",
  "MGN": "CO",
  "MGP": "PG",
  "MGQ": "SO",
  "MGR": "US",
  "MGS": "CK",
  "MGT": "AU",
  "MGU": "MM",
  "MGV": "AU",
  "MGW": "US",
  "MGX": "GA",
  "MGY": "US",
  "MGZ": "MM",
  "MHA": "GY",
  "MHB": "NZ",
  "MHC": "CL",
  "MHD": "IR",
  "MHE": "US",
  "MHF": "CO",
  "MHG": "DE",
  "MHH": "BS",
  "MHI": "DJ",
  "MHK": "US",
  "MHN": "US",
  "MHO": "AU",
  "MHP": "BY",
  "MHQ": "FI",
  "MHR": "US",
  "MHS": "US",
  "MHT": "US",
  "MHU": "AU",
  "MHV": "US",
  "MHW": "BO",
  "MHX": "CK",
  "MHY": "PG",
  "MHZ": "GB",
  "MIA": "US",
  "MID": "MX",
  "MIE": "US",
  "MIF": "US",
  "MIG": "CN",
  "MIH": "AU",
  "MII": "BR",
  "MIJ": "MH",
  "MIK": "FI",
  "MIM": "AU",
  "MIN": "AU",
  "MIP": "IL",
  "MIR": "TN",
  "MIS": "PG",
  "MIU": "NG",
  "MIY": "AU",
  "MIZ": "AU",
  "MJA": "MG",
  "MJB": "MH",
  "MJC": "CI",
  "MJD": "PK",
  "MJE": "MH",
  "MJF": "NO",
  "MJI": "LY",
  "MJJ": "PG",
  "MJM": "CD",
  "MJN": "MG",
  "MJO": "NA",
  "MJP": "AU",
  "MJR": "AR",
  "MJS": "MZ",
  "MJT": "GR",
  "MJU": "ID",
  "MJV": "ES",
  "MJW": "ZW",
  "MJY": "ID",
  "MJZ": "RU",
  "MKA": "CZ",
  "MKB": "GA",
  "MKC": "US",
  "MKE": "US",
  "MKG": "US",
  "MKH": "LS",
  "MKI": "CF",
  "MKJ": "CG",
  "MKK": "US",
  "MKL": "US",
  "MKM": "MY",
  "MKN": "PG",
  "MKP": "PF",
  "MKQ": "ID",
  "MKR": "AU",
  "MKS": "ET",
  "MKU": "GA",
  "MKV": "AU",
  "MKW": "ID",
  "MKY": "AU",
  "MKZ": "MY",
  "MLA": "MT",
  "MLB": "US",
  "MLE": "MV",
  "MLG": "ID",
  "MLH": "FR",
  "MLI": "US",
  "MLK": "US",
  "MLL": "US",
  "MLM": "MX",
  "MLN": "ES",
  "MLO": "GR",
  "MLP": "PH",
  "MLQ": "PG",
  "MLR": "AU",
  "MLS": "US",
  "MLU": "US",
  "MLV": "AU",
  "MLW": "LR",
  "MLX": "TR",
  "MLY": "US",
  "MLZ": "UY",
  "MMB": "JP",
  "MMC": "MX",
  "MME": "GB",
  "MMF": "CM",
  "MMG": "AU",
  "MMH": "US",
  "MMI": "US",
  "MMJ": "JP",
  "MMK": "RU",
  "MML": "US",
  "MMM": "AU",
  "MMO": "CV",
  "MMP": "CO",
  "MMQ": "ZM",
  "MMS": "US",
  "MMT": "US",
  "MMU": "US",
  "MMV": "PG",
  "MMX": "SE",
  "MMY": "JP",
  "MMZ": "AF",
  "MNA": "ID",
  "MNB": "CD",
  "MNC": "MZ",
  "MND": "CO",
  "MNE": "AU",
  "MNF": "FJ",
  "MNG": "AU",
  "MNJ": "MG",
  "MNK": "KI",
  "MNL": "PH",
  "MNN": "US",
  "MNO": "CD",
  "MNP": "PG",
  "MNQ": "AU",
  "MNR": "ZM",
  "MNT": "US",
  "MNU": "MM",
  "MNW": "AU",
  "MNX": "BR",
  "MNY": "SB",
  "MNZ": "US",
  "MOA": "CU",
  "MOB": "US",
  "MOC": "BR",
  "MOD": "US",
  "MOE": "MM",
  "MOF": "ID",
  "MOG": "MM",
  "MOI": "CK",
  "MOJ": "SR",
  "MOL": "NO",
  "MOM": "MR",
  "MON": "NZ",
  "MOO": "AU",
  "MOQ": "MG",
  "MOT": "US",
  "MOU": "US",
  "MOV": "AU",
  "MOZ": "PF",
  "MPA": "NA",
  "MPC": "ID",
  "MPE": "US",
  "MPF": "PG",
  "MPG": "PG",
  "MPH": "PH",
  "MPI": "PA",
  "MPL": "FR",
  "MPM": "MZ",
  "MPN": "FK",
  "MPP": "PA",
  "MPT": "TL",
  "MPU": "PG",
  "MPV": "US",
  "MPW": "UA",
  "MPX": "PG",
  "MPY": "GF",
  "MPZ": "US",
  "MQA": "AU",
  "MQB": "US",
  "MQC": "PM",
  "MQD": "AR",
  "MQE": "AU",
  "MQF": "RU",
  "MQG": "NA",
  "MQH": "BR",
  "MQJ": "TR",
  "MQK": "BO",
  "MQL": "AU",
  "MQM": "TR",
  "MQN": "NO",
  "MQO": "PG",
  "MQP": "ZA",
  "MQQ": "TD",
  "MQS": "VC",
  "MQT": "US",
  "MQX": "ET",
  "MQY": "US",
  "MQZ": "AU",
  "MRA": "LY",
  "MRB": "US",
  "MRC": "US",
  "MRD": "VE",
  "MRE": "KE",
  "MRF": "US",
  "MRG": "AU",
  "MRI": "US",
  "MRJ": "HN",
  "MRK": "US",
  "MRM": "PG",
  "MRO": "NZ",
  "MRP": "AU",
  "MRQ": "PH",
  "MRR": "EC",
  "MRS": "FR",
  "MRU": "MU",
  "MRV": "RU",
  "MRW": "DK",
  "MRX": "IR",
  "MRY": "US",
  "MRZ": "AU",
  "MSA": "CA",
  "MSB": "GP",
  "MSC": "US",
  "MSE": "GB",
  "MSH": "OM",
  "MSJ": "JP",
  "MSL": "US",
  "MSM": "CD",
  "MSN": "US",
  "MSO": "US",
  "MSP": "US",
  "MSQ": "BY",
  "MSR": "TR",
  "MSS": "US",
  "MST": "NL",
  "MSU": "LS",
  "MSW": "ER",
  "MSX": "CG",
  "MSY": "US",
  "MSZ": "AO",
  "MTA": "NZ",
  "MTB": "CO",
  "MTD": "AU",
  "MTE": "BR",
  "MTF": "ET",
  "MTG": "BR",
  "MTI": "CV",
  "MTJ": "US",
  "MTL": "AU",
  "MTQ": "AU",
  "MTR": "CO",
  "MTS": "SZ",
  "MTT": "MX",
  "MTU": "MZ",
  "MTV": "VU",
  "MTW": "ID",
  "MTX": "US",
  "MTY": "MX",
  "MTZ": "IL",
  "MUA": "SB",
  "MUB": "BW",
  "MUC": "DE",
  "MUD": "MZ",
  "MUE": "US",
  "MUF": "ID",
  "MUG": "MX",
  "MUH": "EG",
  "MUJ": "ET",
  "MUK": "CK",
  "MUM": "KE",
  "MUN": "VE",
  "MUO": "US",
  "MUQ": "AU",
  "MUR": "MY",
  "MUW": "DZ",
  "MUX": "PK",
  "MUY": "CG",
  "MUZ": "TZ",
  "MVA": "IS",
  "MVB": "GA",
  "MVC": "US",
  "MVD": "UY",
  "MVF": "BR",
  "MVI": "PG",
  "MVJ": "JM",
  "MVK": "AU",
  "MVL": "US",
  "MVO": "TD",
  "MVP": "CO",
  "MVR": "CM",
  "MVS": "BR",
  "MVT": "PF",
  "MVU": "AU",
  "MVV": "FR",
  "MVW": "US",
  "MVX": "GA",
  "MVY": "US",
  "MVZ": "ZW",
  "MWA": "US",
  "MWB": "AU",
  "MWD": "PK",
  "MWF": "VU",
  "MWG": "PG",
  "MWH": "US",
  "MWI": "PG",
  "MWJ": "GY",
  "MWK": "ID",
  "MWL": "US",
  "MWN": "TZ",
  "MWP": "NP",
  "MWQ": "MM",
  "MWT": "AU",
  "MWX": "KR",
  "MWY": "AU",
  "MWZ": "TZ",
  "MXB": "ID",
  "MXC": "US",
  "MXD": "AU",
  "MXH": "PG",
  "MXI": "PH",
  "MXJ": "NG",
  "MXK": "PG",
  "MXL": "MX",
  "MXM": "MG",
  "MXN": "FR",
  "MXP": "IT",
  "MXS": "WS",
  "MXT": "MG",
  "MXU": "AU",
  "MXV": "MN",
  "MXW": "MN",
  "MXX": "SE",
  "MXY": "US",
  "MXZ": "CN",
  "MYA": "AU",
  "MYB": "GA",
  "MYC": "VE",
  "MYD": "KE",
  "MYE": "JP",
  "MYF": "US",
  "MYG": "BS",
  "MYI": "AU",
  "MYJ": "JP",
  "MYK": "US",
  "MYL": "US",
  "MYM": "GY",
  "MYN": "YE",
  "MYO": "AU",
  "MYP": "TM",
  "MYQ": "IN",
  "MYR": "US",
  "MYS": "ET",
  "MYT": "MM",
  "MYU": "US",
  "MYV": "US",
  "MYW": "TZ",
  "MYX": "PG",
  "MYY": "MY",
  "MYZ": "MW",
  "MZB": "MZ",
  "MZD": "EC",
  "MZE": "BZ",
  "MZG": "TW",
  "MZH": "TR",
  "MZJ": "US",
  "MZK": "KI",
  "MZL": "CO",
  "MZM": "FR",
  "MZO": "CU",
  "MZP": "NZ",
  "MZQ": "ZA",
  "MZR": "AF",
  "MZS": "MY",
  "MZT": "MX",
  "MZU": "IN",
  "MZV": "MY",
  "MZW": "DZ",
  "MZY": "ZA",
  "MZZ": "US",
  "NAA": "AU",
  "NAC": "AU",
  "NAD": "CO",
  "NAE": "BJ",
  "NAF": "ID",
  "NAG": "IN",
  "NAH": "ID",
  "NAI": "GY",
  "NAJ": "AZ",
  "NAK": "TH",
  "NAL": "RU",
  "NAM": "ID",
  "NAN": "FJ",
  "NAO": "CN",
  "NAP": "IT",
  "NAQ": "GL",
  "NAR": "CO",
  "NAS": "BS",
  "NAT": "BR",
  "NAU": "PF",
  "NAV": "TR",
  "NAW": "TH",
  "NAY": "CN",
  "NAZ": "SB",
  "NBA": "PG",
  "NBB": "CO",
  "NBC": "RU",
  "NBE": "TN",
  "NBG": "US",
  "NBH": "AU",
  "NBL": "PA",
  "NBO": "KE",
  "NBS": "CN",
  "NBW": "CU",
  "NBX": "ID",
  "NCA": "TC",
  "NCE": "FR",
  "NCG": "MX",
  "NCH": "TZ",
  "NCI": "CO",
  "NCJ": "AR",
  "NCL": "GB",
  "NCN": "US",
  "NCR": "NI",
  "NCS": "ZA",
  "NCU": "UZ",
  "NCY": "FR",
  "NDA": "ID",
  "NDB": "MR",
  "NDC": "IN",
  "NDD": "AO",
  "NDE": "KE",
  "NDF": "AO",
  "NDG": "CN",
  "NDI": "PG",
  "NDJ": "TD",
  "NDK": "MH",
  "NDL": "CF",
  "NDM": "ET",
  "NDN": "PG",
  "NDR": "MA",
  "NDS": "AU",
  "NDU": "NA",
  "NDY": "GB",
  "NDZ": "DE",
  "NEC": "AR",
  "NEF": "RU",
  "NEG": "JM",
  "NEJ": "ET",
  "NEK": "ET",
  "NEN": "US",
  "NER": "RU",
  "NEU": "LA",
  "NEV": "KN",
  "NEW": "US",
  "NFG": "RU",
  "NFL": "US",
  "NFO": "TO",
  "NGA": "AU",
  "NGB": "CN",
  "NGD": "VG",
  "NGE": "CM",
  "NGI": "FJ",
  "NGL": "ZA",
  "NGO": "JP",
  "NGQ": "CN",
  "NGS": "JP",
  "NGX": "NP",
  "NGZ": "US",
  "NHA": "VN",
  "NHD": "AE",
  "NHF": "SD",
  "NHT": "GB",
  "NHV": "PF",
  "NHX": "US",
  "NIA": "LR",
  "NIC": "CY",
  "NIF": "AU",
  "NIG": "KI",
  "NIM": "NE",
  "NIO": "CD",
  "NIS": "PG",
  "NIT": "FR",
  "NIX": "ML",
  "NJA": "JP",
  "NJC": "RU",
  "NJF": "IQ",
  "NKB": "AU",
  "NKC": "MR",
  "NKD": "ID",
  "NKG": "CN",
  "NKI": "US",
  "NKM": "JP",
  "NKN": "PG",
  "NKS": "CM",
  "NKU": "LS",
  "NKW": "IO",
  "NKX": "US",
  "NKY": "CG",
  "NLA": "ZM",
  "NLC": "US",
  "NLD": "MX",
  "NLE": "US",
  "NLF": "AU",
  "NLG": "US",
  "NLK": "NF",
  "NLL": "AU",
  "NLO": "CD",
  "NLP": "ZA",
  "NLS": "AU",
  "NLU": "MX",
  "NLV": "UA",
  "NMA": "UZ",
  "NMB": "IN",
  "NMC": "BS",
  "NME": "US",
  "NMG": "PA",
  "NML": "CA",
  "NMN": "PG",
  "NMP": "AU",
  "NMR": "AU",
  "NMS": "MM",
  "NMT": "MM",
  "NNA": "MA",
  "NNB": "SB",
  "NND": "MZ",
  "NNG": "CN",
  "NNI": "NA",
  "NNK": "US",
  "NNL": "US",
  "NNM": "RU",
  "NNR": "IE",
  "NNT": "TH",
  "NNU": "BR",
  "NNX": "ID",
  "NNY": "CN",
  "NOA": "AU",
  "NOB": "CR",
  "NOC": "IE",
  "NOD": "DE",
  "NOG": "MX",
  "NOJ": "RU",
  "NOK": "BR",
  "NON": "KI",
  "NOO": "PG",
  "NOR": "IS",
  "NOS": "MG",
  "NOT": "US",
  "NOU": "NC",
  "NOV": "AO",
  "NOZ": "RU",
  "NPA": "US",
  "NPE": "NZ",
  "NPG": "PG",
  "NPH": "US",
  "NPL": "NZ",
  "NPP": "AU",
  "NPU": "CO",
  "NQA": "US",
  "NQI": "US",
  "NQL": "BR",
  "NQN": "AR",
  "NQT": "GB",
  "NQU": "CO",
  "NQX": "US",
  "NQY": "GB",
  "NRA": "AU",
  "NRB": "US",
  "NRC": "US",
  "NRD": "DE",
  "NRE": "ID",
  "NRG": "AU",
  "NRI": "US",
  "NRK": "SE",
  "NRL": "GB",
  "NRN": "DE",
  "NRT": "JP",
  "NRY": "AU",
  "NSB": "BS",
  "NSE": "US",
  "NSH": "IR",
  "NSI": "CM",
  "NSK": "RU",
  "NSM": "AU",
  "NSN": "NZ",
  "NSO": "AU",
  "NSP": "PH",
  "NST": "TH",
  "NTA": "FJ",
  "NTB": "NO",
  "NTC": "MZ",
  "NTD": "US",
  "NTE": "FR",
  "NTG": "CN",
  "NTJ": "US",
  "NTL": "AU",
  "NTN": "AU",
  "NTO": "CV",
  "NTQ": "JP",
  "NTR": "MX",
  "NTT": "TO",
  "NTX": "ID",
  "NTY": "ZA",
  "NUB": "AU",
  "NUE": "DE",
  "NUG": "PG",
  "NUI": "US",
  "NUK": "PF",
  "NUL": "US",
  "NUP": "US",
  "NUR": "AU",
  "NUS": "VU",
  "NUU": "KE",
  "NUX": "RU",
  "NVA": "CO",
  "NVG": "NI",
  "NVI": "UZ",
  "NVJ": "MX",
  "NVK": "NO",
  "NVN": "US",
  "NVP": "BR",
  "NVR": "RU",
  "NVS": "FR",
  "NVT": "BR",
  "NVY": "IN",
  "NWA": "KM",
  "NWI": "GB",
  "NYA": "RU",
  "NYE": "KE",
  "NYI": "GH",
  "NYK": "KE",
  "NYM": "RU",
  "NYN": "AU",
  "NYO": "SE",
  "NYT": "MM",
  "NZC": "PE",
  "NZY": "US",
  "OAA": "AF",
  "OAG": "AU",
  "OAH": "AF",
  "OAI": "AF",
  "OAJ": "US",
  "OAK": "US",
  "OAL": "BR",
  "OAM": "NZ",
  "OAN": "HN",
  "OAR": "US",
  "OAS": "AF",
  "OAX": "MX",
  "OAZ": "AF",
  "OBC": "DJ",
  "OBD": "ID",
  "OBF": "DE",
  "OBK": "US",
  "OBL": "BE",
  "OBM": "PG",
  "OBN": "GB",
  "OBO": "JP",
  "OBS": "FR",
  "OBU": "US",
  "OBX": "PG",
  "OBY": "GL",
  "OCA": "US",
  "OCC": "EC",
  "OCE": "US",
  "OCF": "US",
  "OCH": "US",
  "OCJ": "JM",
  "OCN": "US",
  "OCV": "CO",
  "OCW": "US",
  "ODA": "CF",
  "ODB": "ES",
  "ODC": "US",
  "ODD": "AU",
  "ODE": "DK",
  "ODH": "GB",
  "ODJ": "CF",
  "ODN": "MY",
  "ODO": "RU",
  "ODR": "AU",
  "ODS": "UA",
  "ODW": "US",
  "ODY": "LA",
  "OEA": "US",
  "OEC": "TL",
  "OEL": "RU",
  "OEM": "SR",
  "OEO": "US",
  "OER": "SE",
  "OES": "AR",
  "OFI": "CI",
  "OFJ": "IS",
  "OFK": "US",
  "OFU": "AS",
  "OGA": "US",
  "OGB": "US",
  "OGD": "US",
  "OGE": "PG",
  "OGG": "US",
  "OGL": "GY",
  "OGN": "JP",
  "OGO": "CI",
  "OGR": "TD",
  "OGS": "US",
  "OGU": "TR",
  "OGX": "DZ",
  "OGZ": "RU",
  "OHA": "NZ",
  "OHD": "MK",
  "OHE": "CN",
  "OHH": "RU",
  "OHI": "NA",
  "OHO": "RU",
  "OHR": "DE",
  "OHT": "PK",
  "OIA": "BR",
  "OIC": "US",
  "OIL": "US",
  "OIM": "JP",
  "OIR": "JP",
  "OIT": "JP",
  "OJC": "US",
  "OKA": "JP",
  "OKC": "US",
  "OKD": "JP",
  "OKE": "JP",
  "OKF": "NA",
  "OKG": "CG",
  "OKH": "GB",
  "OKI": "JP",
  "OKJ": "JP",
  "OKK": "US",
  "OKL": "ID",
  "OKM": "US",
  "OKN": "GA",
  "OKP": "PG",
  "OKQ": "ID",
  "OKR": "AU",
  "OKS": "US",
  "OKT": "RU",
  "OKU": "NA",
  "OKV": "PG",
  "OKY": "AU",
  "OLA": "NO",
  "OLB": "IT",
  "OLD": "US",
  "OLI": "IS",
  "OLJ": "VU",
  "OLK": "PY",
  "OLM": "US",
  "OLN": "AR",
  "OLO": "CZ",
  "OLP": "AU",
  "OLQ": "PG",
  "OLR": "AF",
  "OLV": "US",
  "OMA": "US",
  "OMB": "GA",
  "OMC": "PH",
  "OMD": "NA",
  "OME": "US",
  "OMF": "JO",
  "OMG": "NA",
  "OMH": "IR",
  "OMI": "IR",
  "OMK": "US",
  "OML": "PG",
  "OMM": "OM",
  "OMN": "IN",
  "OMO": "BA",
  "OMR": "RO",
  "OMS": "RU",
  "OMY": "KH",
  "ONB": "PG",
  "OND": "NA",
  "ONG": "AU",
  "ONI": "ID",
  "ONJ": "JP",
  "ONO": "US",
  "ONQ": "TR",
  "ONR": "AU",
  "ONS": "AU",
  "ONT": "US",
  "ONX": "PA",
  "OOK": "US",
  "OOL": "AU",
  "OOM": "AU",
  "OOR": "AU",
  "OOT": "KI",
  "OOX": "UA",
  "OPA": "IS",
  "OPI": "AU",
  "OPO": "PT",
  "OPS": "BR",
  "OPU": "PG",
  "OPW": "NA",
  "ORA": "AR",
  "ORB": "SE",
  "ORC": "CO",
  "ORD": "US",
  "ORE": "FR",
  "ORF": "US",
  "ORH": "US",
  "ORI": "US",
  "ORJ": "GY",
  "ORK": "IE",
  "ORM": "GB",
  "ORN": "DZ",
  "ORO": "HN",
  "ORP": "BW",
  "ORR": "AU",
  "ORT": "US",
  "ORU": "BO",
  "ORV": "US",
  "ORW": "PK",
  "ORX": "BR",
  "ORY": "FR",
  "ORZ": "BZ",
  "OSB": "IQ",
  "OSD": "SE",
  "OSE": "PG",
  "OSG": "PG",
  "OSH": "US",
  "OSI": "HR",
  "OSL": "NO",
  "OSN": "KR",
  "OSR": "CZ",
  "OSS": "KG",
  "OST": "BE",
  "OSU": "US",
  "OSW": "RU",
  "OSY": "NO",
  "OTC": "TD",
  "OTD": "PA",
  "OTH": "US",
  "OTI": "ID",
  "OTJ": "NA",
  "OTK": "US",
  "OTL": "MR",
  "OTM": "US",
  "OTN": "US",
  "OTP": "RO",
  "OTR": "CR",
  "OTT": "BR",
  "OTU": "CO",
  "OTV": "SB",
  "OTZ": "US",
  "OUA": "BF",
  "OUD": "MA",
  "OUE": "CG",
  "OUG": "BF",
  "OUH": "ZA",
  "OUK": "GB",
  "OUL": "FI",
  "OUM": "TD",
  "OUN": "US",
  "OUR": "CM",
  "OUS": "BR",
  "OUT": "TD",
  "OUZ": "MR",
  "OVA": "MG",
  "OVB": "RU",
  "OVD": "ES",
  "OVE": "US",
  "OVG": "ZA",
  "OVL": "CL",
  "OVR": "AR",
  "OVS": "RU",
  "OWA": "US",
  "OWB": "US",
  "OWK": "US",
  "OXB": "GW",
  "OXC": "US",
  "OXD": "US",
  "OXF": "GB",
  "OXO": "AU",
  "OXP": "GF",
  "OXR": "US",
  "OXY": "AU",
  "OYA": "AR",
  "OYE": "GA",
  "OYK": "BR",
  "OYO": "AR",
  "OYP": "GF",
  "OZA": "US",
  "OZC": "PH",
  "OZG": "MA",
  "OZH": "UA",
  "OZP": "ES",
  "OZR": "US",
  "OZZ": "MA",
  "PAA": "MM",
  "PAB": "IN",
  "PAC": "PA",
  "PAD": "DE",
  "PAE": "US",
  "PAF": "UG",
  "PAG": "PH",
  "PAH": "US",
  "PAJ": "PK",
  "PAK": "US",
  "PAL": "CO",
  "PAM": "US",
  "PAN": "TH",
  "PAO": "US",
  "PAP": "HT",
  "PAQ": "US",
  "PAS": "GR",
  "PAT": "IN",
  "PAU": "MM",
  "PAV": "BR",
  "PAX": "HT",
  "PAY": "MY",
  "PAZ": "MX",
  "PBB": "BR",
  "PBC": "MX",
  "PBD": "IN",
  "PBE": "CO",
  "PBF": "US",
  "PBG": "US",
  "PBH": "BT",
  "PBI": "US",
  "PBJ": "VU",
  "PBL": "VE",
  "PBM": "SR",
  "PBN": "AO",
  "PBO": "AU",
  "PBP": "CR",
  "PBQ": "BR",
  "PBR": "GT",
  "PBT": "PY",
  "PBU": "MM",
  "PBX": "BR",
  "PBZ": "ZA",
  "PCA": "US",
  "PCB": "ID",
  "PCC": "CO",
  "PCD": "US",
  "PCG": "GT",
  "PCH": "HN",
  "PCJ": "PY",
  "PCL": "PE",
  "PCM": "MX",
  "PCN": "NZ",
  "PCP": "ST",
  "PCQ": "LA",
  "PCR": "CO",
  "PCS": "BR",
  "PCT": "US",
  "PCU": "US",
  "PCV": "MX",
  "PDA": "CO",
  "PDB": "US",
  "PDC": "NC",
  "PDE": "AU",
  "PDF": "BR",
  "PDG": "ID",
  "PDI": "PG",
  "PDK": "US",
  "PDL": "PT",
  "PDN": "AU",
  "PDO": "ID",
  "PDP": "UY",
  "PDR": "BR",
  "PDS": "MX",
  "PDT": "US",
  "PDU": "UY",
  "PDV": "BG",
  "PDX": "US",
  "PDZ": "VE",
  "PEA": "AU",
  "PEC": "US",
  "PED": "CZ",
  "PEE": "RU",
  "PEF": "DE",
  "PEG": "IT",
  "PEH": "AR",
  "PEI": "CO",
  "PEK": "CN",
  "PEL": "LS",
  "PEM": "PE",
  "PEN": "MY",
  "PEP": "AU",
  "PEQ": "US",
  "PER": "AU",
  "PES": "RU",
  "PET": "BR",
  "PEU": "HN",
  "PEV": "HU",
  "PEW": "PK",
  "PEX": "RU",
  "PEY": "AU",
  "PEZ": "RU",
  "PFB": "BR",
  "PFC": "US",
  "PFN": "US",
  "PFO": "CY",
  "PFQ": "IR",
  "PFR": "CD",
  "PGA": "US",
  "PGB": "PG",
  "PGC": "US",
  "PGD": "US",
  "PGE": "PG",
  "PGF": "FR",
  "PGH": "IN",
  "PGI": "AO",
  "PGK": "ID",
  "PGL": "US",
  "PGM": "US",
  "PGN": "PG",
  "PGO": "US",
  "PGR": "US",
  "PGV": "US",
  "PGX": "FR",
  "PGZ": "BR",
  "PHB": "BR",
  "PHC": "NG",
  "PHD": "US",
  "PHE": "AU",
  "PHF": "US",
  "PHG": "NG",
  "PHH": "VN",
  "PHI": "BR",
  "PHK": "US",
  "PHL": "US",
  "PHN": "US",
  "PHO": "US",
  "PHP": "US",
  "PHQ": "AU",
  "PHS": "TH",
  "PHT": "US",
  "PHW": "ZA",
  "PHX": "US",
  "PHY": "TH",
  "PIA": "US",
  "PIB": "US",
  "PIC": "TC",
  "PID": "BS",
  "PIE": "US",
  "PIF": "TW",
  "PIH": "US",
  "PIK": "GB",
  "PIL": "PY",
  "PIM": "US",
  "PIN": "BR",
  "PIO": "PE",
  "PIP": "US",
  "PIR": "US",
  "PIS": "FR",
  "PIT": "US",
  "PIU": "PE",
  "PIW": "CA",
  "PIX": "PT",
  "PIZ": "US",
  "PJA": "SE",
  "PJB": "US",
  "PJC": "PY",
  "PJG": "PK",
  "PJM": "CR",
  "PKA": "US",
  "PKB": "US",
  "PKC": "RU",
  "PKD": "US",
  "PKE": "AU",
  "PKF": "US",
  "PKG": "MY",
  "PKH": "GR",
  "PKJ": "GT",
  "PKK": "MM",
  "PKN": "ID",
  "PKO": "BJ",
  "PKP": "PF",
  "PKR": "NP",
  "PKT": "AU",
  "PKU": "ID",
  "PKV": "RU",
  "PKW": "BW",
  "PKY": "ID",
  "PKZ": "LA",
  "PLB": "US",
  "PLD": "CR",
  "PLE": "PG",
  "PLF": "TD",
  "PLH": "GB",
  "PLJ": "BZ",
  "PLK": "US",
  "PLL": "BR",
  "PLM": "ID",
  "PLN": "US",
  "PLO": "AU",
  "PLP": "PA",
  "PLQ": "LT",
  "PLR": "US",
  "PLS": "TC",
  "PLT": "CO",
  "PLU": "BR",
  "PLV": "UA",
  "PLW": "ID",
  "PLX": "KZ",
  "PLY": "US",
  "PLZ": "ZA",
  "PMA": "TZ",
  "PMC": "CL",
  "PMD": "US",
  "PME": "GB",
  "PMF": "IT",
  "PMG": "BR",
  "PMH": "US",
  "PMI": "ES",
  "PMK": "AU",
  "PML": "US",
  "PMM": "TH",
  "PMN": "PG",
  "PMO": "IT",
  "PMP": "PG",
  "PMQ": "AR",
  "PMR": "NZ",
  "PMS": "SY",
  "PMT": "GY",
  "PMV": "VE",
  "PMW": "BR",
  "PMX": "US",
  "PMY": "AR",
  "PMZ": "CR",
  "PNA": "ES",
  "PNB": "BR",
  "PNC": "US",
  "PND": "BZ",
  "PNE": "US",
  "PNG": "BR",
  "PNH": "KH",
  "PNI": "FM",
  "PNK": "ID",
  "PNL": "IT",
  "PNO": "MX",
  "PNP": "PG",
  "PNQ": "IN",
  "PNR": "CG",
  "PNS": "US",
  "PNT": "CL",
  "PNU": "US",
  "PNV": "LT",
  "PNX": "US",
  "PNY": "IN",
  "PNZ": "BR",
  "POA": "BR",
  "POB": "US",
  "POC": "US",
  "POD": "SN",
  "POE": "US",
  "POF": "US",
  "POG": "GA",
  "POI": "BO",
  "POJ": "BR",
  "POL": "MZ",
  "POM": "PG",
  "PON": "GT",
  "POO": "BR",
  "POP": "DO",
  "POR": "FI",
  "POS": "TT",
  "POT": "JM",
  "POU": "US",
  "POV": "SK",
  "POW": "SI",
  "POX": "FR",
  "POY": "US",
  "POZ": "PL",
  "PPA": "US",
  "PPB": "BR",
  "PPC": "US",
  "PPD": "PR",
  "PPE": "MX",
  "PPF": "US",
  "PPG": "AS",
  "PPH": "VE",
  "PPI": "AU",
  "PPK": "KZ",
  "PPL": "NP",
  "PPM": "US",
  "PPN": "CO",
  "PPP": "AU",
  "PPQ": "NZ",
  "PPS": "PH",
  "PPT": "PF",
  "PPU": "MM",
  "PPV": "US",
  "PPW": "GB",
  "PPX": "PG",
  "PPY": "BR",
  "PPZ": "VE",
  "PQC": "VN",
  "PQD": "LK",
  "PQE": "CO",
  "PQI": "US",
  "PQM": "MX",
  "PQQ": "AU",
  "PRA": "AR",
  "PRB": "US",
  "PRC": "US",
  "PRD": "AU",
  "PRE": "CO",
  "PRG": "CZ",
  "PRH": "TH",
  "PRI": "SC",
  "PRK": "ZA",
  "PRM": "PT",
  "PRN": "XK",
  "PRO": "US",
  "PRP": "FR",
  "PRQ": "AR",
  "PRR": "GY",
  "PRS": "SB",
  "PRU": "MM",
  "PRW": "US",
  "PRX": "US",
  "PRY": "ZA",
  "PRZ": "US",
  "PSA": "IT",
  "PSC": "US",
  "PSD": "EG",
  "PSE": "PR",
  "PSG": "US",
  "PSH": "DE",
  "PSI": "PK",
  "PSJ": "ID",
  "PSK": "US",
  "PSL": "GB",
  "PSM": "US",
  "PSN": "US",
  "PSO": "CO",
  "PSP": "US",
  "PSR": "IT",
  "PSS": "AR",
  "PST": "CU",
  "PSU": "ID",
  "PSW": "BR",
  "PSX": "US",
  "PSZ": "BO",
  "PTA": "US",
  "PTB": "US",
  "PTC": "US",
  "PTD": "US",
  "PTF": "FJ",
  "PTG": "ZA",
  "PTH": "US",
  "PTJ": "AU",
  "PTK": "US",
  "PTM": "VE",
  "PTN": "US",
  "PTO": "BR",
  "PTP": "GP",
  "PTQ": "BR",
  "PTT": "US",
  "PTU": "US",
  "PTV": "US",
  "PTX": "CO",
  "PTY": "PA",
  "PTZ": "EC",
  "PUA": "PG",
  "PUB": "US",
  "PUC": "US",
  "PUD": "AR",
  "PUE": "PA",
  "PUF": "FR",
  "PUG": "AU",
  "PUI": "PG",
  "PUJ": "DO",
  "PUK": "PF",
  "PUL": "US",
  "PUM": "ID",
  "PUN": "CD",
  "PUP": "BF",
  "PUQ": "CL",
  "PUR": "BO",
  "PUS": "KR",
  "PUT": "IN",
  "PUU": "CO",
  "PUV": "NC",
  "PUW": "US",
  "PUX": "CL",
  "PUY": "HR",
  "PUZ": "NI",
  "PVA": "CO",
  "PVC": "US",
  "PVD": "US",
  "PVE": "PA",
  "PVF": "US",
  "PVG": "CN",
  "PVH": "BR",
  "PVI": "BR",
  "PVK": "GR",
  "PVN": "BG",
  "PVO": "EC",
  "PVR": "MX",
  "PVS": "RU",
  "PVU": "US",
  "PVW": "US",
  "PVZ": "US",
  "PWA": "US",
  "PWD": "US",
  "PWE": "RU",
  "PWI": "ET",
  "PWK": "US",
  "PWL": "ID",
  "PWM": "US",
  "PWN": "BS",
  "PWO": "CD",
  "PWQ": "KZ",
  "PWR": "US",
  "PWT": "US",
  "PXL": "US",
  "PXM": "MX",
  "PXO": "PT",
  "PXU": "VN",
  "PYA": "CO",
  "PYB": "IN",
  "PYC": "PA",
  "PYE": "CK",
  "PYH": "VE",
  "PYJ": "RU",
  "PYL": "US",
  "PYO": "EC",
  "PYV": "PA",
  "PYX": "TH",
  "PZA": "CO",
  "PZB": "ZA",
  "PZE": "GB",
  "PZH": "PK",
  "PZI": "CN",
  "PZK": "CK",
  "PZL": "ZA",
  "PZO": "VE",
  "PZU": "SD",
  "QAC": "BR",
  "QAK": "BR",
  "QAM": "FR",
  "QAQ": "IT",
  "QAR": "NL",
  "QBC": "CA",
  "QBQ": "FR",
  "QBX": "BR",
  "QCH": "BR",
  "QCN": "BR",
  "QCO": "CU",
  "QCP": "BR",
  "QCR": "BR",
  "QCY": "GB",
  "QDB": "BR",
  "QDC": "BR",
  "QDF": "BR",
  "QEF": "DE",
  "QEO": "PL",
  "QFG": "GL",
  "QFI": "GL",
  "QFN": "GL",
  "QFO": "GB",
  "QFR": "IT",
  "QFX": "GL",
  "QGA": "BR",
  "QGB": "BR",
  "QGC": "BR",
  "QGF": "BR",
  "QGP": "BR",
  "QGQ": "GL",
  "QGS": "BR",
  "QGU": "JP",
  "QGY": "HU",
  "QHA": "BE",
  "QHB": "BR",
  "QHN": "BR",
  "QHP": "BR",
  "QHR": "ET",
  "QHU": "DE",
  "QHV": "BR",
  "QID": "BR",
  "QIE": "FR",
  "QIG": "BR",
  "QIQ": "BR",
  "QIT": "BR",
  "QJB": "SA",
  "QJE": "GL",
  "QJI": "GL",
  "QLA": "GB",
  "QLP": "IT",
  "QLS": "CH",
  "QMF": "BR",
  "QMM": "IT",
  "QMZ": "DE",
  "QND": "RS",
  "QNJ": "FR",
  "QNM": "BE",
  "QNS": "BR",
  "QNV": "BR",
  "QNX": "FR",
  "QNY": "US",
  "QOA": "BR",
  "QOB": "DE",
  "QOJ": "BR",
  "QOW": "NG",
  "QPA": "IT",
  "QPD": "CU",
  "QPH": "BW",
  "QPM": "PL",
  "QPS": "BR",
  "QPW": "GL",
  "QPZ": "IT",
  "QQT": "GL",
  "QRA": "ZA",
  "QRC": "CL",
  "QRF": "AR",
  "QRO": "MX",
  "QRT": "IT",
  "QRW": "NG",
  "QRY": "GL",
  "QRZ": "BR",
  "QSA": "ES",
  "QSC": "BR",
  "QSF": "DZ",
  "QSI": "TZ",
  "QSN": "CU",
  "QSX": "GY",
  "QTJ": "FR",
  "QUB": "LY",
  "QUG": "GB",
  "QUN": "KR",
  "QUO": "NG",
  "QUP": "GL",
  "QUS": "NG",
  "QUV": "GL",
  "QUY": "GB",
  "QVA": "IT",
  "QVB": "BR",
  "QVE": "FI",
  "QVP": "BR",
  "QVR": "BR",
  "QWG": "US",
  "QWS": "PL",
  "QXC": "BR",
  "QXH": "DE",
  "QYR": "FR",
  "QYY": "PL",
  "QZD": "HU",
  "QZO": "IT",
  "RAA": "PG",
  "RAB": "PG",
  "RAC": "US",
  "RAE": "SA",
  "RAG": "NZ",
  "RAH": "SA",
  "RAI": "CV",
  "RAJ": "IN",
  "RAK": "MA",
  "RAL": "US",
  "RAM": "AU",
  "RAN": "IT",
  "RAO": "BR",
  "RAP": "US",
  "RAQ": "ID",
  "RAR": "CK",
  "RAT": "RU",
  "RAV": "CO",
  "RAW": "PG",
  "RAX": "PG",
  "RAZ": "PK",
  "RBA": "MA",
  "RBB": "BR",
  "RBC": "AU",
  "RBD": "US",
  "RBE": "KH",
  "RBF": "US",
  "RBG": "US",
  "RBI": "FJ",
  "RBK": "US",
  "RBL": "US",
  "RBM": "DE",
  "RBO": "BO",
  "RBP": "PG",
  "RBQ": "BO",
  "RBR": "BR",
  "RBS": "AU",
  "RBU": "AU",
  "RBV": "SB",
  "RBW": "US",
  "RBX": "SS",
  "RBY": "US",
  "RCA": "US",
  "RCB": "ZA",
  "RCE": "US",
  "RCH": "CO",
  "RCK": "US",
  "RCL": "VU",
  "RCM": "AU",
  "RCN": "AU",
  "RCO": "FR",
  "RCQ": "AR",
  "RCS": "GB",
  "RCT": "US",
  "RCU": "AR",
  "RCY": "BS",
  "RDA": "AU",
  "RDB": "US",
  "RDC": "BR",
  "RDD": "US",
  "RDE": "ID",
  "RDG": "US",
  "RDM": "US",
  "RDN": "MY",
  "RDR": "US",
  "RDS": "AR",
  "RDT": "SN",
  "RDU": "US",
  "RDV": "US",
  "RDZ": "FR",
  "REA": "PF",
  "REB": "DE",
  "REC": "BR",
  "RED": "US",
  "REE": "US",
  "REG": "IT",
  "REH": "US",
  "REI": "GF",
  "REL": "AR",
  "REN": "RU",
  "REO": "US",
  "REP": "KH",
  "REQ": "PK",
  "RER": "GT",
  "RES": "AR",
  "RET": "NO",
  "REU": "ES",
  "REW": "IN",
  "REX": "MX",
  "REY": "BO",
  "RFA": "CF",
  "RFD": "US",
  "RFN": "IS",
  "RFP": "PF",
  "RFR": "CR",
  "RFS": "NI",
  "RGA": "AR",
  "RGE": "PG",
  "RGH": "IN",
  "RGI": "PF",
  "RGK": "RU",
  "RGL": "AR",
  "RGN": "MM",
  "RGO": "KP",
  "RGR": "US",
  "RGS": "ES",
  "RGT": "ID",
  "RHD": "AR",
  "RHG": "RW",
  "RHI": "US",
  "RHL": "AU",
  "RHO": "GR",
  "RHP": "NP",
  "RHV": "US",
  "RIB": "BO",
  "RIC": "US",
  "RIE": "US",
  "RIG": "BR",
  "RIH": "PA",
  "RIJ": "PE",
  "RIK": "CR",
  "RIM": "PE",
  "RIN": "SB",
  "RIS": "JP",
  "RIW": "US",
  "RIX": "LV",
  "RIY": "YE",
  "RIZ": "PA",
  "RJA": "IN",
  "RJB": "NP",
  "RJH": "BD",
  "RJI": "IN",
  "RJK": "HR",
  "RJL": "ES",
  "RJN": "IR",
  "RKA": "PF",
  "RKC": "US",
  "RKD": "US",
  "RKE": "DK",
  "RKH": "US",
  "RKI": "ID",
  "RKP": "US",
  "RKS": "US",
  "RKT": "AE",
  "RKU": "PG",
  "RKV": "IS",
  "RKW": "US",
  "RKY": "AU",
  "RLA": "US",
  "RLG": "DE",
  "RLP": "AU",
  "RLT": "NE",
  "RMA": "AU",
  "RMB": "OM",
  "RME": "US",
  "RMF": "EG",
  "RMG": "US",
  "RMI": "IT",
  "RMK": "AU",
  "RML": "LK",
  "RMN": "PG",
  "RMQ": "TW",
  "RMS": "DE",
  "RMT": "PF",
  "RMU": "ES",
  "RMY": "US",
  "RNA": "SB",
  "RNB": "SE",
  "RNC": "US",
  "RND": "US",
  "RNE": "FR",
  "RNI": "NI",
  "RNJ": "JP",
  "RNL": "SB",
  "RNM": "OM",
  "RNN": "DK",
  "RNO": "US",
  "RNP": "MH",
  "RNR": "PG",
  "RNS": "FR",
  "RNT": "US",
  "RNU": "MY",
  "RNZ": "US",
  "ROA": "US",
  "ROB": "LR",
  "ROC": "US",
  "ROD": "ZA",
  "ROG": "US",
  "ROH": "AU",
  "ROI": "TH",
  "ROK": "AU",
  "ROL": "US",
  "ROO": "BR",
  "ROP": "MP",
  "ROR": "PW",
  "ROS": "AR",
  "ROT": "NZ",
  "ROU": "BG",
  "ROV": "RU",
  "ROW": "US",
  "ROY": "AR",
  "ROZ": "ES",
  "RPA": "NP",
  "RPB": "AU",
  "RPM": "AU",
  "RPN": "IL",
  "RPR": "IN",
  "RPV": "AU",
  "RPX": "US",
  "RQO": "US",
  "RQW": "IQ",
  "RRE": "AU",
  "RRG": "MU",
  "RRK": "IN",
  "RRL": "US",
  "RRM": "MZ",
  "RRR": "PF",
  "RRS": "NO",
  "RRT": "US",
  "RRV": "AU",
  "RSA": "AR",
  "RSB": "AU",
  "RSD": "BS",
  "RSE": "AU",
  "RSH": "US",
  "RSJ": "US",
  "RSK": "ID",
  "RSL": "US",
  "RSN": "US",
  "RSS": "SD",
  "RST": "US",
  "RSU": "KR",
  "RSW": "US",
  "RSX": "US",
  "RTA": "FJ",
  "RTB": "HN",
  "RTC": "IN",
  "RTG": "ID",
  "RTI": "ID",
  "RTL": "US",
  "RTM": "NL",
  "RTN": "US",
  "RTP": "AU",
  "RTS": "AU",
  "RTW": "RU",
  "RTY": "AU",
  "RUD": "IR",
  "RUE": "CD",
  "RUF": "ID",
  "RUH": "SA",
  "RUI": "US",
  "RUK": "NP",
  "RUM": "NP",
  "RUN": "RE",
  "RUP": "IN",
  "RUR": "PF",
  "RUS": "SB",
  "RUT": "US",
  "RUU": "PG",
  "RUV": "GT",
  "RVA": "MG",
  "RVC": "LR",
  "RVD": "BR",
  "RVE": "CO",
  "RVH": "RU",
  "RVK": "NO",
  "RVN": "FI",
  "RVO": "ZA",
  "RVR": "US",
  "RVS": "US",
  "RVT": "AU",
  "RVV": "PF",
  "RVY": "UY",
  "RWF": "US",
  "RWI": "US",
  "RWL": "US",
  "RWN": "UA",
  "RXE": "US",
  "RXS": "PH",
  "RYB": "RU",
  "RYG": "NO",
  "RYK": "PK",
  "RYN": "FR",
  "RZE": "PL",
  "RZH": "US",
  "RZN": "RU",
  "RZP": "PH",
  "RZR": "IR",
  "RZS": "ID",
  "RZZ": "US",
  "SAB": "BQ",
  "SAC": "US",
  "SAD": "US",
  "SAE": "ID",
  "SAF": "US",
  "SAG": "US",
  "SAH": "YE",
  "SAK": "IS",
  "SAL": "SV",
  "SAM": "PG",
  "SAN": "US",
  "SAO": "BR",
  "SAP": "HN",
  "SAQ": "BS",
  "SAR": "US",
  "SAS": "US",
  "SAT": "US",
  "SAV": "US",
  "SAW": "TR",
  "SAX": "PA",
  "SAZ": "LR",
  "SB0": "BR",
  "SB2": "BR",
  "SBA": "US",
  "SBB": "VE",
  "SBC": "PG",
  "SBD": "US",
  "SBE": "PG",
  "SBF": "AF",
  "SBG": "ID",
  "SBH": "BL",
  "SBI": "GN",
  "SBJ": "BR",
  "SBK": "FR",
  "SBL": "BO",
  "SBN": "US",
  "SBO": "US",
  "SBP": "US",
  "SBQ": "PK",
  "SBR": "AU",
  "SBS": "US",
  "SBU": "ZA",
  "SBV": "PG",
  "SBW": "MY",
  "SBX": "US",
  "SBY": "US",
  "SBZ": "RO",
  "SCC": "US",
  "SCD": "HN",
  "SCE": "US",
  "SCF": "US",
  "SCG": "AU",
  "SCH": "US",
  "SCI": "VE",
  "SCK": "US",
  "SCL": "CL",
  "SCM": "US",
  "SCN": "DE",
  "SCO": "KZ",
  "SCP": "FR",
  "SCQ": "ES",
  "SCS": "GB",
  "SCT": "YE",
  "SCU": "CU",
  "SCV": "RO",
  "SCW": "RU",
  "SCX": "MX",
  "SCY": "EC",
  "SCZ": "SB",
  "SDC": "GY",
  "SDD": "AO",
  "SDE": "AR",
  "SDF": "US",
  "SDG": "IR",
  "SDH": "HN",
  "SDI": "PG",
  "SDJ": "JP",
  "SDK": "MY",
  "SDL": "SE",
  "SDM": "US",
  "SDN": "NO",
  "SDP": "US",
  "SDQ": "DO",
  "SDR": "ES",
  "SDS": "JP",
  "SDT": "PK",
  "SDU": "BR",
  "SDV": "IL",
  "SDX": "US",
  "SDY": "US",
  "SEA": "US",
  "SEB": "LY",
  "SEF": "US",
  "SEG": "US",
  "SEH": "ID",
  "SEK": "MA",
  "SEM": "US",
  "SEN": "GB",
  "SEO": "CI",
  "SEP": "US",
  "SEQ": "ID",
  "SER": "US",
  "SEU": "TZ",
  "SEV": "UA",
  "SEW": "EG",
  "SEX": "DE",
  "SEY": "MR",
  "SEZ": "SC",
  "SFA": "TN",
  "SFB": "US",
  "SFC": "GP",
  "SFD": "VE",
  "SFE": "PH",
  "SFF": "US",
  "SFG": "MF",
  "SFH": "MX",
  "SFI": "MA",
  "SFJ": "GL",
  "SFK": "BR",
  "SFL": "CV",
  "SFM": "US",
  "SFN": "AR",
  "SFO": "US",
  "SFR": "US",
  "SFS": "PH",
  "SFT": "SE",
  "SFU": "PG",
  "SFZ": "US",
  "SGA": "AF",
  "SGC": "RU",
  "SGD": "DK",
  "SGE": "DE",
  "SGF": "US",
  "SGG": "MY",
  "SGH": "US",
  "SGI": "PK",
  "SGK": "PG",
  "SGL": "PH",
  "SGM": "MX",
  "SGN": "VN",
  "SGO": "AU",
  "SGP": "AU",
  "SGR": "US",
  "SGT": "US",
  "SGU": "US",
  "SGV": "AR",
  "SGW": "US",
  "SGX": "TZ",
  "SGY": "US",
  "SGZ": "TH",
  "SHA": "CN",
  "SHB": "JP",
  "SHC": "ET",
  "SHD": "US",
  "SHE": "CN",
  "SHF": "CN",
  "SHG": "US",
  "SHH": "US",
  "SHI": "JP",
  "SHJ": "AE",
  "SHK": "LS",
  "SHL": "IN",
  "SHM": "JP",
  "SHN": "US",
  "SHO": "SZ",
  "SHQ": "AU",
  "SHR": "US",
  "SHS": "CN",
  "SHT": "AU",
  "SHU": "AU",
  "SHV": "US",
  "SHW": "SA",
  "SHX": "US",
  "SHY": "TZ",
  "SHZ": "LS",
  "SIB": "CG",
  "SID": "CV",
  "SIE": "PT",
  "SIF": "NP",
  "SIG": "PR",
  "SIH": "NP",
  "SII": "MA",
  "SIL": "PG",
  "SIM": "PG",
  "SIN": "SG",
  "SIO": "AU",
  "SIP": "UA",
  "SIR": "CH",
  "SIS": "ZA",
  "SIT": "US",
  "SIU": "NI",
  "SIW": "ID",
  "SIX": "AU",
  "SIZ": "PG",
  "SJA": "PE",
  "SJB": "BO",
  "SJC": "US",
  "SJD": "MX",
  "SJE": "CO",
  "SJF": "VI",
  "SJH": "CO",
  "SJI": "PH",
  "SJJ": "BA",
  "SJL": "BR",
  "SJM": "DO",
  "SJN": "US",
  "SJO": "CR",
  "SJP": "BR",
  "SJQ": "ZM",
  "SJR": "CO",
  "SJS": "BO",
  "SJT": "US",
  "SJU": "PR",
  "SJV": "BO",
  "SJW": "CN",
  "SJX": "BZ",
  "SJY": "FI",
  "SJZ": "PT",
  "SKA": "US",
  "SKB": "KN",
  "SKC": "PG",
  "SKD": "UZ",
  "SKE": "NO",
  "SKF": "US",
  "SKG": "GR",
  "SKH": "NP",
  "SKI": "DZ",
  "SKJ": "US",
  "SKK": "US",
  "SKL": "GB",
  "SKM": "GY",
  "SKN": "NO",
  "SKO": "NG",
  "SKP": "MK",
  "SKQ": "LS",
  "SKR": "ET",
  "SKT": "PK",
  "SKU": "GR",
  "SKV": "EG",
  "SKX": "RU",
  "SKY": "US",
  "SKZ": "PK",
  "SLA": "AR",
  "SLB": "US",
  "SLC": "US",
  "SLE": "US",
  "SLF": "SA",
  "SLG": "US",
  "SLH": "VU",
  "SLI": "ZM",
  "SLJ": "AU",
  "SLK": "US",
  "SLL": "OM",
  "SLM": "ES",
  "SLN": "US",
  "SLO": "US",
  "SLP": "MX",
  "SLQ": "US",
  "SLR": "US",
  "SLS": "BG",
  "SLT": "US",
  "SLU": "LC",
  "SLV": "IN",
  "SLW": "MX",
  "SLX": "TC",
  "SLY": "RU",
  "SLZ": "BR",
  "SMA": "PT",
  "SMB": "CL",
  "SME": "US",
  "SMF": "US",
  "SMG": "PE",
  "SMH": "PG",
  "SMI": "GR",
  "SMJ": "PG",
  "SMK": "US",
  "SML": "BS",
  "SMM": "MY",
  "SMN": "US",
  "SMO": "US",
  "SMP": "PG",
  "SMQ": "ID",
  "SMR": "CO",
  "SMS": "MG",
  "SMT": "TW",
  "SMU": "US",
  "SMV": "CH",
  "SMW": "EH",
  "SMX": "US",
  "SMY": "SN",
  "SMZ": "SR",
  "SNA": "US",
  "SNB": "AU",
  "SNC": "EC",
  "SNE": "CV",
  "SNF": "VE",
  "SNG": "BO",
  "SNH": "AU",
  "SNI": "LR",
  "SNJ": "CU",
  "SNK": "US",
  "SNL": "US",
  "SNM": "BO",
  "SNN": "IE",
  "SNO": "TH",
  "SNP": "US",
  "SNQ": "MX",
  "SNR": "FR",
  "SNS": "US",
  "SNT": "CO",
  "SNU": "CU",
  "SNV": "VE",
  "SNW": "MM",
  "SNX": "DO",
  "SNY": "US",
  "SNZ": "BR",
  "SOA": "VN",
  "SOB": "HU",
  "SOC": "ID",
  "SOD": "BR",
  "SOE": "CG",
  "SOF": "BG",
  "SOG": "NO",
  "SOH": "CO",
  "SOI": "AU",
  "SOJ": "NO",
  "SOK": "LS",
  "SOL": "US",
  "SOM": "VE",
  "SON": "VU",
  "SOO": "SE",
  "SOP": "US",
  "SOQ": "ID",
  "SOR": "SY",
  "SOT": "FI",
  "SOU": "GB",
  "SOV": "US",
  "SOW": "US",
  "SOX": "CO",
  "SOY": "GB",
  "SOZ": "FR",
  "SPA": "US",
  "SPB": "VI",
  "SPC": "ES",
  "SPD": "BD",
  "SPE": "MY",
  "SPF": "US",
  "SPH": "PG",
  "SPI": "US",
  "SPJ": "GR",
  "SPM": "DE",
  "SPN": "MP",
  "SPP": "AO",
  "SPQ": "US",
  "SPR": "BZ",
  "SPS": "US",
  "SPT": "MY",
  "SPU": "HR",
  "SPV": "PG",
  "SPW": "US",
  "SPY": "CI",
  "SPZ": "US",
  "SQA": "US",
  "SQC": "AU",
  "SQE": "CO",
  "SQF": "CO",
  "SQG": "ID",
  "SQH": "VN",
  "SQI": "US",
  "SQK": "EG",
  "SQM": "BR",
  "SQN": "ID",
  "SQO": "SE",
  "SQQ": "LT",
  "SQR": "ID",
  "SQS": "BZ",
  "SQT": "PG",
  "SQU": "PE",
  "SQV": "US",
  "SQX": "BR",
  "SQY": "BR",
  "SQZ": "GB",
  "SRA": "BR",
  "SRB": "BO",
  "SRD": "BO",
  "SRE": "BO",
  "SRF": "US",
  "SRG": "ID",
  "SRI": "ID",
  "SRJ": "BO",
  "SRK": "SL",
  "SRL": "MX",
  "SRM": "AU",
  "SRN": "AU",
  "SRO": "CO",
  "SRP": "NO",
  "SRQ": "US",
  "SRR": "AU",
  "SRS": "CO",
  "SRT": "UG",
  "SRV": "US",
  "SRW": "US",
  "SRX": "LY",
  "SRY": "IR",
  "SRZ": "BO",
  "SSA": "BR",
  "SSB": "VI",
  "SSC": "US",
  "SSD": "CL",
  "SSE": "IN",
  "SSF": "US",
  "SSG": "GQ",
  "SSH": "EG",
  "SSI": "US",
  "SSJ": "NO",
  "SSK": "AU",
  "SSL": "CO",
  "SSN": "KR",
  "SSO": "BR",
  "SSP": "AU",
  "SSQ": "CA",
  "SSR": "VU",
  "SSS": "PG",
  "SST": "AR",
  "SSU": "US",
  "SSV": "PH",
  "SSW": "US",
  "SSX": "TR",
  "SSY": "AO",
  "SSZ": "BR",
  "STA": "DK",
  "STC": "US",
  "STD": "VE",
  "STE": "US",
  "STF": "AU",
  "STG": "US",
  "STH": "AU",
  "STI": "DO",
  "STJ": "US",
  "STK": "US",
  "STL": "US",
  "STM": "BR",
  "STN": "GB",
  "STP": "US",
  "STR": "DE",
  "STS": "US",
  "STT": "VI",
  "STU": "BZ",
  "STV": "IN",
  "STW": "RU",
  "STX": "VI",
  "STY": "UY",
  "SUA": "US",
  "SUB": "ID",
  "SUD": "US",
  "SUE": "US",
  "SUF": "IT",
  "SUG": "PH",
  "SUH": "OM",
  "SUI": "GE",
  "SUJ": "RO",
  "SUK": "KR",
  "SUL": "PK",
  "SUM": "US",
  "SUN": "US",
  "SUO": "US",
  "SUP": "ID",
  "SUQ": "EC",
  "SUR": "CA",
  "SUS": "US",
  "SUT": "TZ",
  "SUU": "US",
  "SUV": "FJ",
  "SUW": "US",
  "SUX": "US",
  "SUY": "IS",
  "SUZ": "PG",
  "SVA": "US",
  "SVB": "MG",
  "SVD": "VC",
  "SVE": "US",
  "SVF": "BJ",
  "SVG": "NO",
  "SVH": "US",
  "SVI": "CO",
  "SVJ": "NO",
  "SVK": "BZ",
  "SVL": "FI",
  "SVO": "RU",
  "SVP": "AO",
  "SVQ": "ES",
  "SVR": "KH",
  "SVS": "US",
  "SVT": "BW",
  "SVU": "FJ",
  "SVX": "RU",
  "SVZ": "VE",
  "SWA": "CN",
  "SWB": "AU",
  "SWC": "AU",
  "SWD": "US",
  "SWE": "PG",
  "SWF": "US",
  "SWG": "PG",
  "SWH": "AU",
  "SWJ": "VU",
  "SWM": "BR",
  "SWN": "PK",
  "SWO": "US",
  "SWP": "NA",
  "SWQ": "ID",
  "SWR": "PG",
  "SWS": "GB",
  "SWT": "RU",
  "SWU": "KR",
  "SWV": "PK",
  "SWW": "US",
  "SWX": "BW",
  "SWY": "MY",
  "SXA": "PG",
  "SXB": "FR",
  "SXF": "DE",
  "SXH": "PG",
  "SXI": "IR",
  "SXJ": "CN",
  "SXK": "ID",
  "SXL": "IE",
  "SXM": "SX",
  "SXN": "BW",
  "SXO": "BR",
  "SXP": "US",
  "SXQ": "US",
  "SXR": "IN",
  "SXS": "MY",
  "SXT": "MY",
  "SXU": "ET",
  "SXV": "IN",
  "SXW": "PG",
  "SXX": "BR",
  "SXZ": "TR",
  "SYA": "US",
  "SYB": "US",
  "SYC": "PE",
  "SYD": "AU",
  "SYE": "YE",
  "SYF": "CA",
  "SYH": "NP",
  "SYI": "US",
  "SYJ": "IR",
  "SYL": "US",
  "SYM": "CN",
  "SYN": "US",
  "SYO": "JP",
  "SYP": "PA",
  "SYQ": "CR",
  "SYR": "US",
  "SYT": "FR",
  "SYU": "AU",
  "SYV": "US",
  "SYW": "PK",
  "SYX": "CN",
  "SYY": "GB",
  "SYZ": "IR",
  "SZA": "AO",
  "SZB": "MY",
  "SZE": "ET",
  "SZF": "TR",
  "SZG": "AT",
  "SZJ": "CU",
  "SZK": "ZA",
  "SZL": "US",
  "SZN": "US",
  "SZP": "US",
  "SZQ": "AR",
  "SZR": "BG",
  "SZS": "NZ",
  "SZW": "DE",
  "SZX": "CN",
  "SZY": "PL",
  "SZZ": "PL",
  "TAA": "SB",
  "TAB": "TT",
  "TAC": "PH",
  "TAD": "US",
  "TAE": "KR",
  "TAF": "DZ",
  "TAG": "PH",
  "TAH": "VU",
  "TAI": "YE",
  "TAJ": "PG",
  "TAK": "JP",
  "TAL": "US",
  "TAM": "MX",
  "TAN": "AU",
  "TAO": "CN",
  "TAP": "MX",
  "TAQ": "AU",
  "TAS": "UZ",
  "TAT": "SK",
  "TAU": "CO",
  "TAV": "AS",
  "TAW": "UY",
  "TAX": "ID",
  "TAY": "EE",
  "TBA": "PG",
  "TBB": "VN",
  "TBC": "US",
  "TBE": "PG",
  "TBF": "KI",
  "TBG": "PG",
  "TBH": "PH",
  "TBI": "BS",
  "TBJ": "TN",
  "TBK": "AU",
  "TBL": "AU",
  "TBM": "ID",
  "TBN": "US",
  "TBO": "TZ",
  "TBP": "PE",
  "TBQ": "PG",
  "TBR": "US",
  "TBS": "GE",
  "TBT": "BR",
  "TBU": "TO",
  "TBV": "MH",
  "TBW": "RU",
  "TBY": "BW",
  "TBZ": "IR",
  "TCA": "AU",
  "TCB": "BS",
  "TCC": "US",
  "TCD": "CO",
  "TCE": "RO",
  "TCG": "CN",
  "TCH": "GA",
  "TCJ": "PG",
  "TCK": "PG",
  "TCL": "US",
  "TCM": "US",
  "TCN": "MX",
  "TCO": "CO",
  "TCP": "EG",
  "TCQ": "PE",
  "TCR": "IN",
  "TCS": "US",
  "TCT": "US",
  "TCU": "ZA",
  "TCW": "AU",
  "TCX": "IR",
  "TCY": "NA",
  "TCZ": "CN",
  "TDA": "CO",
  "TDB": "PG",
  "TDD": "BO",
  "TDG": "PH",
  "TDJ": "DJ",
  "TDK": "KZ",
  "TDL": "AR",
  "TDN": "AU",
  "TDO": "US",
  "TDP": "PE",
  "TDR": "AU",
  "TDS": "PG",
  "TDT": "ZA",
  "TDV": "MG",
  "TDW": "US",
  "TDX": "TH",
  "TDZ": "US",
  "TEA": "HN",
  "TEB": "US",
  "TEC": "BR",
  "TED": "DK",
  "TEE": "DZ",
  "TEF": "AU",
  "TEG": "BF",
  "TEI": "IN",
  "TEK": "US",
  "TEL": "MY",
  "TEM": "AU",
  "TEN": "CN",
  "TEO": "PG",
  "TEP": "PG",
  "TEQ": "TR",
  "TER": "PT",
  "TES": "ER",
  "TET": "MZ",
  "TEU": "NZ",
  "TEX": "US",
  "TEY": "IS",
  "TEZ": "IN",
  "TFB": "PG",
  "TFF": "BR",
  "TFI": "PG",
  "TFL": "BR",
  "TFM": "PG",
  "TFN": "ES",
  "TFS": "ES",
  "TFT": "PK",
  "TGC": "MY",
  "TGD": "ME",
  "TGE": "US",
  "TGG": "MY",
  "TGH": "VU",
  "TGI": "PE",
  "TGJ": "NC",
  "TGK": "RU",
  "TGL": "PG",
  "TGM": "RO",
  "TGN": "AU",
  "TGO": "CN",
  "TGQ": "BR",
  "TGR": "DZ",
  "TGS": "MZ",
  "TGT": "TZ",
  "TGU": "HN",
  "TGV": "BG",
  "TGZ": "MX",
  "THA": "US",
  "THB": "LS",
  "THC": "LR",
  "THE": "BR",
  "THF": "DE",
  "THG": "AU",
  "THH": "NZ",
  "THI": "MR",
  "THK": "LA",
  "THL": "MM",
  "THM": "US",
  "THN": "SE",
  "THO": "IS",
  "THP": "US",
  "THQ": "CN",
  "THR": "IR",
  "THS": "TH",
  "THT": "MR",
  "THU": "GL",
  "THV": "US",
  "THX": "RU",
  "THY": "ZA",
  "THZ": "NE",
  "TIA": "AL",
  "TIB": "CO",
  "TIC": "MH",
  "TID": "DZ",
  "TIE": "ET",
  "TIF": "SA",
  "TIG": "PG",
  "TIH": "PF",
  "TIJ": "MX",
  "TIK": "US",
  "TIL": "CA",
  "TIM": "ID",
  "TIN": "DZ",
  "TIO": "MM",
  "TIP": "LY",
  "TIQ": "MP",
  "TIR": "IN",
  "TIU": "NZ",
  "TIV": "ME",
  "TIW": "US",
  "TIX": "US",
  "TIY": "MR",
  "TIZ": "PG",
  "TJA": "BO",
  "TJC": "PA",
  "TJG": "ID",
  "TJH": "JP",
  "TJI": "HN",
  "TJK": "TR",
  "TJM": "RU",
  "TJN": "PF",
  "TJQ": "ID",
  "TJS": "ID",
  "TJU": "TJ",
  "TJV": "IN",
  "TKA": "US",
  "TKB": "PG",
  "TKC": "CM",
  "TKD": "GH",
  "TKE": "US",
  "TKF": "US",
  "TKG": "ID",
  "TKH": "TH",
  "TKI": "US",
  "TKK": "FM",
  "TKL": "US",
  "TKM": "GT",
  "TKN": "JP",
  "TKO": "LS",
  "TKP": "PF",
  "TKQ": "TZ",
  "TKR": "BD",
  "TKS": "JP",
  "TKT": "TH",
  "TKU": "FI",
  "TKV": "PF",
  "TKW": "PG",
  "TKX": "PF",
  "TKY": "AU",
  "TKZ": "NZ",
  "TLA": "US",
  "TLB": "PK",
  "TLC": "MX",
  "TLD": "BW",
  "TLE": "MG",
  "TLG": "SB",
  "TLH": "US",
  "TLI": "ID",
  "TLJ": "US",
  "TLK": "IS",
  "TLL": "EE",
  "TLM": "DZ",
  "TLN": "FR",
  "TLO": "PG",
  "TLP": "PG",
  "TLR": "US",
  "TLS": "FR",
  "TLT": "US",
  "TLU": "CO",
  "TLV": "IL",
  "TLW": "PG",
  "TLX": "CL",
  "TLZ": "BR",
  "TMA": "US",
  "TMB": "US",
  "TMC": "ID",
  "TMD": "MR",
  "TME": "CO",
  "TMG": "MY",
  "TMH": "ID",
  "TMI": "NP",
  "TMJ": "UZ",
  "TML": "GH",
  "TMM": "MG",
  "TMN": "KI",
  "TMO": "VE",
  "TMP": "FI",
  "TMQ": "BF",
  "TMR": "DZ",
  "TMS": "ST",
  "TMT": "BR",
  "TMU": "CR",
  "TMW": "AU",
  "TMX": "DZ",
  "TMY": "ID",
  "TMZ": "NZ",
  "TNA": "CN",
  "TNB": "ID",
  "TNC": "US",
  "TND": "CU",
  "TNE": "JP",
  "TNF": "FR",
  "TNG": "MA",
  "TNH": "CN",
  "TNI": "IN",
  "TNJ": "ID",
  "TNK": "US",
  "TNL": "UA",
  "TNM": "AQ",
  "TNN": "TW",
  "TNO": "CR",
  "TNP": "US",
  "TNQ": "KI",
  "TNR": "MG",
  "TNS": "CA",
  "TNT": "US",
  "TNU": "US",
  "TNV": "KI",
  "TNW": "EC",
  "TNZ": "MN",
  "TOA": "US",
  "TOB": "LY",
  "TOC": "US",
  "TOD": "MY",
  "TOE": "TN",
  "TOF": "RU",
  "TOG": "US",
  "TOH": "VU",
  "TOI": "US",
  "TOJ": "ES",
  "TOK": "PG",
  "TOL": "US",
  "TOM": "ML",
  "TON": "PG",
  "TOO": "CR",
  "TOP": "US",
  "TOQ": "CL",
  "TOR": "US",
  "TOS": "NO",
  "TOT": "SR",
  "TOU": "NC",
  "TOW": "BR",
  "TOX": "RU",
  "TOY": "JP",
  "TOZ": "CI",
  "TPA": "US",
  "TPC": "EC",
  "TPE": "TW",
  "TPG": "MY",
  "TPH": "US",
  "TPI": "PG",
  "TPJ": "NP",
  "TPK": "ID",
  "TPL": "US",
  "TPN": "EC",
  "TPP": "PE",
  "TPQ": "MX",
  "TPR": "AU",
  "TPS": "IT",
  "TPT": "LR",
  "TPU": "NP",
  "TQL": "RU",
  "TQN": "AF",
  "TQR": "IT",
  "TQS": "CO",
  "TR7": "CA",
  "TRA": "JP",
  "TRB": "CO",
  "TRC": "MX",
  "TRD": "NO",
  "TRE": "GB",
  "TRF": "NO",
  "TRG": "NZ",
  "TRH": "US",
  "TRI": "US",
  "TRJ": "PG",
  "TRK": "ID",
  "TRL": "US",
  "TRM": "US",
  "TRN": "IT",
  "TRO": "AU",
  "TRQ": "BR",
  "TRR": "LK",
  "TRS": "IT",
  "TRU": "PE",
  "TRV": "IN",
  "TRW": "KI",
  "TRY": "UG",
  "TRZ": "IN",
  "TSA": "TW",
  "TSB": "NA",
  "TSC": "EC",
  "TSD": "ZA",
  "TSE": "KZ",
  "TSF": "IT",
  "TSG": "US",
  "TSH": "CD",
  "TSJ": "JP",
  "TSK": "PG",
  "TSL": "MX",
  "TSM": "US",
  "TSN": "CN",
  "TSQ": "BR",
  "TSR": "RO",
  "TSS": "US",
  "TST": "TH",
  "TSU": "KI",
  "TSV": "AU",
  "TSW": "PG",
  "TSX": "ID",
  "TSY": "ID",
  "TSZ": "MN",
  "TTA": "MA",
  "TTC": "CL",
  "TTD": "US",
  "TTE": "ID",
  "TTG": "AR",
  "TTH": "OM",
  "TTI": "PF",
  "TTJ": "JP",
  "TTL": "FJ",
  "TTN": "US",
  "TTO": "US",
  "TTQ": "CR",
  "TTR": "ID",
  "TTS": "MG",
  "TTT": "TW",
  "TTU": "MA",
  "TTW": "LK",
  "TUA": "EC",
  "TUB": "PF",
  "TUC": "AR",
  "TUD": "SN",
  "TUE": "PA",
  "TUF": "FR",
  "TUG": "PH",
  "TUH": "US",
  "TUI": "SA",
  "TUJ": "ET",
  "TUK": "PK",
  "TUL": "US",
  "TUM": "AU",
  "TUN": "TN",
  "TUO": "NZ",
  "TUP": "US",
  "TUQ": "BF",
  "TUR": "BR",
  "TUS": "US",
  "TUT": "PG",
  "TUU": "SA",
  "TUV": "VE",
  "TUX": "CA",
  "TUY": "MX",
  "TUZ": "BR",
  "TVA": "MG",
  "TVC": "US",
  "TVF": "US",
  "TVI": "US",
  "TVL": "US",
  "TVS": "CN",
  "TVU": "FJ",
  "TVY": "MM",
  "TWA": "US",
  "TWB": "AU",
  "TWD": "US",
  "TWE": "US",
  "TWF": "US",
  "TWH": "US",
  "TWP": "AU",
  "TWT": "PH",
  "TWU": "MY",
  "TWY": "PG",
  "TWZ": "NZ",
  "TXF": "BR",
  "TXG": "TW",
  "TXK": "US",
  "TXL": "DE",
  "TXM": "ID",
  "TXN": "CN",
  "TXR": "AU",
  "TXU": "CI",
  "TYA": "RU",
  "TYB": "AU",
  "TYD": "RU",
  "TYE": "US",
  "TYF": "SE",
  "TYG": "AU",
  "TYL": "PE",
  "TYM": "BS",
  "TYN": "CN",
  "TYP": "AU",
  "TYR": "US",
  "TYS": "US",
  "TYT": "UY",
  "TZA": "BZ",
  "TZL": "BA",
  "TZM": "MX",
  "TZR": "HU",
  "TZX": "TR",
  "UAC": "MX",
  "UAE": "PG",
  "UAH": "PF",
  "UAI": "TL",
  "UAK": "GL",
  "UAL": "AO",
  "UAP": "PF",
  "UAQ": "AR",
  "UAR": "MA",
  "UAS": "KE",
  "UAX": "GT",
  "UBA": "BR",
  "UBB": "AU",
  "UBI": "PG",
  "UBJ": "JP",
  "UBP": "TH",
  "UBR": "ID",
  "UBS": "US",
  "UBT": "BR",
  "UBU": "AU",
  "UCA": "US",
  "UCE": "US",
  "UCK": "UA",
  "UCN": "LR",
  "UCT": "RU",
  "UCY": "US",
  "UCZ": "PE",
  "UDA": "AU",
  "UDD": "US",
  "UDE": "NL",
  "UDI": "BR",
  "UDJ": "UA",
  "UDR": "IN",
  "UEE": "AU",
  "UEL": "MZ",
  "UEN": "RU",
  "UEO": "JP",
  "UES": "US",
  "UET": "PK",
  "UFA": "RU",
  "UGA": "MN",
  "UGB": "US",
  "UGC": "UZ",
  "UGI": "US",
  "UGN": "US",
  "UGO": "AO",
  "UGT": "MN",
  "UGU": "ID",
  "UHE": "CZ",
  "UHF": "GB",
  "UIB": "CO",
  "UIH": "VN",
  "UII": "HN",
  "UIK": "RU",
  "UIL": "US",
  "UIN": "US",
  "UIO": "EC",
  "UIP": "FR",
  "UIQ": "VU",
  "UIR": "AU",
  "UIT": "MH",
  "UJE": "MH",
  "UJN": "KR",
  "UKA": "KE",
  "UKB": "JP",
  "UKH": "OM",
  "UKI": "US",
  "UKK": "KZ",
  "UKN": "US",
  "UKR": "YE",
  "UKS": "UA",
  "UKT": "US",
  "UKU": "PG",
  "UKX": "RU",
  "ULA": "AR",
  "ULB": "VU",
  "ULC": "CL",
  "ULD": "ZA",
  "ULE": "PG",
  "ULG": "MN",
  "ULH": "SA",
  "ULK": "RU",
  "ULL": "GB",
  "ULM": "US",
  "ULN": "MN",
  "ULO": "MN",
  "ULP": "AU",
  "ULU": "UG",
  "ULV": "RU",
  "ULX": "ZA",
  "ULY": "RU",
  "UMA": "CU",
  "UMC": "PG",
  "UMD": "GL",
  "UME": "SE",
  "UMI": "PE",
  "UMM": "US",
  "UMR": "AU",
  "UMT": "US",
  "UMU": "BR",
  "UMY": "UA",
  "UNA": "BR",
  "UNC": "CO",
  "UND": "AF",
  "UNE": "LS",
  "UNG": "PG",
  "UNI": "VC",
  "UNK": "US",
  "UNN": "TH",
  "UNR": "MN",
  "UNT": "GB",
  "UNU": "US",
  "UOL": "ID",
  "UOS": "US",
  "UOX": "US",
  "UPB": "CU",
  "UPG": "ID",
  "UPK": "GL",
  "UPL": "CR",
  "UPN": "MX",
  "UPP": "US",
  "UPR": "PG",
  "UPV": "GB",
  "URA": "KZ",
  "URB": "BR",
  "URC": "CN",
  "URE": "EE",
  "URG": "BR",
  "URI": "CO",
  "URJ": "RU",
  "URM": "VE",
  "URN": "AF",
  "URO": "FR",
  "URS": "RU",
  "URT": "TH",
  "URU": "PG",
  "URY": "SA",
  "URZ": "AF",
  "USH": "AR",
  "USI": "GY",
  "USK": "RU",
  "USL": "AU",
  "USM": "TH",
  "USN": "KR",
  "USO": "PG",
  "USS": "CU",
  "UST": "US",
  "USU": "PH",
  "UTA": "ZW",
  "UTB": "AU",
  "UTC": "NL",
  "UTD": "AU",
  "UTG": "LS",
  "UTH": "TH",
  "UTI": "FI",
  "UTK": "MH",
  "UTN": "ZA",
  "UTO": "US",
  "UTP": "TH",
  "UTR": "TH",
  "UTS": "RU",
  "UTT": "ZA",
  "UTU": "PA",
  "UTW": "ZA",
  "UUA": "RU",
  "UUD": "RU",
  "UUK": "US",
  "UUN": "MN",
  "UUS": "RU",
  "UUU": "PG",
  "UVA": "US",
  "UVE": "NC",
  "UVF": "LC",
  "UVL": "EG",
  "UVO": "PG",
  "UWA": "US",
  "UYL": "SD",
  "UYN": "CN",
  "UYU": "BO",
  "UZC": "RS",
  "UZU": "AR",
  "VAA": "FI",
  "VAC": "DE",
  "VAD": "US",
  "VAF": "FR",
  "VAG": "BR",
  "VAH": "BO",
  "VAI": "PG",
  "VAK": "US",
  "VAL": "BR",
  "VAM": "MV",
  "VAN": "TR",
  "VAO": "SB",
  "VAP": "CL",
  "VAR": "BG",
  "VAS": "TR",
  "VAT": "MG",
  "VAU": "FJ",
  "VAV": "TO",
  "VAW": "NO",
  "VBG": "US",
  "VBV": "FJ",
  "VBY": "SE",
  "VCA": "VN",
  "VCD": "AU",
  "VCE": "IT",
  "VCF": "AR",
  "VCH": "UY",
  "VCL": "VN",
  "VCP": "BR",
  "VCR": "VE",
  "VCS": "VN",
  "VCT": "US",
  "VCV": "US",
  "VDA": "IL",
  "VDB": "NO",
  "VDC": "BR",
  "VDE": "ES",
  "VDH": "VN",
  "VDI": "US",
  "VDM": "AR",
  "VDR": "AR",
  "VDS": "NO",
  "VDY": "IN",
  "VDZ": "US",
  "VEE": "US",
  "VEL": "US",
  "VER": "MX",
  "VEV": "SB",
  "VEX": "US",
  "VEY": "IS",
  "VFA": "ZW",
  "VGA": "IN",
  "VGD": "RU",
  "VGO": "ES",
  "VGS": "AR",
  "VGT": "US",
  "VGZ": "CO",
  "VHC": "AO",
  "VHM": "SE",
  "VHN": "US",
  "VHY": "FR",
  "VHZ": "PF",
  "VIA": "BR",
  "VIB": "MX",
  "VID": "BG",
  "VIE": "AT",
  "VIG": "VE",
  "VIH": "US",
  "VII": "VN",
  "VIJ": "VG",
  "VIL": "EH",
  "VIN": "UA",
  "VIQ": "TL",
  "VIR": "ZA",
  "VIS": "US",
  "VIT": "ES",
  "VIU": "SB",
  "VIV": "PG",
  "VIX": "BR",
  "VIY": "FR",
  "VJB": "MZ",
  "VJI": "US",
  "VJQ": "MZ",
  "VKG": "VN",
  "VKO": "RU",
  "VKS": "US",
  "VKT": "RU",
  "VLA": "US",
  "VLC": "ES",
  "VLD": "US",
  "VLE": "US",
  "VLG": "AR",
  "VLI": "VU",
  "VLK": "RU",
  "VLL": "ES",
  "VLM": "BO",
  "VLN": "VE",
  "VLP": "BR",
  "VLR": "CL",
  "VLS": "VU",
  "VLU": "RU",
  "VLV": "VE",
  "VMI": "PY",
  "VMU": "PG",
  "VNA": "LA",
  "VNC": "US",
  "VND": "MG",
  "VNE": "FR",
  "VNO": "LT",
  "VNR": "AU",
  "VNS": "IN",
  "VNT": "LV",
  "VNX": "MZ",
  "VNY": "US",
  "VOD": "CZ",
  "VOG": "RU",
  "VOH": "MG",
  "VOI": "LR",
  "VOK": "US",
  "VOL": "GR",
  "VOT": "BR",
  "VOZ": "RU",
  "VPE": "AO",
  "VPG": "KE",
  "VPN": "IS",
  "VPS": "US",
  "VPY": "MZ",
  "VPZ": "US",
  "VQS": "PR",
  "VRA": "CU",
  "VRB": "US",
  "VRC": "PH",
  "VRE": "ZA",
  "VRK": "FI",
  "VRL": "PT",
  "VRN": "IT",
  "VRO": "CU",
  "VRS": "US",
  "VRU": "ZA",
  "VRY": "NO",
  "VSA": "MX",
  "VSE": "PT",
  "VSF": "US",
  "VSG": "UA",
  "VSK": "US",
  "VST": "SE",
  "VTE": "LA",
  "VTF": "FJ",
  "VTG": "VN",
  "VTL": "FR",
  "VTM": "IL",
  "VTN": "US",
  "VTU": "CU",
  "VTZ": "IN",
  "VUP": "CO",
  "VUS": "RU",
  "VUU": "MW",
  "VVB": "MG",
  "VVC": "CO",
  "VVI": "BO",
  "VVK": "SE",
  "VVO": "RU",
  "VVZ": "DZ",
  "VXC": "MZ",
  "VXE": "CV",
  "VXO": "SE",
  "VYD": "ZA",
  "VYS": "US",
  "WAA": "US",
  "WAC": "ET",
  "WAD": "MG",
  "WAE": "SA",
  "WAF": "PK",
  "WAG": "NZ",
  "WAH": "US",
  "WAI": "MG",
  "WAJ": "PG",
  "WAK": "MG",
  "WAL": "US",
  "WAM": "MG",
  "WAN": "AU",
  "WAO": "PG",
  "WAP": "CL",
  "WAQ": "MG",
  "WAR": "ID",
  "WAT": "IE",
  "WAV": "AU",
  "WAW": "PL",
  "WAX": "LY",
  "WAY": "US",
  "WAZ": "AU",
  "WBA": "AU",
  "WBB": "US",
  "WBC": "PG",
  "WBD": "MG",
  "WBM": "PG",
  "WBQ": "US",
  "WBR": "US",
  "WBU": "US",
  "WBW": "US",
  "WCA": "CL",
  "WCH": "CL",
  "WCR": "US",
  "WDA": "YE",
  "WDG": "US",
  "WDH": "NA",
  "WDI": "AU",
  "WDN": "US",
  "WDR": "US",
  "WEA": "US",
  "WED": "PG",
  "WEF": "CN",
  "WEH": "CN",
  "WEI": "AU",
  "WEL": "ZA",
  "WEM": "GB",
  "WEP": "PG",
  "WET": "ID",
  "WEW": "AU",
  "WEX": "IE",
  "WFB": "US",
  "WFI": "MG",
  "WFK": "US",
  "WGA": "AU",
  "WGB": "PK",
  "WGC": "IN",
  "WGE": "AU",
  "WGO": "US",
  "WGP": "ID",
  "WGT": "AU",
  "WGU": "PG",
  "WGY": "GA",
  "WHD": "US",
  "WHF": "SD",
  "WHK": "NZ",
  "WHL": "AU",
  "WHO": "NZ",
  "WHP": "US",
  "WHS": "GB",
  "WHT": "US",
  "WHU": "CN",
  "WIB": "US",
  "WIC": "GB",
  "WID": "DE",
  "WIK": "NZ",
  "WIL": "KE",
  "WIN": "AU",
  "WIO": "AU",
  "WIR": "NZ",
  "WIU": "PG",
  "WJA": "MH",
  "WJF": "US",
  "WJR": "KE",
  "WJU": "KR",
  "WKA": "NZ",
  "WKB": "AU",
  "WKF": "ZA",
  "WKI": "ZW",
  "WKJ": "JP",
  "WKK": "US",
  "WKL": "US",
  "WKN": "PG",
  "WKR": "BS",
  "WLA": "AU",
  "WLC": "AU",
  "WLD": "US",
  "WLG": "NZ",
  "WLH": "VU",
  "WLK": "US",
  "WLL": "AU",
  "WLR": "US",
  "WLS": "WF",
  "WLW": "US",
  "WMA": "MG",
  "WMB": "AU",
  "WMC": "US",
  "WMD": "MG",
  "WME": "AU",
  "WMH": "US",
  "WMI": "PL",
  "WMK": "US",
  "WML": "MG",
  "WMN": "MG",
  "WMO": "US",
  "WMP": "MG",
  "WMR": "MG",
  "WMX": "ID",
  "WNA": "US",
  "WND": "AU",
  "WNP": "PH",
  "WNR": "AU",
  "WNU": "PG",
  "WNZ": "CN",
  "WOA": "PG",
  "WOE": "NL",
  "WOK": "VE",
  "WOL": "AU",
  "WON": "AU",
  "WOS": "KP",
  "WOT": "TW",
  "WOW": "US",
  "WPA": "CL",
  "WPB": "MG",
  "WPC": "CA",
  "WPK": "AU",
  "WPL": "CA",
  "WPM": "PG",
  "WPO": "US",
  "WPR": "CL",
  "WPU": "CL",
  "WRA": "ET",
  "WRB": "US",
  "WRE": "NZ",
  "WRG": "US",
  "WRI": "US",
  "WRL": "US",
  "WRO": "PL",
  "WRW": "AU",
  "WRY": "GB",
  "WSA": "PG",
  "WSB": "US",
  "WSD": "US",
  "WSG": "US",
  "WSH": "US",
  "WSM": "US",
  "WSN": "US",
  "WSO": "SR",
  "WSP": "NI",
  "WSR": "ID",
  "WST": "US",
  "WSU": "PG",
  "WSX": "US",
  "WSY": "AU",
  "WSZ": "NZ",
  "WTA": "MG",
  "WTD": "BS",
  "WTE": "MH",
  "WTK": "US",
  "WTL": "US",
  "WTN": "GB",
  "WTO": "MH",
  "WTP": "PG",
  "WTR": "US",
  "WTS": "MG",
  "WTT": "PG",
  "WTZ": "NZ",
  "WUA": "CN",
  "WUD": "AU",
  "WUG": "PG",
  "WUH": "CN",
  "WUN": "AU",
  "WUS": "CN",
  "WUU": "SS",
  "WUV": "PG",
  "WUX": "CN",
  "WVB": "NA",
  "WVI": "US",
  "WVK": "MG",
  "WVL": "US",
  "WVN": "DE",
  "WWA": "US",
  "WWD": "US",
  "WWI": "AU",
  "WWK": "PG",
  "WWP": "US",
  "WWR": "US",
  "WWT": "US",
  "WWY": "AU",
  "WXF": "GB",
  "WXN": "CN",
  "WYA": "AU",
  "WYB": "US",
  "WYE": "SL",
  "WYN": "AU",
  "WYS": "US",
  "XAB": "FR",
  "XAC": "FR",
  "XAL": "MX",
  "XAN": "FR",
  "XAP": "BR",
  "XAR": "BF",
  "XAS": "FR",
  "XAU": "GF",
  "XBB": "CA",
  "XBE": "CA",
  "XBG": "BF",
  "XBJ": "IR",
  "XBN": "PG",
  "XBO": "BF",
  "XBQ": "FR",
  "XBR": "CA",
  "XBV": "FR",
  "XBX": "FR",
  "XCB": "FR",
  "XCH": "CX",
  "XCL": "CA",
  "XCM": "CA",
  "XCO": "AU",
  "XCP": "FR",
  "XCR": "FR",
  "XCX": "FR",
  "XCZ": "FR",
  "XDA": "FR",
  "XDE": "BF",
  "XDJ": "BF",
  "XDK": "FR",
  "XEN": "CN",
  "XES": "US",
  "XFN": "CN",
  "XFW": "DE",
  "XGA": "BF",
  "XGG": "BF",
  "XGR": "CA",
  "XGT": "FR",
  "XIC": "CN",
  "XIE": "LA",
  "XIJ": "KW",
  "XIL": "CN",
  "XIQ": "GL",
  "XIY": "CN",
  "XJD": "QA",
  "XJM": "PK",
  "XKA": "BF",
  "XKH": "LA",
  "XKS": "CA",
  "XKY": "BF",
  "XLB": "CA",
  "XLN": "FR",
  "XLO": "VN",
  "XLR": "FR",
  "XLS": "SN",
  "XLU": "BF",
  "XLW": "DE",
  "XMA": "PH",
  "XMC": "AU",
  "XMD": "US",
  "XME": "FR",
  "XMF": "FR",
  "XMG": "NP",
  "XMH": "PF",
  "XMI": "TZ",
  "XMJ": "FR",
  "XMK": "FR",
  "XML": "AU",
  "XMN": "CN",
  "XMP": "CA",
  "XMS": "EC",
  "XMW": "FR",
  "XMY": "AU",
  "XNA": "US",
  "XNG": "VN",
  "XNN": "CN",
  "XNT": "CN",
  "XNU": "BF",
  "XOG": "FR",
  "XPA": "BF",
  "XPK": "CA",
  "XPP": "CA",
  "XPR": "US",
  "XQP": "CR",
  "XQU": "CA",
  "XRH": "AU",
  "XRR": "CA",
  "XRY": "ES",
  "XSC": "TC",
  "XSD": "US",
  "XSE": "BF",
  "XSI": "CA",
  "XSJ": "FR",
  "XSL": "FR",
  "XSO": "PH",
  "XSP": "SG",
  "XSU": "FR",
  "XTB": "FR",
  "XTG": "AU",
  "XTL": "CA",
  "XTO": "AU",
  "XTR": "AU",
  "XUZ": "CN",
  "XVL": "VN",
  "XVN": "FR",
  "XVO": "FR",
  "XVS": "FR",
  "XWP": "SE",
  "XXN": "SA",
  "XYA": "SB",
  "XYE": "MM",
  "XYR": "PG",
  "XZA": "BF",
  "YAA": "CA",
  "YAB": "CA",
  "YAC": "CA",
  "YAD": "CA",
  "YAG": "CA",
  "YAH": "CA",
  "YAI": "CL",
  "YAJ": "CA",
  "YAK": "US",
  "YAL": "CA",
  "YAM": "CA",
  "YAN": "CD",
  "YAO": "CM",
  "YAP": "FM",
  "YAQ": "CA",
  "YAR": "CA",
  "YAT": "CA",
  "YAU": "CA",
  "YAW": "CA",
  "YAY": "CA",
  "YBA": "CA",
  "YBB": "CA",
  "YBC": "CA",
  "YBE": "CA",
  "YBF": "CA",
  "YBG": "CA",
  "YBH": "CA",
  "YBI": "CA",
  "YBJ": "CA",
  "YBK": "CA",
  "YBL": "CA",
  "YBM": "CA",
  "YBN": "CA",
  "YBO": "CA",
  "YBP": "CN",
  "YBQ": "CA",
  "YBR": "CA",
  "YBS": "CA",
  "YBT": "CA",
  "YBV": "CA",
  "YBW": "CA",
  "YBX": "CA",
  "YBY": "CA",
  "YCA": "CA",
  "YCB": "CA",
  "YCC": "CA",
  "YCD": "CA",
  "YCF": "CA",
  "YCG": "CA",
  "YCH": "CA",
  "YCK": "CA",
  "YCL": "CA",
  "YCM": "CA",
  "YCN": "CA",
  "YCO": "CA",
  "YCQ": "CA",
  "YCR": "CA",
  "YCS": "CA",
  "YCT": "CA",
  "YCU": "CN",
  "YCV": "CA",
  "YCW": "CA",
  "YCY": "CA",
  "YCZ": "CA",
  "YDA": "CA",
  "YDB": "CA",
  "YDC": "CA",
  "YDE": "CA",
  "YDF": "CA",
  "YDG": "CA",
  "YDJ": "CA",
  "YDL": "CA",
  "YDN": "CA",
  "YDO": "CA",
  "YDP": "CA",
  "YDQ": "CA",
  "YDV": "CA",
  "YDW": "CA",
  "YEB": "CA",
  "YEC": "KR",
  "YEG": "CA",
  "YEI": "TR",
  "YEK": "CA",
  "YEL": "CA",
  "YEM": "CA",
  "YEN": "CA",
  "YEQ": "PG",
  "YER": "CA",
  "YET": "CA",
  "YEU": "CA",
  "YEV": "CA",
  "YEY": "CA",
  "YFA": "CA",
  "YFB": "CA",
  "YFC": "CA",
  "YFE": "CA",
  "YFG": "CA",
  "YFH": "CA",
  "YFI": "CA",
  "YFJ": "CA",
  "YFL": "CA",
  "YFO": "CA",
  "YFR": "CA",
  "YFS": "CA",
  "YFX": "CA",
  "YGA": "CA",
  "YGB": "CA",
  "YGC": "CA",
  "YGE": "CA",
  "YGG": "CA",
  "YGH": "CA",
  "YGJ": "JP",
  "YGK": "CA",
  "YGL": "CA",
  "YGM": "CA",
  "YGN": "CA",
  "YGO": "CA",
  "YGP": "CA",
  "YGQ": "CA",
  "YGR": "CA",
  "YGT": "CA",
  "YGV": "CA",
  "YGW": "CA",
  "YGX": "CA",
  "YGZ": "CA",
  "YHA": "CA",
  "YHB": "CA",
  "YHD": "CA",
  "YHE": "CA",
  "YHF": "CA",
  "YHI": "CA",
  "YHK": "CA",
  "YHM": "CA",
  "YHN": "CA",
  "YHO": "CA",
  "YHP": "CA",
  "YHR": "CA",
  "YHS": "CA",
  "YHT": "CA",
  "YHU": "CA",
  "YHY": "CA",
  "YHZ": "CA",
  "YIB": "CA",
  "YIF": "CA",
  "YIG": "CA",
  "YIH": "CN",
  "YIK": "CA",
  "YIN": "CN",
  "YIO": "CA",
  "YIP": "US",
  "YIV": "CA",
  "YIW": "CN",
  "YJF": "CA",
  "YJN": "CA",
  "YJP": "CA",
  "YJS": "KP",
  "YJT": "CA",
  "YKA": "CA",
  "YKC": "CA",
  "YKD": "CA",
  "YKE": "CA",
  "YKF": "CA",
  "YKG": "CA",
  "YKJ": "CA",
  "YKK": "CA",
  "YKL": "CA",
  "YKM": "US",
  "YKN": "US",
  "YKQ": "CA",
  "YKS": "RU",
  "YKT": "CA",
  "YKU": "CA",
  "YKX": "CA",
  "YKY": "CA",
  "YKZ": "CA",
  "YLB": "CA",
  "YLC": "CA",
  "YLD": "CA",
  "YLE": "CA",
  "YLG": "AU",
  "YLH": "CA",
  "YLJ": "CA",
  "YLK": "CA",
  "YLL": "CA",
  "YLM": "CA",
  "YLP": "CA",
  "YLQ": "CA",
  "YLR": "CA",
  "YLS": "CA",
  "YLT": "CA",
  "YLW": "CA",
  "YLY": "CA",
  "YMA": "CA",
  "YMB": "CA",
  "YMD": "CA",
  "YME": "CA",
  "YMG": "CA",
  "YMH": "CA",
  "YMJ": "CA",
  "YMK": "RU",
  "YML": "CA",
  "YMM": "CA",
  "YMN": "CA",
  "YMO": "CA",
  "YMP": "CA",
  "YMS": "PE",
  "YMT": "CA",
  "YMU": "CA",
  "YMV": "CA",
  "YMW": "CA",
  "YMX": "CA",
  "YNA": "CA",
  "YNB": "SA",
  "YNC": "CA",
  "YND": "CA",
  "YNE": "CA",
  "YNG": "US",
  "YNH": "CA",
  "YNJ": "CN",
  "YNL": "CA",
  "YNM": "CA",
  "YNN": "AU",
  "YNO": "CA",
  "YNS": "CA",
  "YNT": "CN",
  "YNX": "CA",
  "YNY": "KR",
  "YNZ": "CN",
  "YOA": "CA",
  "YOC": "CA",
  "YOD": "CA",
  "YOE": "CA",
  "YOG": "CA",
  "YOH": "CA",
  "YOI": "CA",
  "YOJ": "CA",
  "YOL": "NG",
  "YOS": "CA",
  "YOW": "CA",
  "YOY": "CA",
  "YPA": "CA",
  "YPB": "CA",
  "YPC": "CA",
  "YPD": "CA",
  "YPE": "CA",
  "YPG": "CA",
  "YPH": "CA",
  "YPI": "CA",
  "YPJ": "CA",
  "YPL": "CA",
  "YPM": "CA",
  "YPN": "CA",
  "YPO": "CA",
  "YPQ": "CA",
  "YPR": "CA",
  "YPS": "CA",
  "YPT": "CA",
  "YPW": "CA",
  "YPX": "CA",
  "YPY": "CA",
  "YPZ": "CA",
  "YQA": "CA",
  "YQB": "CA",
  "YQC": "CA",
  "YQD": "CA",
  "YQF": "CA",
  "YQG": "CA",
  "YQH": "CA",
  "YQI": "CA",
  "YQK": "CA",
  "YQL": "CA",
  "YQM": "CA",
  "YQN": "CA",
  "YQQ": "CA",
  "YQR": "CA",
  "YQS": "CA",
  "YQT": "CA",
  "YQU": "CA",
  "YQV": "CA",
  "YQW": "CA",
  "YQX": "CA",
  "YQY": "CA",
  "YQZ": "CA",
  "YRA": "CA",
  "YRB": "CA",
  "YRC": "CA",
  "YRD": "CA",
  "YRF": "CA",
  "YRG": "CA",
  "YRI": "CA",
  "YRJ": "CA",
  "YRL": "CA",
  "YRM": "CA",
  "YRN": "CA",
  "YRO": "CA",
  "YRQ": "CA",
  "YRR": "CA",
  "YRS": "CA",
  "YRT": "CA",
  "YRV": "CA",
  "YSA": "CA",
  "YSB": "CA",
  "YSC": "CA",
  "YSD": "CA",
  "YSE": "CA",
  "YSF": "CA",
  "YSG": "CA",
  "YSH": "CA",
  "YSI": "CA",
  "YSJ": "CA",
  "YSK": "CA",
  "YSL": "CA",
  "YSM": "CA",
  "YSN": "CA",
  "YSO": "CA",
  "YSP": "CA",
  "YST": "CA",
  "YSU": "CA",
  "YSV": "CA",
  "YSX": "CA",
  "YSY": "CA",
  "YTA": "CA",
  "YTB": "CA",
  "YTD": "CA",
  "YTE": "CA",
  "YTF": "CA",
  "YTG": "CA",
  "YTH": "CA",
  "YTJ": "CA",
  "YTL": "CA",
  "YTM": "CA",
  "YTP": "CA",
  "YTQ": "CA",
  "YTR": "CA",
  "YTS": "CA",
  "YTT": "CA",
  "YTU": "CA",
  "YTX": "CA",
  "YTZ": "CA",
  "YUA": "CN",
  "YUB": "CA",
  "YUD": "CA",
  "YUE": "AU",
  "YUL": "CA",
  "YUM": "US",
  "YUS": "CN",
  "YUT": "CA",
  "YUX": "CA",
  "YUY": "CA",
  "YVA": "KM",
  "YVB": "CA",
  "YVC": "CA",
  "YVE": "CA",
  "YVG": "CA",
  "YVM": "CA",
  "YVO": "CA",
  "YVP": "CA",
  "YVQ": "CA",
  "YVR": "CA",
  "YVT": "CA",
  "YVV": "CA",
  "YWA": "CA",
  "YWB": "CA",
  "YWG": "CA",
  "YWH": "CA",
  "YWJ": "CA",
  "YWK": "CA",
  "YWL": "CA",
  "YWM": "CA",
  "YWN": "CA",
  "YWO": "CA",
  "YWP": "CA",
  "YWQ": "CA",
  "YWR": "CA",
  "YWS": "CA",
  "YWY": "CA",
  "YXC": "CA",
  "YXE": "CA",
  "YXH": "CA",
  "YXI": "CA",
  "YXJ": "CA",
  "YXK": "CA",
  "YXL": "CA",
  "YXN": "CA",
  "YXP": "CA",
  "YXQ": "CA",
  "YXR": "CA",
  "YXS": "CA",
  "YXT": "CA",
  "YXU": "CA",
  "YXX": "CA",
  "YXY": "CA",
  "YXZ": "CA",
  "YYB": "CA",
  "YYC": "CA",
  "YYD": "CA",
  "YYE": "CA",
  "YYF": "CA",
  "YYH": "CA",
  "YYI": "CA",
  "YYJ": "CA",
  "YYL": "CA",
  "YYM": "CA",
  "YYN": "CA",
  "YYQ": "CA",
  "YYR": "CA",
  "YYT": "CA",
  "YYU": "CA",
  "YYW": "CA",
  "YYY": "CA",
  "YYZ": "CA",
  "YZA": "CA",
  "YZD": "CA",
  "YZE": "CA",
  "YZF": "CA",
  "YZG": "CA",
  "YZH": "CA",
  "YZP": "CA",
  "YZR": "CA",
  "YZS": "CA",
  "YZT": "CA",
  "YZU": "CA",
  "YZV": "CA",
  "YZW": "CA",
  "YZX": "CA",
  "YZY": "CN",
  "YZZ": "CA",
  "ZAA": "CA",
  "ZAC": "CA",
  "ZAD": "HR",
  "ZAG": "HR",
  "ZAH": "IR",
  "ZAJ": "AF",
  "ZAL": "CL",
  "ZAM": "PH",
  "ZAO": "FR",
  "ZAR": "NG",
  "ZAT": "CN",
  "ZAZ": "ES",
  "ZBE": "CZ",
  "ZBF": "CA",
  "ZBK": "ME",
  "ZBL": "AU",
  "ZBO": "AU",
  "ZBR": "IR",
  "ZBY": "LA",
  "ZCD": "DE",
  "ZCL": "MX",
  "ZCO": "CL",
  "ZEC": "ZA",
  "ZEG": "ID",
  "ZEL": "CA",
  "ZEM": "CA",
  "ZEN": "PG",
  "ZER": "IN",
  "ZFA": "CA",
  "ZFD": "CA",
  "ZFM": "CA",
  "ZFN": "CA",
  "ZFU": "BR",
  "ZFW": "CA",
  "ZGC": "CN",
  "ZGF": "CA",
  "ZGI": "CA",
  "ZGL": "AU",
  "ZGM": "ZM",
  "ZGR": "CA",
  "ZGS": "CA",
  "ZGU": "VU",
  "ZHA": "CN",
  "ZHM": "BD",
  "ZHP": "CA",
  "ZHY": "CN",
  "ZIA": "RU",
  "ZIC": "CL",
  "ZIG": "SN",
  "ZIH": "MX",
  "ZIZ": "PK",
  "ZJG": "CA",
  "ZJI": "CH",
  "ZJN": "CA",
  "ZKB": "ZM",
  "ZKE": "CA",
  "ZKG": "CA",
  "ZKM": "GA",
  "ZKP": "ZM",
  "ZLG": "MR",
  "ZLO": "MX",
  "ZLR": "CL",
  "ZLT": "CA",
  "ZMD": "BR",
  "ZMH": "CA",
  "ZMM": "MX",
  "ZMT": "CA",
  "ZNA": "CA",
  "ZNC": "US",
  "ZND": "NE",
  "ZNE": "AU",
  "ZNZ": "TZ",
  "ZOF": "CA",
  "ZOS": "CL",
  "ZOW": "DE",
  "ZPB": "CA",
  "ZPC": "CL",
  "ZPH": "US",
  "ZPO": "CA",
  "ZQL": "DE",
  "ZQN": "NZ",
  "ZQW": "DE",
  "ZRH": "CH",
  "ZRI": "ID",
  "ZRJ": "CA",
  "ZRM": "ID",
  "ZSA": "BS",
  "ZSE": "RE",
  "ZSJ": "CA",
  "ZSP": "CA",
  "ZSS": "CI",
  "ZST": "CA",
  "ZSW": "CA",
  "ZTA": "PF",
  "ZTB": "CA",
  "ZTH": "GR",
  "ZTM": "CA",
  "ZTR": "UA",
  "ZTS": "CA",
  "ZTU": "AZ",
  "ZUC": "CA",
  "ZUH": "CN",
  "ZUM": "CA",
  "ZVA": "MG",
  "ZVK": "LA",
  "ZWA": "MG",
  "ZWL": "CA",
  "ZXT": "AZ",
  "ZYI": "CN",
  "ZYL": "BD",
  "ZZO": "RU",
  "ZZU": "MW",
  "ZZV": "US",
};

export default AIRPORT_COUNTRIES;
